export default class MapData {
    static map_data = {"title":"United Republic of Tanzania",
        "version":"1.1.3",
        "type":"FeatureCollection",
        "copyright":"Copyright (c) 2020 Highsoft AS, Based on data from Natural Earth",
        "copyrightShort":"Natural Earth",
        "copyrightUrl":"http://www.naturalearthdata.com",
        "crs":{"type":"name","properties":{"name":"urn:ogc:def:crs:EPSG:32736"}},
        "hc-transform":
            {"default":
                    {
                        "crs":"+proj=utm +zone=36 +south +datum=WGS84 +units=m +no_defs",
                        "scale":0.000585452333834,
                        "jsonres":15.5,
                        "jsonmarginX":-999,
                        "jsonmarginY":9851.0,
                        "xoffset":122058.492634,
                        "yoffset":9890953.44299
                    }
                    },

"features":[
    {"type":"Feature",
        "id":"TZ.MW",
        "properties":{
        "hc-group":"admin1",
            "hc-middle-x":0.71,
            "hc-middle-y":0.68,
            "hc-key":"tz-mw",
            "hc-a2":"MW",
            "labelrank":"7",
            "hasc":"TZ.MW",
            "alt-name":null,
            "woe-id":"2347363",
            "subregion":null,
            "fips":"TZ12",
            "postal-code":"MW",
            "name":"Mwanza",
            "country":"United Republic of Tanzania",
            "type-en":"Region",
            "region":null,
            "longitude":"32.6685",
            "woe-name":"Mwanza",
            "latitude":"-2.67284",
            "woe-label":"Mwanza, TZ, Tanzania",
            "type":"Mkoa"
        },
        "geometry":{"type":"MultiPolygon","coordinates":[[[[1864,8556],[1928,8513],[1959,8550],[1946,8450],[1867,8417],[1833,8491],[1864,8556]]],[[[1468,8586],[1472,8492],[1399,8466],[1407,8524],[1372,8556],[1468,8586]]],[[[2529,9027],[2468,8940],[2428,8976],[2447,9035],[2529,9027]]],[[[2760,8704],[2744,8712],[2728,8718],[2744,8712],[2760,8704]]],[[[2642,8712],[2640,8719],[2641,8726],[2640,8719],[2642,8712]]],[[[2642,8730],[2650,8744],[2654,8754],[2650,8744],[2642,8730]]],[[[2653,8765],[2652,8772],[2651,8776],[2652,8772],[2653,8765]]],[[[2647,8781],[2647,8781],[2647,8781],[2647,8781]]],[[[2689,8787],[2689,8788],[2689,8787],[2689,8787]]],[[[2689,8788],[2714,8782],[2719,8778],[2714,8782],[2689,8788]]],[[[2814,8781],[2817,8788],[2820,8791],[2817,8788],[2814,8781]]],[[[2649,8785],[2651,8792],[2654,8793],[2652,8792],[2649,8785]]],[[[2826,8793],[2834,8795],[2834,8795],[2826,8793]]],[[[2745,8801],[2751,8789],[2758,8789],[2751,8788],[2745,8801]]],[[[2990,8813],[2993,8820],[3000,8828],[2993,8819],[2990,8813]]],[[[3007,8841],[3009,8847],[3004,8853],[3009,8847],[3007,8841]]],[[[2973,8864],[2972,8864],[2975,8866],[2973,8864]]],[[[2978,8868],[2980,8871],[2980,8871],[2978,8868]]],[[[2908,8884],[2897,8885],[2897,8885],[2908,8884]]],[[[2748,8890],[2748,8890],[2742,8894],[2748,8890]]],[[[2739,8927],[2744,8929],[2744,8937],[2744,8929],[2739,8927]]],[[[2897,8953],[2893,8954],[2897,8953],[2897,8953]]],[[[2747,8955],[2753,8965],[2753,8965],[2747,8955]]],[[[2655,8792],[2661,8789],[2685,8787],[2661,8788],[2655,8792]]],[[[2703,8823],[2715,8834],[2742,8806],[2715,8834],[2703,8823]]],[[[2806,8836],[2834,8862],[2932,8809],[2983,8807],[2932,8809],[2834,8862],[2806,8836]]],[[[2802,8791],[2774,8815],[2758,8818],[2774,8816],[2802,8791]]],[[[2427,8735],[2359,8742],[2280,8793],[2329,8857],[2281,8891],[2341,8938],[2366,8898],[2423,8843],[2537,8868],[2532,8791],[2618,8718],[2606,8665],[2510,8712],[2487,8694],[2427,8735]]],[[[1586,8312],[1590,8336],[1490,8408],[1500,8466],[1583,8445],[1645,8512],[1651,8581],[1734,8562],[1745,8479],[1796,8401],[1859,8376],[1980,8366],[1928,8287],[1976,8294],[2052,8366],[2087,8453],[2163,8300],[2243,8345],[2240,8164],[2303,8103],[2277,8008],[2154,7969],[2226,7922],[2177,7862],[2192,7819],[2233,7861],[2270,7981],[2321,8010],[2422,7954],[2441,7986],[2357,8012],[2385,8046],[2309,8128],[2339,8153],[2295,8231],[2330,8279],[2302,8338],[2357,8424],[2430,8453],[2551,8433],[2579,8370],[2654,8315],[2744,8328],[2862,8280],[2896,8331],[2851,8366],[2950,8384],[3109,8220],[3201,8171],[3225,8125],[3202,8077],[3125,8041],[3056,8061],[2933,7971],[2965,7859],[2907,7652],[2857,7557],[2802,7524],[2646,7503],[2608,7429],[2541,7398],[2394,7468],[2292,7576],[2203,7567],[2168,7523],[2109,7511],[2088,7445],[2115,7382],[2077,7384],[1961,7459],[1968,7566],[1937,7633],[2024,7871],[1936,7945],[1961,8021],[1785,8122],[1839,8224],[1669,8252],[1586,8312]]]]}},{"type":"Feature","id":"TZ.KR","properties":{"hc-group":"admin1","hc-middle-x":0.55,"hc-middle-y":0.24,"hc-key":"tz-kr","hc-a2":"KR","labelrank":"5","hasc":"TZ.KR","alt-name":null,"woe-id":"2347370","subregion":null,"fips":"TZ19","postal-code":"KR","name":"Kagera","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"31.2578","woe-name":"Kagera","latitude":"-1.77904","woe-label":"Kagera, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"MultiPolygon","coordinates":[[[[1340,9207],[1278,9090],[1292,9182],[1278,9214],[1340,9207]]],[[[395,7992],[296,7902],[231,7839],[48,7855],[-44,7929],[-98,7888],[-176,7977],[-142,8088],[-69,8181],[-150,8149],[-177,8184],[-130,8243],[-84,8367],[-18,8442],[47,8434],[84,8480],[169,8450],[245,8486],[255,8594],[299,8750],[227,8814],[237,8899],[207,8904],[248,8997],[234,9103],[241,9240],[201,9244],[142,9358],[146,9429],[40,9468],[-38,9517],[-83,9665],[-129,9687],[-142,9739],[-82,9763],[46,9763],[95,9812],[186,9851],[238,9834],[1202,9835],[1200,9782],[1244,9835],[1294,9813],[1264,9778],[1290,9687],[1271,9558],[1240,9489],[1216,9352],[1174,9370],[1160,9269],[1180,9239],[1139,9159],[1092,8939],[1036,8860],[1029,8795],[1126,8829],[1105,8774],[1112,8692],[1052,8517],[1052,8477],[982,8479],[780,8567],[581,8553],[432,8298],[322,8245],[287,8146],[383,8055],[395,7992]]]]}},{"type":"Feature","id":"TZ.PW","properties":{"hc-group":"admin1","hc-middle-x":0.40,"hc-middle-y":0.68,"hc-key":"tz-pw","hc-a2":"PW","labelrank":"5","hasc":"TZ.PW","alt-name":null,"woe-id":"2347353","subregion":null,"fips":"TZ02","postal-code":"PW","name":"Pwani","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"39.7491","woe-name":"Pwani","latitude":"-7.86726","woe-label":"Pwani, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"MultiPolygon","coordinates":[[[[9194,2694],[9141,2686],[9188,2766],[9248,2753],[9194,2694]]],[[[9141,2892],[9164,2951],[9296,3024],[9349,3124],[9344,3006],[9271,2846],[9202,2846],[9172,2788],[9095,2768],[9033,2818],[9141,2892]]],[[[8266,4829],[8243,4761],[8283,4654],[8321,4626],[8304,4521],[8314,4439],[8384,4341],[8488,4298],[8503,4314],[8589,4224],[8545,4182],[8507,4045],[8476,3995],[8513,3982],[8562,3868],[8482,3747],[8534,3723],[8592,3776],[8625,3762],[8704,3824],[8816,3816],[8866,3747],[8865,3604],[8891,3591],[8869,3532],[8781,3464],[8807,3423],[8755,3324],[8724,3175],[8751,2978],[8775,3043],[8787,2987],[8842,2988],[8890,2934],[8866,2865],[8898,2755],[8788,2543],[8766,2469],[8723,2446],[8671,2482],[8425,2441],[8237,2389],[8192,2416],[8121,2402],[8073,2305],[7968,2280],[7938,2417],[7725,2605],[7669,2634],[7428,2705],[7238,2845],[7294,2971],[7313,3170],[7343,3196],[7471,3225],[7543,3212],[7805,3263],[7811,3299],[7749,3468],[7804,3579],[7881,3605],[7967,3743],[7948,3804],[7776,3848],[7737,3905],[7774,4024],[7757,4099],[7652,4087],[7475,4154],[7444,4210],[7493,4310],[7513,4545],[7441,4604],[7344,4762],[7307,4871],[7259,4907],[7412,4947],[7481,4930],[7608,4941],[7699,4877],[7779,4852],[7805,4815],[7931,4771],[8018,4776],[8182,4843],[8266,4829]]]]}},{"type":"Feature","id":"TZ.MO","properties":{"hc-group":"admin1","hc-middle-x":0.60,"hc-middle-y":0.41,"hc-key":"tz-mo","hc-a2":"MO","labelrank":"6","hasc":"TZ.MO","alt-name":null,"woe-id":"2347361","subregion":null,"fips":"TZ10","postal-code":"MO","name":"Morogoro","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"36.922","woe-name":"Morogoro","latitude":"-8.696730000000001","woe-label":"Morogoro, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[5119,1461],[5103,1555],[4915,1704],[4848,1809],[4791,1796],[4783,1907],[4755,1952],[4780,1989],[4768,2118],[4849,2120],[5054,2074],[5095,1947],[5145,2167],[5267,2237],[5339,2301],[5377,2404],[5525,2561],[5613,2613],[5740,2621],[5747,2742],[5853,2827],[5941,2858],[6123,2822],[6200,2843],[6283,3015],[6405,3145],[6297,3162],[6254,3148],[6214,3223],[6099,3272],[5954,3303],[5916,3434],[5961,3519],[5943,3617],[5999,3751],[6082,3801],[6084,4027],[6183,4264],[6208,4362],[6250,4382],[6305,4463],[6279,4700],[6312,4806],[6366,4824],[6513,4940],[6527,4834],[6584,4809],[6570,4737],[6620,4695],[6667,4762],[6812,4874],[6846,5016],[6983,4965],[6995,4919],[7083,4823],[7111,4850],[7205,4859],[7259,4907],[7307,4871],[7344,4762],[7441,4604],[7513,4545],[7493,4310],[7444,4210],[7475,4154],[7652,4087],[7757,4099],[7774,4024],[7737,3905],[7776,3848],[7948,3804],[7967,3743],[7881,3605],[7804,3579],[7749,3468],[7811,3299],[7805,3263],[7543,3212],[7471,3225],[7343,3196],[7313,3170],[7294,2971],[7238,2845],[7113,2708],[7062,2601],[7014,2582],[6938,2456],[6905,2435],[6798,2290],[6810,2217],[6782,2096],[6731,1979],[6743,1855],[6769,1789],[6781,1644],[6679,1589],[6560,1225],[6485,1204],[6284,1076],[6078,881],[5985,831],[5918,830],[5893,878],[5948,948],[5980,1029],[5910,1180],[5867,1230],[5858,1159],[5781,1066],[5638,1066],[5551,1045],[5462,1075],[5390,988],[5180,988],[5137,1022],[5144,1083],[5201,1112],[5280,1224],[5283,1298],[5355,1415],[5327,1484],[5323,1612],[5199,1485],[5119,1461]]]}},{"type":"Feature","id":"TZ.NJ","properties":{"hc-group":"admin1","hc-middle-x":0.51,"hc-middle-y":0.41,"hc-key":"tz-nj","hc-a2":"NJ","labelrank":"6","hasc":"TZ.NJ","alt-name":null,"woe-id":"-2347355","subregion":null,"fips":"TZ30","postal-code":"NJ","name":"Njombe","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"34.8871","woe-name":"Iringa","latitude":"-9.39902","woe-label":"Iringa, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[4791,1796],[4848,1809],[4915,1704],[5103,1555],[5119,1461],[4969,1362],[4813,1227],[4748,1193],[4651,1091],[4545,1044],[4535,1016],[4590,932],[4587,883],[4635,760],[4537,611],[4465,604],[4408,566],[4402,500],[4243,399],[4197,335],[4110,281],[4000,272],[4013,322],[3985,394],[4006,504],[3947,711],[3959,763],[3906,860],[3616,1202],[3505,1299],[3509,1332],[3430,1383],[3324,1547],[3303,1632],[3224,1806],[3282,1898],[3378,1946],[3451,1920],[3540,1978],[3656,1974],[3756,1998],[3903,1985],[3949,2003],[4011,2092],[4135,2140],[4161,2205],[4302,2161],[4302,2111],[4541,2026],[4529,1847],[4623,1779],[4717,1773],[4791,1796]]]}},

    {"type":"Feature","id":"TZ.ZS","properties":{"hc-group":"admin1","hc-middle-x":0.92,"hc-middle-y":0.83,"hc-key":"tz-zs","hc-a2":"ZS","labelrank":"5","hasc":"TZ.ZS","alt-name":"Kusini Unguja|Zanzibar Central/South","woe-id":"2347372","subregion":null,"fips":"TZ21","postal-code":"ZS","name":"Zanzibar South and Central","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"39.4241","woe-name":"Zanzibar South and Central","latitude":"-6.2741","woe-label":"Zanzibar South and Central, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[8775,4538],[8744,4606],[8744,4752],[8817,4756],[8862,4784],[8901,4729],[8900,4596],[8995,4606],[9037,4358],[8975,4316],[8870,4407],[8775,4538]]]}},{"type":"Feature","id":"TZ.ZW","properties":{"hc-group":"admin1","hc-middle-x":0.57,"hc-middle-y":0.87,"hc-key":"tz-zw","hc-a2":"ZW","labelrank":"5","hasc":"TZ.ZW","alt-name":"Mjini-Magharibi|Zanzibar Urban/West","woe-id":"2347376","subregion":null,"fips":"TZ25","postal-code":"ZW","name":"Zanzibar West","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"39.2425","woe-name":"Zanzibar West","latitude":"-6.1537","woe-label":"Zanzibar West, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[8744,4752],[8744,4606],[8775,4538],[8730,4481],[8674,4548],[8644,4628],[8681,4672],[8667,4753],[8707,4755],[8744,4752]]]}},{"type":"Feature","id":"TZ.KM","properties":{"hc-group":"admin1","hc-middle-x":0.50,"hc-middle-y":0.47,"hc-key":"tz-km","hc-a2":"KM","labelrank":"7","hasc":"TZ.KM","alt-name":null,"woe-id":"2347356","subregion":null,"fips":"TZ05","postal-code":"KM","name":"Kigoma","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"30.4057","woe-name":"Kigoma","latitude":"-4.41836","woe-label":"Kigoma, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[231,7839],[296,7902],[395,7992],[438,7975],[483,7891],[485,7816],[419,7685],[417,7629],[472,7648],[525,7609],[562,7467],[621,7364],[634,7191],[659,7129],[716,7075],[777,6942],[795,6860],[756,6719],[766,6606],[836,6469],[844,6377],[884,6356],[912,6204],[887,6149],[807,6097],[818,5992],[647,5864],[670,5805],[622,5669],[613,5554],[651,5394],[633,5360],[483,5322],[458,5403],[386,5500],[376,5561],[304,5506],[253,5564],[147,5629],[-176,5629],[-315,5498],[-364,5486],[-580,5482],[-597,5460],[-506,5383],[-466,5296],[-399,4914],[-277,4634],[-198,4570],[-208,4507],[-186,4421],[-281,4355],[-333,4236],[-421,4344],[-463,4361],[-629,4328],[-725,4400],[-872,4565],[-852,4616],[-850,4767],[-796,4827],[-750,4817],[-638,4896],[-642,5018],[-751,5255],[-847,5384],[-810,5470],[-793,5633],[-767,5697],[-813,5816],[-999,5919],[-990,6057],[-939,6369],[-860,6356],[-793,6457],[-692,6475],[-589,6550],[-540,6642],[-441,6736],[-382,6894],[-254,7051],[-209,7037],[-210,7140],[-121,7313],[-83,7316],[50,7408],[14,7455],[51,7495],[212,7554],[244,7656],[195,7767],[231,7839]]]}},{"type":"Feature","id":"TZ.MT","properties":{"hc-group":"admin1","hc-middle-x":0.40,"hc-middle-y":0.54,"hc-key":"tz-mt","hc-a2":"MT","labelrank":"7","hasc":"TZ.MT","alt-name":null,"woe-id":"2347362","subregion":null,"fips":"TZ11","postal-code":"MT","name":"Mtwara","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"39.2212","woe-name":"Mtwara","latitude":"-10.814","woe-label":"Mtwara, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[7482,-495],[7417,-256],[7389,-51],[7564,-41],[7712,116],[7979,220],[8134,238],[8201,206],[8271,210],[8318,250],[8567,359],[8617,292],[8661,300],[8684,365],[8823,409],[8899,359],[8930,265],[8987,165],[9028,142],[9086,207],[9056,266],[9081,375],[9381,556],[9407,604],[9538,561],[9522,473],[9635,430],[9602,486],[9637,527],[9709,448],[9740,375],[9851,376],[9819,216],[9750,160],[9646,112],[9554,20],[9399,-85],[9275,-136],[9148,-212],[8870,-263],[8671,-415],[8596,-433],[8512,-397],[8446,-416],[8282,-421],[8144,-514],[8039,-525],[7875,-660],[7733,-603],[7644,-519],[7542,-520],[7482,-495]]]}},{"type":"Feature","id":"TZ.RV","properties":{"hc-group":"admin1","hc-middle-x":0.44,"hc-middle-y":0.56,"hc-key":"tz-rv","hc-a2":"RV","labelrank":"5","hasc":"TZ.RV","alt-name":null,"woe-id":"2347365","subregion":null,"fips":"TZ14","postal-code":"RV","name":"Ruvuma","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"36.3365","woe-name":"Ruvuma","latitude":"-10.7136","woe-label":"Ruvuma, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[7389,-51],[7417,-256],[7482,-495],[7327,-520],[7264,-554],[7169,-794],[7033,-870],[6889,-904],[6813,-953],[6718,-911],[6614,-921],[6495,-884],[6423,-789],[6298,-815],[6213,-795],[6139,-887],[6059,-933],[5956,-950],[5889,-899],[5773,-897],[5675,-924],[5596,-916],[5566,-792],[5423,-717],[5389,-723],[5342,-644],[5230,-622],[5167,-683],[5099,-703],[5058,-786],[4980,-813],[4829,-783],[4375,-776],[4371,-701],[4299,-577],[4214,-532],[4173,-538],[4129,-402],[4037,-318],[4010,-214],[4063,-111],[4093,50],[4079,115],[4000,272],[4110,281],[4197,335],[4243,399],[4402,500],[4408,566],[4465,604],[4537,611],[4635,760],[4587,883],[4590,932],[4535,1016],[4545,1044],[4651,1091],[4748,1193],[4813,1227],[4969,1362],[5119,1461],[5199,1485],[5323,1612],[5327,1484],[5355,1415],[5283,1298],[5280,1224],[5201,1112],[5144,1083],[5137,1022],[5180,988],[5390,988],[5462,1075],[5551,1045],[5638,1066],[5781,1066],[5858,1159],[5867,1230],[5910,1180],[5980,1029],[5948,948],[5893,878],[5918,830],[5985,831],[6078,881],[6284,1076],[6485,1204],[6560,1225],[6521,1107],[6399,962],[6316,888],[6290,833],[6281,626],[6330,584],[6570,489],[7121,346],[7224,273],[7303,93],[7389,-51]]]}},{"type":"Feature","id":"TZ.PN","properties":{"hc-group":"admin1","hc-middle-x":0.47,"hc-middle-y":0.51,"hc-key":"tz-pn","hc-a2":"PN","labelrank":"5","hasc":"TZ.PN","alt-name":"Pemba North","woe-id":"2347364","subregion":null,"fips":"TZ13","postal-code":"PN","name":"Kaskazini-Pemba","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"39.777","woe-name":"Kaskazini-Pemba","latitude":"-5.05108","woe-label":"Pemba North, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[9342,5605],[9274,5590],[9227,5627],[9175,5652],[9204,5728],[9161,5789],[9202,5814],[9163,5847],[9171,5902],[9302,5821],[9358,5884],[9366,5801],[9323,5763],[9314,5686],[9348,5673],[9342,5605]]]}},{"type":"Feature","id":"TZ.PS","properties":{"hc-group":"admin1","hc-middle-x":0.44,"hc-middle-y":0.51,"hc-key":"tz-ps","hc-a2":"PS","labelrank":"5","hasc":"TZ.PS","alt-name":"Pemba South","woe-id":"2347371","subregion":null,"fips":"TZ20","postal-code":"PS","name":"Kusini-Pemba","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"39.7495","woe-name":"Kusini-Pemba","latitude":"-5.34982","woe-label":"Pemba South, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[9227,5627],[9274,5590],[9342,5605],[9329,5520],[9279,5379],[9186,5343],[9124,5373],[9146,5501],[9174,5529],[9258,5528],[9133,5599],[9211,5583],[9227,5627]]]}},{"type":"Feature","id":"TZ.ZN","properties":{"hc-group":"admin1","hc-middle-x":0.46,"hc-middle-y":0.50,"hc-key":"tz-zn","hc-a2":"ZN","labelrank":"5","hasc":"TZ.ZN","alt-name":"Zanzibar North","woe-id":"2347373","subregion":null,"fips":"TZ22","postal-code":"ZN","name":"Kaskazini-Unguja","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"39.2294","woe-name":"Kaskazini-Unguja","latitude":"-5.84474","woe-label":"Zanzibar North, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[8862,4784],[8817,4756],[8744,4752],[8707,4755],[8667,4753],[8681,4870],[8752,4945],[8787,5070],[8829,4983],[8826,4889],[8862,4784]]]}},{"type":"Feature","id":"TZ.SD","properties":{"hc-group":"admin1","hc-middle-x":0.61,"hc-middle-y":0.46,"hc-key":"tz-sd","hc-a2":"SD","labelrank":"7","hasc":"TZ.SD","alt-name":null,"woe-id":"2347367","subregion":null,"fips":"TZ16","postal-code":"SD","name":"Singida","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"34.4149","woe-name":"Singida","latitude":"-5.59564","woe-label":"Singida, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[3729,6791],[3767,6824],[3854,6866],[4129,6976],[4205,7025],[4268,6968],[4337,6917],[4374,6841],[4460,6748],[4463,6718],[4351,6545],[4313,6444],[4427,6353],[4514,6214],[4581,6181],[4590,6099],[4689,6061],[4727,5990],[4787,5967],[4765,5873],[4519,5706],[4536,5564],[4582,5416],[4781,5118],[4729,5066],[4714,4987],[4652,4866],[4648,4750],[4625,4659],[4662,4461],[4635,4339],[4652,4167],[4623,4100],[4497,4095],[4517,3894],[4355,3926],[4204,3826],[4193,3729],[4155,3658],[3860,3598],[3791,3490],[3607,3503],[3541,3422],[3370,3318],[3247,3382],[3210,3516],[3152,3533],[3093,3621],[3016,3671],[2970,3818],[2917,3876],[2960,3965],[2951,4199],[2999,4256],[3087,4292],[3189,4396],[3286,4445],[3322,4502],[3450,4602],[3438,4752],[3491,4947],[3500,5072],[3548,5136],[3493,5229],[3537,5297],[3669,5433],[3558,5550],[3365,5674],[3350,5758],[3378,5837],[3352,5975],[3388,6071],[3375,6242],[3397,6334],[3517,6487],[3613,6669],[3700,6681],[3729,6791]]]}},{"type":"Feature","id":"TZ.SH","properties":{"hc-group":"admin1","hc-middle-x":0.26,"hc-middle-y":0.54,"hc-key":"tz-sh","hc-a2":"SH","labelrank":"6","hasc":"TZ.SH","alt-name":null,"woe-id":"2347366","subregion":null,"fips":"TZ15","postal-code":"SH","name":"Shinyanga","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"33.2015","woe-name":"Shinyanga","latitude":"-3.65098","woe-label":"Shinyanga, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[3854,6866],[3767,6824],[3729,6791],[3664,6758],[3422,6806],[3347,6869],[3179,6901],[3111,6895],[3031,6949],[2945,6925],[2820,6939],[2703,6911],[2614,6869],[2500,6872],[2414,6923],[2365,6903],[2293,6918],[2141,6849],[2138,6736],[2078,6682],[2161,6628],[2142,6575],[2020,6545],[1990,6629],[1894,6619],[1875,6494],[1797,6442],[1637,6510],[1553,6494],[1395,6396],[1382,6683],[1319,6735],[1112,6789],[1112,6923],[1168,7008],[1257,7086],[1363,7135],[1558,7156],[1572,7234],[1540,7435],[1605,7558],[1675,7594],[1714,7536],[1772,7511],[1842,7596],[1937,7633],[1968,7566],[1961,7459],[2077,7384],[2115,7382],[2088,7445],[2109,7511],[2168,7523],[2203,7567],[2292,7576],[2394,7468],[2541,7398],[2608,7429],[2646,7503],[2802,7524],[2857,7557],[2909,7551],[3029,7442],[3168,7386],[3240,7412],[3347,7314],[3515,7303],[3598,7279],[3630,7226],[3707,7013],[3763,6941],[3854,6866]]]}},{"type":"Feature","id":"TZ.AS","properties":{"hc-group":"admin1","hc-middle-x":0.47,"hc-middle-y":0.51,"hc-key":"tz-as","hc-a2":"AS","labelrank":"7","hasc":"TZ.AS","alt-name":null,"woe-id":"2347352","subregion":null,"fips":"TZ26","postal-code":"AS","name":"Arusha","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"36.0865","woe-name":"Arusha","latitude":"-3.02634","woe-label":"Arusha, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[4337,6917],[4268,6968],[4205,7025],[4198,7104],[4267,7203],[4338,7231],[4348,7947],[4383,7942],[4484,7862],[4572,7910],[4600,7961],[4667,8247],[4658,8344],[4700,8462],[4753,8482],[4794,8595],[4780,8645],[4684,8687],[4676,8731],[4699,9127],[5736,8549],[6897,7900],[6735,7965],[6610,7967],[6477,7861],[6376,7827],[6352,7761],[6363,7666],[6490,7582],[6527,7513],[6529,7330],[6419,7249],[6343,7248],[6261,7179],[6205,7231],[6131,7227],[6117,7193],[6038,7157],[5960,7038],[5989,6738],[5809,6718],[5752,6692],[5702,6713],[5476,7043],[5395,7180],[5337,7161],[5201,6996],[5179,7065],[5212,7210],[5172,7262],[5148,7156],[5028,7124],[5013,7059],[4937,7097],[4983,7160],[4829,7202],[4762,7135],[4627,7088],[4531,7030],[4504,6988],[4337,6917]]]}},{"type":"Feature","id":"TZ.MY","properties":{"hc-group":"admin1","hc-middle-x":0.65,"hc-middle-y":0.46,"hc-key":"tz-my","hc-a2":"MY","labelrank":"5","hasc":"TZ.MY","alt-name":null,"woe-id":"56025085","subregion":null,"fips":"TZ27","postal-code":"MY","name":"Manyara","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"36.4591","woe-name":"Manyara","latitude":"-4.88783","woe-label":"Manyara, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[6513,4940],[6366,4824],[6312,4806],[6175,4854],[6125,4898],[6020,5063],[5894,5132],[5831,5228],[5694,5357],[5687,5523],[5764,5697],[5802,5938],[5815,6142],[5761,6338],[5755,6636],[5503,6566],[5405,6470],[5306,6443],[5272,6460],[5201,6390],[5085,6322],[5110,6253],[4957,5960],[4787,5967],[4727,5990],[4689,6061],[4590,6099],[4581,6181],[4514,6214],[4427,6353],[4313,6444],[4351,6545],[4463,6718],[4460,6748],[4374,6841],[4337,6917],[4504,6988],[4531,7030],[4627,7088],[4762,7135],[4829,7202],[4983,7160],[4937,7097],[5013,7059],[5028,7124],[5148,7156],[5172,7262],[5212,7210],[5179,7065],[5201,6996],[5337,7161],[5395,7180],[5476,7043],[5702,6713],[5752,6692],[5809,6718],[5989,6738],[5960,7038],[6038,7157],[6117,7193],[6131,7227],[6205,7231],[6261,7179],[6343,7248],[6419,7249],[6529,7330],[6607,7336],[6674,7370],[6757,7326],[6798,7220],[6852,7161],[6936,7000],[6932,6889],[6975,6741],[6963,6430],[6996,6373],[7228,6224],[7397,6242],[7500,6170],[7449,6117],[7439,6002],[7516,5807],[7413,5845],[7214,5799],[7055,5831],[6999,5782],[6849,5604],[6847,5525],[6801,5362],[6708,5244],[6666,5072],[6633,5020],[6513,4940]]]}},{"type":"Feature","id":"TZ.MA","properties":{"hc-group":"admin1","hc-middle-x":0.61,"hc-middle-y":0.55,"hc-key":"tz-ma","hc-a2":"MA","labelrank":"5","hasc":"TZ.MA","alt-name":null,"woe-id":"2347359","subregion":null,"fips":"TZ08","postal-code":"MA","name":"Mara","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"34.0227","woe-name":"Mara","latitude":"-1.58906","woe-label":"Mara, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[3269,8662],[3254,8711],[3187,8748],[3158,8734],[3149,8729],[3131,8717],[3042,8651],[2953,8679],[2945,8681],[2938,8681],[2884,8683],[2845,8679],[2834,8678],[2827,8676],[2792,8666],[2760,8704],[2744,8712],[2728,8718],[2692,8723],[2642,8712],[2640,8719],[2641,8726],[2641,8730],[2642,8730],[2650,8744],[2654,8754],[2654,8762],[2653,8765],[2652,8772],[2651,8776],[2650,8781],[2647,8781],[2647,8781],[2649,8785],[2652,8792],[2654,8793],[2655,8792],[2661,8788],[2685,8787],[2689,8787],[2689,8787],[2689,8787],[2689,8788],[2689,8788],[2714,8782],[2719,8778],[2726,8803],[2703,8823],[2715,8834],[2742,8806],[2744,8803],[2745,8801],[2751,8788],[2758,8789],[2758,8818],[2774,8815],[2802,8791],[2814,8781],[2814,8781],[2817,8788],[2820,8791],[2820,8792],[2826,8793],[2834,8795],[2834,8795],[2834,8795],[2806,8836],[2834,8862],[2932,8809],[2983,8807],[2986,8805],[2990,8813],[2993,8819],[3000,8828],[3005,8833],[3007,8841],[3009,8847],[3004,8853],[2994,8864],[2973,8864],[2975,8866],[2977,8866],[2978,8868],[2980,8871],[2980,8871],[2980,8871],[2940,8881],[2908,8884],[2897,8885],[2924,8902],[2897,8953],[2897,8953],[2897,8953],[2893,8954],[2827,8938],[2748,8890],[2742,8894],[2716,8912],[2739,8927],[2744,8929],[2744,8937],[2745,8951],[2747,8955],[2753,8965],[2753,8965],[2799,9031],[2883,9035],[2928,8995],[3035,9097],[2979,9160],[3125,9160],[3149,9187],[3112,9255],[3063,9280],[3123,9317],[3084,9354],[3249,9354],[3263,9324],[3384,9310],[3333,9338],[3298,9428],[3231,9502],[3345,9516],[3429,9486],[3373,9559],[3325,9559],[3325,9613],[3433,9699],[3515,9785],[4699,9127],[4676,8731],[4684,8687],[4780,8645],[4794,8595],[4753,8482],[4700,8462],[4658,8344],[4103,8341],[4010,8396],[3922,8408],[3872,8475],[3741,8576],[3611,8637],[3540,8642],[3476,8701],[3444,8652],[3269,8662]]]}},{"type":"Feature","id":"TZ.SI","properties":{"hc-group":"admin1","hc-middle-x":0.47,"hc-middle-y":0.46,"hc-key":"tz-si","hc-a2":"SI","labelrank":"6","hasc":"TZ.SI","alt-name":null,"woe-id":"-2347366","subregion":null,"fips":"TZ31","postal-code":"SI","name":"Simiyu","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"34.2172","woe-name":"Shinyanga","latitude":"-2.96688","woe-label":"Shinyanga, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"MultiPolygon","coordinates":[[[[2827,8676],[2834,8678],[2845,8679],[2834,8678],[2827,8676]]],[[[2953,8679],[2945,8681],[2938,8681],[2945,8681],[2953,8679]]],[[[4205,7025],[4129,6976],[3854,6866],[3763,6941],[3707,7013],[3630,7226],[3598,7279],[3515,7303],[3347,7314],[3240,7412],[3168,7386],[3029,7442],[2909,7551],[2857,7557],[2907,7652],[2965,7859],[2933,7971],[3056,8061],[3125,8041],[3202,8077],[3225,8125],[3201,8171],[3109,8220],[2950,8384],[2958,8446],[3085,8525],[3197,8564],[3277,8613],[3269,8662],[3444,8652],[3476,8701],[3540,8642],[3611,8637],[3741,8576],[3872,8475],[3922,8408],[4010,8396],[4103,8341],[4658,8344],[4667,8247],[4600,7961],[4572,7910],[4484,7862],[4383,7942],[4348,7947],[4338,7231],[4267,7203],[4198,7104],[4205,7025]]],[[[3131,8717],[3149,8729],[3158,8734],[3149,8729],[3131,8717]]]]}},{"type":"Feature","id":"TZ.MB","properties":{"hc-group":"admin1","hc-middle-x":0.47,"hc-middle-y":0.39,"hc-key":"tz-mb","hc-a2":"MB","labelrank":"6","hasc":"TZ.MB","alt-name":null,"woe-id":"2347360","subregion":null,"fips":"TZ09","postal-code":"MB","name":"Mbeya","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"33.5281","woe-name":"Mbeya","latitude":"-8.296950000000001","woe-label":"Mbeya, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[3505,1299],[3439,1332],[3373,1260],[3378,1136],[3338,1091],[3292,1140],[3162,1226],[3078,1199],[2988,1217],[2909,1186],[2833,1206],[2804,1262],[2730,1319],[2603,1300],[2534,1323],[2423,1420],[2352,1404],[2191,1472],[2145,1526],[1950,1553],[1892,1644],[1815,1678],[1644,1685],[1579,1741],[1582,1862],[1503,1933],[1523,1962],[1442,2030],[1463,2070],[1644,2150],[1719,2244],[1709,2469],[1746,2513],[1807,2516],[1933,2600],[1959,2588],[1980,2455],[2063,2349],[2181,2344],[2173,2410],[1942,2717],[1895,2764],[1709,2887],[1440,3026],[1423,3062],[1450,3148],[1524,3282],[1627,3321],[1703,3502],[1703,3608],[1931,3686],[1982,3715],[2121,3725],[2222,3872],[2291,3878],[2349,3921],[2467,3953],[2618,3882],[2699,3864],[2917,3876],[2970,3818],[3016,3671],[3093,3621],[3152,3533],[3210,3516],[3247,3382],[3370,3318],[3412,3282],[3300,3091],[3273,3013],[3326,2979],[3791,3001],[3991,2961],[4070,2921],[4341,2877],[4347,2820],[4422,2819],[4494,2775],[4426,2709],[4371,2693],[4284,2537],[4169,2462],[4120,2377],[4173,2270],[4161,2205],[4135,2140],[4011,2092],[3949,2003],[3903,1985],[3756,1998],[3656,1974],[3540,1978],[3451,1920],[3378,1946],[3282,1898],[3224,1806],[3303,1632],[3324,1547],[3430,1383],[3509,1332],[3505,1299]]]}},{"type":"Feature","id":"TZ.RK","properties":{"hc-group":"admin1","hc-middle-x":0.51,"hc-middle-y":0.60,"hc-key":"tz-rk","hc-a2":"RK","labelrank":"5","hasc":"TZ.RK","alt-name":null,"woe-id":"2347375","subregion":null,"fips":"TZ24","postal-code":"RK","name":"Rukwa","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"31.3337","woe-name":"Rukwa","latitude":"-7.8958","woe-label":"Rukwa, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[1579,1741],[1465,1765],[1414,1739],[1351,1789],[1370,1879],[1221,1919],[1106,1898],[987,2002],[972,2107],[786,2223],[694,2186],[640,2229],[600,2221],[568,2285],[578,2384],[559,2416],[403,2548],[333,2792],[229,2936],[173,3091],[94,3167],[11,3303],[37,3441],[-53,3679],[-15,3711],[1,3795],[-12,3857],[111,3901],[330,3913],[417,3880],[461,3749],[462,3662],[506,3596],[811,3576],[866,3510],[922,3106],[1440,3026],[1709,2887],[1895,2764],[1942,2717],[2173,2410],[2181,2344],[2063,2349],[1980,2455],[1959,2588],[1933,2600],[1807,2516],[1746,2513],[1709,2469],[1719,2244],[1644,2150],[1463,2070],[1442,2030],[1523,1962],[1503,1933],[1582,1862],[1579,1741]]]}},{"type":"Feature","id":"TZ.DS","properties":{"hc-group":"admin1","hc-middle-x":0.55,"hc-middle-y":0.50,"hc-key":"tz-ds","hc-a2":"DS","labelrank":"9","hasc":"TZ.DS","alt-name":"Dar es Salaam","woe-id":"2347374","subregion":null,"fips":"TZ23","postal-code":"DS","name":"Dar-Es-Salaam","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"39.2857","woe-name":"Dar-Es-Salaam","latitude":"-6.89289","woe-label":"Dar es Salaam, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[8589,4224],[8674,4139],[8692,4077],[8741,4052],[8754,3963],[8925,3918],[9010,3779],[9005,3654],[8966,3604],[8891,3591],[8865,3604],[8866,3747],[8816,3816],[8704,3824],[8625,3762],[8592,3776],[8534,3723],[8482,3747],[8562,3868],[8513,3982],[8476,3995],[8507,4045],[8545,4182],[8589,4224]]]}},{"type":"Feature","id":"TZ.DO","properties":{"hc-group":"admin1","hc-middle-x":0.45,"hc-middle-y":0.55,"hc-key":"tz-do","hc-a2":"DO","labelrank":"7","hasc":"TZ.DO","alt-name":null,"woe-id":"2347354","subregion":null,"fips":"TZ03","postal-code":"DO","name":"Dodoma","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"35.9608","woe-name":"Dodoma","latitude":"-5.73233","woe-label":"Dodoma, TZ, Tanzania","type":"Mkoa"},

        "geometry":{"type":"Polygon","coordinates":[[[6312,4806],[6279,4700],[6305,4463],[6250,4382],[6208,4362],[6183,4264],[6084,4027],[6082,3801],[5999,3751],[5943,3617],[5961,3519],[5916,3434],[5863,3489],[5776,3479],[5682,3635],[5548,3683],[5421,3678],[5212,3743],[5144,3744],[4962,3815],[4950,3851],[4880,3880],[4736,3872],[4614,3835],[4517,3894],[4497,4095],[4623,4100],[4652,4167],[4635,4339],[4662,4461],[4625,4659],[4648,4750],[4652,4866],[4714,4987],[4729,5066],[4781,5118],[4582,5416],[4536,5564],[4519,5706],[4765,5873],[4787,5967],[4957,5960],[5110,6253],[5085,6322],[5201,6390],[5272,6460],[5306,6443],[5405,6470],[5503,6566],[5755,6636],[5761,6338],[5815,6142],[5802,5938],[5764,5697],[5687,5523],[5694,5357],[5831,5228],[5894,5132],[6020,5063],[6125,4898],[6175,4854],[6312,4806]]]}},{"type":"Feature","id":"TZ.TB","properties":{"hc-group":"admin1","hc-middle-x":0.54,"hc-middle-y":0.47,"hc-key":"tz-tb","hc-a2":"TB","labelrank":"6","hasc":"TZ.TB","alt-name":null,"woe-id":"2347368","subregion":null,"fips":"TZ17","postal-code":"TB","name":"Tabora","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"32.6595","woe-name":"Tabora","latitude":"-6.82145","woe-label":"Tabora, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[3729,6791],[3700,6681],[3613,6669],[3517,6487],[3397,6334],[3375,6242],[3388,6071],[3352,5975],[3378,5837],[3350,5758],[3365,5674],[3558,5550],[3669,5433],[3537,5297],[3493,5229],[3548,5136],[3500,5072],[3491,4947],[3438,4752],[3450,4602],[3322,4502],[3286,4445],[3189,4396],[3087,4292],[2999,4256],[2951,4199],[2960,3965],[2917,3876],[2699,3864],[2618,3882],[2467,3953],[2349,3921],[2291,3878],[2222,3872],[2121,3725],[1982,3715],[2016,3918],[2015,4127],[2044,4220],[2131,4311],[2167,4374],[2128,4432],[1941,4460],[1859,4564],[1773,4601],[1746,4650],[1606,4745],[1528,4917],[1524,4986],[1479,5051],[1223,5103],[1115,5023],[1042,4994],[967,5017],[874,4999],[795,5033],[698,5019],[644,5075],[571,5063],[560,5183],[461,5241],[483,5322],[633,5360],[651,5394],[613,5554],[622,5669],[670,5805],[647,5864],[818,5992],[807,6097],[887,6149],[912,6204],[884,6356],[844,6377],[836,6469],[895,6579],[1034,6580],[1103,6614],[1058,6699],[1112,6789],[1319,6735],[1382,6683],[1395,6396],[1553,6494],[1637,6510],[1797,6442],[1875,6494],[1894,6619],[1990,6629],[2020,6545],[2142,6575],[2161,6628],[2078,6682],[2138,6736],[2141,6849],[2293,6918],[2365,6903],[2414,6923],[2500,6872],[2614,6869],[2703,6911],[2820,6939],[2945,6925],[3031,6949],[3111,6895],[3179,6901],[3347,6869],[3422,6806],[3664,6758],[3729,6791]]]}},{"type":"Feature","id":"TZ.LI","properties":{"hc-group":"admin1","hc-middle-x":0.48,"hc-middle-y":0.52,"hc-key":"tz-li","hc-a2":"LI","labelrank":"6","hasc":"TZ.LI","alt-name":null,"woe-id":"2347358","subregion":null,"fips":"TZ07","postal-code":"LI","name":"Lindi","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"38.4234","woe-name":"Lindi","latitude":"-9.443379999999999","woe-label":"Lindi, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[8723,2446],[8738,2403],[8738,2257],[8795,2150],[8786,2046],[8870,2003],[8919,1930],[8949,1832],[8879,1898],[8817,1859],[8893,1858],[8920,1817],[8923,1630],[8983,1659],[9068,1561],[9064,1380],[8984,1336],[9036,1324],[9099,1241],[9161,1037],[9111,999],[9166,994],[9219,888],[9163,863],[9200,817],[9124,790],[9124,702],[9172,757],[9322,703],[9381,601],[9381,556],[9081,375],[9056,266],[9086,207],[9028,142],[8987,165],[8930,265],[8899,359],[8823,409],[8684,365],[8661,300],[8617,292],[8567,359],[8318,250],[8271,210],[8201,206],[8134,238],[7979,220],[7712,116],[7564,-41],[7389,-51],[7303,93],[7224,273],[7121,346],[6570,489],[6330,584],[6281,626],[6290,833],[6316,888],[6399,962],[6521,1107],[6560,1225],[6679,1589],[6781,1644],[6769,1789],[6743,1855],[6731,1979],[6782,2096],[6810,2217],[6798,2290],[6905,2435],[6938,2456],[7014,2582],[7062,2601],[7113,2708],[7238,2845],[7428,2705],[7669,2634],[7725,2605],[7938,2417],[7968,2280],[8073,2305],[8121,2402],[8192,2416],[8237,2389],[8425,2441],[8671,2482],[8723,2446]]]}},{"type":"Feature","id":"TZ.GE","properties":{"hc-group":"admin1","hc-middle-x":0.47,"hc-middle-y":0.46,"hc-key":"tz-ge","hc-a2":"GE","labelrank":"5","hasc":"TZ.GE","alt-name":null,"woe-id":"-2347370","subregion":null,"fips":"TZ28","postal-code":"GE","name":"Geita","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"31.6968","woe-name":"Kagera","latitude":"-3.09999","woe-label":"Kagera, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"MultiPolygon","coordinates":[[[[1230,8651],[1277,8581],[1289,8523],[1329,8511],[1341,8417],[1269,8378],[1272,8444],[1195,8547],[1230,8651]]],[[[1052,8477],[1144,8513],[1216,8370],[1137,8325],[1174,8212],[1279,8231],[1205,8189],[1217,7997],[1265,8045],[1247,8135],[1327,8121],[1319,8183],[1353,8184],[1390,8080],[1438,8072],[1417,8156],[1362,8243],[1414,8249],[1407,8325],[1452,8362],[1555,8300],[1586,8312],[1669,8252],[1839,8224],[1785,8122],[1961,8021],[1936,7945],[2024,7871],[1937,7633],[1842,7596],[1772,7511],[1714,7536],[1675,7594],[1605,7558],[1540,7435],[1572,7234],[1558,7156],[1363,7135],[1257,7086],[1168,7008],[1112,6923],[1112,6789],[1058,6699],[1103,6614],[1034,6580],[895,6579],[836,6469],[766,6606],[756,6719],[795,6860],[777,6942],[716,7075],[659,7129],[634,7191],[621,7364],[562,7467],[525,7609],[472,7648],[417,7629],[419,7685],[485,7816],[483,7891],[438,7975],[395,7992],[383,8055],[287,8146],[322,8245],[432,8298],[581,8553],[780,8567],[982,8479],[1052,8477]]]]}},{"type":"Feature","id":"TZ.KL","properties":{"hc-group":"admin1","hc-middle-x":0.62,"hc-middle-y":0.73,"hc-key":"tz-kl","hc-a2":"KL","labelrank":"5","hasc":"TZ.KL","alt-name":null,"woe-id":"2347357","subregion":null,"fips":"TZ06","postal-code":"KL","name":"Kilimanjaro","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"37.6511","woe-name":"Kilimanjaro","latitude":"-4.01115","woe-label":"Kilimanjaro, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[6897,7900],[7119,7775],[7135,7750],[7174,7505],[7063,7415],[7071,7305],[7195,7278],[7244,7161],[7894,6690],[7545,6201],[7500,6170],[7397,6242],[7228,6224],[6996,6373],[6963,6430],[6975,6741],[6932,6889],[6936,7000],[6852,7161],[6798,7220],[6757,7326],[6674,7370],[6607,7336],[6529,7330],[6527,7513],[6490,7582],[6363,7666],[6352,7761],[6376,7827],[6477,7861],[6610,7967],[6735,7965],[6897,7900]]]}},{"type":"Feature","id":"TZ.TN","properties":{"hc-group":"admin1","hc-middle-x":0.66,"hc-middle-y":0.49,"hc-key":"tz-tn","hc-a2":"TN","labelrank":"7","hasc":"TZ.TN","alt-name":null,"woe-id":"2347369","subregion":null,"fips":"TZ18","postal-code":"TN","name":"Tanga","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"38.1412","woe-name":"Tanga","latitude":"-5.18525","woe-label":"Tanga, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[8266,4829],[8182,4843],[8018,4776],[7931,4771],[7805,4815],[7779,4852],[7699,4877],[7608,4941],[7481,4930],[7412,4947],[7259,4907],[7205,4859],[7111,4850],[7083,4823],[6995,4919],[6983,4965],[6846,5016],[6812,4874],[6667,4762],[6620,4695],[6570,4737],[6584,4809],[6527,4834],[6513,4940],[6633,5020],[6666,5072],[6708,5244],[6801,5362],[6847,5525],[6849,5604],[6999,5782],[7055,5831],[7214,5799],[7413,5845],[7516,5807],[7439,6002],[7449,6117],[7500,6170],[7545,6201],[7894,6690],[8673,6121],[8698,6049],[8651,6018],[8698,6002],[8655,5870],[8588,5881],[8617,5692],[8516,5556],[8557,5564],[8512,5438],[8454,5377],[8458,5289],[8373,5150],[8364,5082],[8300,4977],[8266,4829]]]}},{"type":"Feature","id":"TZ.KA","properties":{"hc-group":"admin1","hc-middle-x":0.42,"hc-middle-y":0.49,"hc-key":"tz-ka","hc-a2":"KA","labelrank":"5","hasc":"TZ.KA","alt-name":null,"woe-id":"-2347375","subregion":null,"fips":"TZ29","postal-code":"KA","name":"Katavi","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"31.3404","woe-name":"Rukwa","latitude":"-6.4277","woe-label":"Rukwa, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[1440,3026],[922,3106],[866,3510],[811,3576],[506,3596],[462,3662],[461,3749],[417,3880],[330,3913],[111,3901],[-12,3857],[-159,3991],[-182,4066],[-243,4167],[-333,4236],[-281,4355],[-186,4421],[-208,4507],[-198,4570],[-277,4634],[-399,4914],[-466,5296],[-506,5383],[-597,5460],[-580,5482],[-364,5486],[-315,5498],[-176,5629],[147,5629],[253,5564],[304,5506],[376,5561],[386,5500],[458,5403],[483,5322],[461,5241],[560,5183],[571,5063],[644,5075],[698,5019],[795,5033],[874,4999],[967,5017],[1042,4994],[1115,5023],[1223,5103],[1479,5051],[1524,4986],[1528,4917],[1606,4745],[1746,4650],[1773,4601],[1859,4564],[1941,4460],[2128,4432],[2167,4374],[2131,4311],[2044,4220],[2015,4127],[2016,3918],[1982,3715],[1931,3686],[1703,3608],[1703,3502],[1627,3321],[1524,3282],[1450,3148],[1423,3062],[1440,3026]]]}},{"type":"Feature","id":"TZ.IR","properties":{"hc-group":"admin1","hc-middle-x":0.49,"hc-middle-y":0.40,"hc-key":"tz-ir","hc-a2":"IR","labelrank":"6","hasc":"TZ.IR","alt-name":null,"woe-id":"2347355","subregion":null,"fips":"TZ04","postal-code":"IR","name":"Iringa","country":"United Republic of Tanzania","type-en":"Region","region":null,"longitude":"35.5453","woe-name":"Iringa","latitude":"-7.83931","woe-label":"Iringa, TZ, Tanzania","type":"Mkoa"},"geometry":{"type":"Polygon","coordinates":[[[4161,2205],[4173,2270],[4120,2377],[4169,2462],[4284,2537],[4371,2693],[4426,2709],[4494,2775],[4422,2819],[4347,2820],[4341,2877],[4070,2921],[3991,2961],[3791,3001],[3326,2979],[3273,3013],[3300,3091],[3412,3282],[3370,3318],[3541,3422],[3607,3503],[3791,3490],[3860,3598],[4155,3658],[4193,3729],[4204,3826],[4355,3926],[4517,3894],[4614,3835],[4736,3872],[4880,3880],[4950,3851],[4962,3815],[5144,3744],[5212,3743],[5421,3678],[5548,3683],[5682,3635],[5776,3479],[5863,3489],[5916,3434],[5954,3303],[6099,3272],[6214,3223],[6254,3148],[6297,3162],[6405,3145],[6283,3015],[6200,2843],[6123,2822],[5941,2858],[5853,2827],[5747,2742],[5740,2621],[5613,2613],[5525,2561],[5377,2404],[5339,2301],[5267,2237],[5145,2167],[5095,1947],[5054,2074],[4849,2120],[4768,2118],[4780,1989],[4755,1952],[4783,1907],[4791,1796],[4717,1773],[4623,1779],[4529,1847],[4541,2026],[4302,2111],[4302,2161],[4161,2205]]]}}]}


        static data = [
            {
                "code": "tz-mo",
                "name": "Morogoro",
                "value": 3.9
            },
            {
                "code": "tz-mw",
                "name": "Mwanza",
                "value": 4.3
            },
            {
                "code": "tz-mb",
                "name": "Mbeya",
                "value": 5.6
            },
            {
                "code": "tz-kr",
                "name": "Kagera",
                "value": 4.2
            },
            {
                "code": "tz-rv",
                "name": "Ruvuma",
                "value": 8
            },
            {
                "code": "tz-nj",
                "name": "Njombe",
                "value": 5
            },
            {
                "code": "tz-ds",
                "name": "Butler County, AL",
                "value": 3
            },
            {
                "code": "tz-ir",
                "name": "Calhoun County, AL",
                "value": 4.9
            },
            {
                "code": "tz-li",
                "name": "Chambers County, AL",
                "value": 2
            },
            {
                "code": "tz-mt",
                "name": "Cherokee County, AL",
                "value": 2.3
            },
            {
                "code": "tz-pw",
                "name": "Chilton County, AL",
                "value": 1.2
            },
            {
                "code": "tz-do",
                "name": "Choctaw County, AL",
                "value": 18.3
            },
            {
                "code": "us-al-025",
                "name": "Clarke County, AL",
                "value": 8.6
            },
            {
                "code": "us-al-027",
                "name": "Clay County, AL",
                "value": 4.2
            },
            {
                "code": "us-al-029",
                "name": "Cleburne County, AL",
                "value": 4.8
            },
            {
                "code": "us-al-031",
                "name": "Coffee County, AL",
                "value": 4.4
            },
            {
                "code": "us-al-033",
                "name": "Colbert County, AL",
                "value": 5.3
            },
            {
                "code": "us-al-035",
                "name": "Conecuh County, AL",
                "value": 5.6
            },
            {
                "code": "us-al-037",
                "name": "Coosa County, AL",
                "value": 4.7
            },
            {
                "code": "us-al-039",
                "name": "Covington County, AL",
                "value": 5.2
            },
            {
                "code": "us-al-041",
                "name": "Crenshaw County, AL",
                "value": 4.7
            },
            {
                "code": "us-al-043",
                "name": "Cullman County, AL",
                "value": 3.7
            },
            {
                "code": "us-al-045",
                "name": "Dale County, AL",
                "value": 4.6
            },
            {
                "code": "us-al-047",
                "name": "Dallas County, AL",
                "value": 7
            },
            {
                "code": "us-al-049",
                "name": "DeKalb County, AL",
                "value": 4.3
            },
            {
                "code": "us-al-051",
                "name": "Elmore County, AL",
                "value": 3.9
            },
            {
                "code": "us-al-053",
                "name": "Escambia County, AL",
                "value": 4.9
            },
            {
                "code": "us-al-055",
                "name": "Etowah County, AL",
                "value": 4.5
            },
            {
                "code": "us-al-057",
                "name": "Fayette County, AL",
                "value": 4.8
            },
            {
                "code": "us-al-059",
                "name": "Franklin County, AL",
                "value": 4.3
            },
            {
                "code": "us-al-061",
                "name": "Geneva County, AL",
                "value": 4.6
            },
            {
                "code": "us-al-063",
                "name": "Greene County, AL",
                "value": 7
            },
            {
                "code": "us-al-065",
                "name": "Hale County, AL",
                "value": 5.7
            },
            {
                "code": "us-al-067",
                "name": "Henry County, AL",
                "value": 4.8
            },
            {
                "code": "us-al-069",
                "name": "Houston County, AL",
                "value": 4.5
            },
            {
                "code": "us-al-071",
                "name": "Jackson County, AL",
                "value": 4.7
            },
            {
                "code": "us-al-073",
                "name": "Jefferson County, AL",
                "value": 4.1
            },
            {
                "code": "us-al-075",
                "name": "Lamar County, AL",
                "value": 4.1
            },
            {
                "code": "us-al-077",
                "name": "Lauderdale County, AL",
                "value": 4.8
            },
            {
                "code": "us-al-079",
                "name": "Lawrence County, AL",
                "value": 4.8
            },
            {
                "code": "us-al-081",
                "name": "Lee County, AL",
                "value": 4
            },
            {
                "code": "us-al-083",
                "name": "Limestone County, AL",
                "value": 4.1
            },
            {
                "code": "us-al-085",
                "name": "Lowndes County, AL",
                "value": 8.1
            },
            {
                "code": "us-al-087",
                "name": "Macon County, AL",
                "value": 5.6
            },
            {
                "code": "us-al-089",
                "name": "Madison County, AL",
                "value": 3.8
            },
            {
                "code": "us-al-091",
                "name": "Marengo County, AL",
                "value": 5.7
            },
            {
                "code": "us-al-093",
                "name": "Marion County, AL",
                "value": 4.5
            },
            {
                "code": "us-al-095",
                "name": "Marshall County, AL",
                "value": 3.8
            },
            {
                "code": "us-al-097",
                "name": "Mobile County, AL",
                "value": 5.3
            },
            {
                "code": "us-al-099",
                "name": "Monroe County, AL",
                "value": 6.8
            },
            {
                "code": "us-al-101",
                "name": "Montgomery County, AL",
                "value": 4.3
            },
            {
                "code": "us-al-103",
                "name": "Morgan County, AL",
                "value": 4.1
            },
            {
                "code": "us-al-105",
                "name": "Perry County, AL",
                "value": 6.7
            },
            {
                "code": "us-al-107",
                "name": "Pickens County, AL",
                "value": 5
            },
            {
                "code": "us-al-109",
                "name": "Pike County, AL",
                "value": 5
            },
            {
                "code": "us-al-111",
                "name": "Randolph County, AL",
                "value": 4.4
            },
            {
                "code": "us-al-113",
                "name": "Russell County, AL",
                "value": 4.6
            },
            {
                "code": "us-al-115",
                "name": "St. Clair County, AL",
                "value": 3.9
            },
            {
                "code": "us-al-117",
                "name": "Shelby County, AL",
                "value": 3.1
            },
            {
                "code": "us-al-119",
                "name": "Sumter County, AL",
                "value": 6.3
            },
            {
                "code": "us-al-121",
                "name": "Talladega County, AL",
                "value": 4.9
            },
            {
                "code": "us-al-123",
                "name": "Tallapoosa County, AL",
                "value": 4.6
            },
            {
                "code": "us-al-125",
                "name": "Tuscaloosa County, AL",
                "value": 4
            },
            {
                "code": "us-al-127",
                "name": "Walker County, AL",
                "value": 4.9
            },
            {
                "code": "us-al-129",
                "name": "Washington County, AL",
                "value": 6.6
            },
            {
                "code": "us-al-131",
                "name": "Wilcox County, AL",
                "value": 11
            },
            {
                "code": "us-al-133",
                "name": "Winston County, AL",
                "value": 4.8
            },
            {
                "code": "us-ak-013",
                "name": "Aleutians East Borough, AK",
                "value": 3.5
            },
            {
                "code": "us-ak-016",
                "name": "Aleutians West Census Area, AK",
                "value": 3
            },
            {
                "code": "us-ak-020",
                "name": "Anchorage Borough/municipality, AK",
                "value": 5.9
            },
            {
                "code": "us-ak-050",
                "name": "Bethel Census Area, AK",
                "value": 13.3
            },
            {
                "code": "us-ak-060",
                "name": "Bristol Bay Borough, AK",
                "value": 15.9
            },
            {
                "code": "us-ak-068",
                "name": "Denali Borough, AK",
                "value": 18.9
            },
            {
                "code": "us-ak-070",
                "name": "Dillingham Census Area, AK",
                "value": 9.6
            },
            {
                "code": "us-ak-090",
                "name": "Fairbanks North Star Borough, AK",
                "value": 6.8
            },
            {
                "code": "us-ak-100",
                "name": "Haines Borough, AK",
                "value": 16.1
            },
            {
                "code": "us-ak-105",
                "name": "Hoonah-Angoon Census Area, AK",
                "value": 19.1
            },
            {
                "code": "us-ak-110",
                "name": "Juneau Borough/city, AK",
                "value": 5.1
            },
            {
                "code": "us-ak-122",
                "name": "Kenai Peninsula Borough, AK",
                "value": 9.6
            },
            {
                "code": "us-ak-130",
                "name": "Ketchikan Gateway Borough, AK",
                "value": 7.9
            },
            {
                "code": "us-ak-150",
                "name": "Kodiak Island Borough, AK",
                "value": 8.3
            },
            {
                "code": "us-ak-158",
                "name": "Kusilvak Census Area, AK",
                "value": 20.2
            },
            {
                "code": "us-ak-164",
                "name": "Lake and Peninsula Borough, AK",
                "value": 15.3
            },
            {
                "code": "us-ak-170",
                "name": "Matanuska-Susitna Borough, AK",
                "value": 8.8
            },
            {
                "code": "us-ak-180",
                "name": "Nome Census Area, AK",
                "value": 11.9
            },
            {
                "code": "us-ak-185",
                "name": "North Slope Borough, AK",
                "value": 6.8
            },
            {
                "code": "us-ak-188",
                "name": "Northwest Arctic Borough, AK",
                "value": 15
            },
            {
                "code": "us-ak-195",
                "name": "Petersburg Borough, AK",
                "value": 12.1
            },
            {
                "code": "us-ak-198",
                "name": "Prince of Wales-Hyder Census Area, AK",
                "value": 13.2
            },
            {
                "code": "us-ak-220",
                "name": "Sitka Borough/city, AK",
                "value": 5.2
            },
            {
                "code": "us-ak-230",
                "name": "Skagway Municipality, AK",
                "value": 21.6
            },
            {
                "code": "us-ak-240",
                "name": "Southeast Fairbanks Census Area, AK",
                "value": 11.6
            },
            {
                "code": "us-ak-261",
                "name": "Valdez-Cordova Census Area, AK",
                "value": 10.7
            },
            {
                "code": "us-ak-275",
                "name": "Wrangell Borough/city, AK",
                "value": 9.7
            },
            {
                "code": "us-ak-282",
                "name": "Yakutat Borough/city, AK",
                "value": 10.6
            },
            {
                "code": "us-ak-290",
                "name": "Yukon-Koyukuk Census Area, AK",
                "value": 18.5
            },
            {
                "code": "us-az-001",
                "name": "Apache County, AZ",
                "value": 10.8
            },
            {
                "code": "us-az-003",
                "name": "Cochise County, AZ",
                "value": 6
            },
            {
                "code": "us-az-005",
                "name": "Coconino County, AZ",
                "value": 6.2
            },
            {
                "code": "us-az-007",
                "name": "Gila County, AZ",
                "value": 6.3
            },
            {
                "code": "us-az-009",
                "name": "Graham County, AZ",
                "value": 5.6
            },
            {
                "code": "us-az-011",
                "name": "Greenlee County, AZ",
                "value": 5
            },
            {
                "code": "us-az-012",
                "name": "La Paz County, AZ",
                "value": 6.4
            },
            {
                "code": "us-az-013",
                "name": "Maricopa County, AZ",
                "value": 4.3
            },
            {
                "code": "us-az-015",
                "name": "Mohave County, AZ",
                "value": 6.3
            },
            {
                "code": "us-az-017",
                "name": "Navajo County, AZ",
                "value": 8.8
            },
            {
                "code": "us-az-019",
                "name": "Pima County, AZ",
                "value": 4.7
            },
            {
                "code": "us-az-021",
                "name": "Pinal County, AZ",
                "value": 5.2
            },
            {
                "code": "us-az-023",
                "name": "Santa Cruz County, AZ",
                "value": 9.1
            },
            {
                "code": "us-az-025",
                "name": "Yavapai County, AZ",
                "value": 4.8
            },
            {
                "code": "us-az-027",
                "name": "Yuma County, AZ",
                "value": 14.3
            },
            {
                "code": "us-ar-001",
                "name": "Arkansas County, AR",
                "value": 4.5
            },
            {
                "code": "us-ar-003",
                "name": "Ashley County, AR",
                "value": 6.8
            },
            {
                "code": "us-ar-005",
                "name": "Baxter County, AR",
                "value": 5.1
            },
            {
                "code": "us-ar-007",
                "name": "Benton County, AR",
                "value": 3.4
            },
            {
                "code": "us-ar-009",
                "name": "Boone County, AR",
                "value": 4.4
            },
            {
                "code": "us-ar-011",
                "name": "Bradley County, AR",
                "value": 4.9
            },
            {
                "code": "us-ar-013",
                "name": "Calhoun County, AR",
                "value": 4.7
            },
            {
                "code": "us-ar-015",
                "name": "Carroll County, AR",
                "value": 5
            },
            {
                "code": "us-ar-017",
                "name": "Chicot County, AR",
                "value": 8.7
            },
            {
                "code": "us-ar-019",
                "name": "Clark County, AR",
                "value": 4.4
            },
            {
                "code": "us-ar-021",
                "name": "Clay County, AR",
                "value": 5.6
            },
            {
                "code": "us-ar-023",
                "name": "Cleburne County, AR",
                "value": 5.9
            },
            {
                "code": "us-ar-025",
                "name": "Cleveland County, AR",
                "value": 4.4
            },
            {
                "code": "us-ar-027",
                "name": "Columbia County, AR",
                "value": 5.4
            },
            {
                "code": "us-ar-029",
                "name": "Conway County, AR",
                "value": 5.1
            },
            {
                "code": "us-ar-031",
                "name": "Craighead County, AR",
                "value": 3.6
            },
            {
                "code": "us-ar-033",
                "name": "Crawford County, AR",
                "value": 4.1
            },
            {
                "code": "us-ar-035",
                "name": "Crittenden County, AR",
                "value": 4.9
            },
            {
                "code": "us-ar-037",
                "name": "Cross County, AR",
                "value": 5.2
            },
            {
                "code": "us-ar-039",
                "name": "Dallas County, AR",
                "value": 5.1
            },
            {
                "code": "us-ar-041",
                "name": "Desha County, AR",
                "value": 5.6
            },
            {
                "code": "us-ar-043",
                "name": "Drew County, AR",
                "value": 6.1
            },
            {
                "code": "us-ar-045",
                "name": "Faulkner County, AR",
                "value": 3.8
            },
            {
                "code": "us-ar-047",
                "name": "Franklin County, AR",
                "value": 4
            },
            {
                "code": "us-ar-049",
                "name": "Fulton County, AR",
                "value": 5.2
            },
            {
                "code": "us-ar-051",
                "name": "Garland County, AR",
                "value": 4.7
            },
            {
                "code": "us-ar-053",
                "name": "Grant County, AR",
                "value": 3.6
            },
            {
                "code": "us-ar-055",
                "name": "Greene County, AR",
                "value": 4.2
            },
            {
                "code": "us-ar-057",
                "name": "Hempstead County, AR",
                "value": 3.9
            },
            {
                "code": "us-ar-059",
                "name": "Hot Spring County, AR",
                "value": 4.3
            },
            {
                "code": "us-ar-061",
                "name": "Howard County, AR",
                "value": 3.5
            },
            {
                "code": "us-ar-063",
                "name": "Independence County, AR",
                "value": 4.8
            },
            {
                "code": "us-ar-065",
                "name": "Izard County, AR",
                "value": 6.9
            },
            {
                "code": "us-ar-067",
                "name": "Jackson County, AR",
                "value": 7.6
            },
            {
                "code": "us-ar-069",
                "name": "Jefferson County, AR",
                "value": 5.8
            },
            {
                "code": "us-ar-071",
                "name": "Johnson County, AR",
                "value": 5.4
            },
            {
                "code": "us-ar-073",
                "name": "Lafayette County, AR",
                "value": 6
            },
            {
                "code": "us-ar-075",
                "name": "Lawrence County, AR",
                "value": 4.9
            },
            {
                "code": "us-ar-077",
                "name": "Lee County, AR",
                "value": 6
            },
            {
                "code": "us-ar-079",
                "name": "Lincoln County, AR",
                "value": 5
            },
            {
                "code": "us-ar-081",
                "name": "Little River County, AR",
                "value": 5.4
            },
            {
                "code": "us-ar-083",
                "name": "Logan County, AR",
                "value": 4.5
            },
            {
                "code": "us-ar-085",
                "name": "Lonoke County, AR",
                "value": 3.7
            },
            {
                "code": "us-ar-087",
                "name": "Madison County, AR",
                "value": 3.6
            },
            {
                "code": "us-ar-089",
                "name": "Marion County, AR",
                "value": 5.1
            },
            {
                "code": "us-ar-091",
                "name": "Miller County, AR",
                "value": 5
            },
            {
                "code": "us-ar-093",
                "name": "Mississippi County, AR",
                "value": 6.2
            },
            {
                "code": "us-ar-095",
                "name": "Monroe County, AR",
                "value": 5.2
            },
            {
                "code": "us-ar-097",
                "name": "Montgomery County, AR",
                "value": 6.1
            },
            {
                "code": "us-ar-099",
                "name": "Nevada County, AR",
                "value": 3.8
            },
            {
                "code": "us-ar-101",
                "name": "Newton County, AR",
                "value": 4.5
            },
            {
                "code": "us-ar-103",
                "name": "Ouachita County, AR",
                "value": 5.2
            },
            {
                "code": "us-ar-105",
                "name": "Perry County, AR",
                "value": 5
            },
            {
                "code": "us-ar-107",
                "name": "Phillips County, AR",
                "value": 7.6
            },
            {
                "code": "us-ar-109",
                "name": "Pike County, AR",
                "value": 5.2
            },
            {
                "code": "us-ar-111",
                "name": "Poinsett County, AR",
                "value": 4.9
            },
            {
                "code": "us-ar-113",
                "name": "Polk County, AR",
                "value": 5
            },
            {
                "code": "us-ar-115",
                "name": "Pope County, AR",
                "value": 5.3
            },
            {
                "code": "us-ar-117",
                "name": "Prairie County, AR",
                "value": 4.7
            },
            {
                "code": "us-ar-119",
                "name": "Pulaski County, AR",
                "value": 3.9
            },
            {
                "code": "us-ar-121",
                "name": "Randolph County, AR",
                "value": 5.4
            },
            {
                "code": "us-ar-123",
                "name": "St. Francis County, AR",
                "value": 6.3
            },
            {
                "code": "us-ar-125",
                "name": "Saline County, AR",
                "value": 3.5
            },
            {
                "code": "us-ar-127",
                "name": "Scott County, AR",
                "value": 4.2
            },
            {
                "code": "us-ar-129",
                "name": "Searcy County, AR",
                "value": 5.9
            },
            {
                "code": "us-ar-131",
                "name": "Sebastian County, AR",
                "value": 4.1
            },
            {
                "code": "us-ar-133",
                "name": "Sevier County, AR",
                "value": 5.4
            },
            {
                "code": "us-ar-135",
                "name": "Sharp County, AR",
                "value": 5.7
            },
            {
                "code": "us-ar-137",
                "name": "Stone County, AR",
                "value": 6
            },
            {
                "code": "us-ar-139",
                "name": "Union County, AR",
                "value": 6.2
            },
            {
                "code": "us-ar-141",
                "name": "Van Buren County, AR",
                "value": 6.4
            },
            {
                "code": "us-ar-143",
                "name": "Washington County, AR",
                "value": 2.8
            },
            {
                "code": "us-ar-145",
                "name": "White County, AR",
                "value": 5.3
            },
            {
                "code": "us-ar-147",
                "name": "Woodruff County, AR",
                "value": 5.6
            },
            {
                "code": "us-ar-149",
                "name": "Yell County, AR",
                "value": 5
            },
            {
                "code": "us-ca-001",
                "name": "Alameda County, CA",
                "value": 3.3
            },
            {
                "code": "us-ca-003",
                "name": "Alpine County, CA",
                "value": 4.4
            },
            {
                "code": "us-ca-005",
                "name": "Amador County, CA",
                "value": 4.8
            },
            {
                "code": "us-ca-007",
                "name": "Butte County, CA",
                "value": 5.8
            },
            {
                "code": "us-ca-009",
                "name": "Calaveras County, CA",
                "value": 4.6
            },
            {
                "code": "us-ca-011",
                "name": "Colusa County, CA",
                "value": 18.1
            },
            {
                "code": "us-ca-013",
                "name": "Contra Costa County, CA",
                "value": 3.5
            },
            {
                "code": "us-ca-015",
                "name": "Del Norte County, CA",
                "value": 6.7
            },
            {
                "code": "us-ca-017",
                "name": "El Dorado County, CA",
                "value": 4
            },
            {
                "code": "us-ca-019",
                "name": "Fresno County, CA",
                "value": 8.7
            },
            {
                "code": "us-ca-021",
                "name": "Glenn County, CA",
                "value": 7.8
            },
            {
                "code": "us-ca-023",
                "name": "Humboldt County, CA",
                "value": 4.1
            },
            {
                "code": "us-ca-025",
                "name": "Imperial County, CA",
                "value": 17
            },
            {
                "code": "us-ca-027",
                "name": "Inyo County, CA",
                "value": 4.3
            },
            {
                "code": "us-ca-029",
                "name": "Kern County, CA",
                "value": 9.2
            },
            {
                "code": "us-ca-031",
                "name": "Kings County, CA",
                "value": 9.3
            },
            {
                "code": "us-ca-033",
                "name": "Lake County, CA",
                "value": 6.1
            },
            {
                "code": "us-ca-035",
                "name": "Lassen County, CA",
                "value": 5.8
            },
            {
                "code": "us-ca-037",
                "name": "Los Angeles County, CA",
                "value": 4.9
            },
            {
                "code": "us-ca-039",
                "name": "Madera County, CA",
                "value": 8.3
            },
            {
                "code": "us-ca-041",
                "name": "Marin County, CA",
                "value": 2.6
            },
            {
                "code": "us-ca-043",
                "name": "Mariposa County, CA",
                "value": 6.7
            },
            {
                "code": "us-ca-045",
                "name": "Mendocino County, CA",
                "value": 4.7
            },
            {
                "code": "us-ca-047",
                "name": "Merced County, CA",
                "value": 10
            },
            {
                "code": "us-ca-049",
                "name": "Modoc County, CA",
                "value": 10.8
            },
            {
                "code": "us-ca-051",
                "name": "Mono County, CA",
                "value": 3.9
            },
            {
                "code": "us-ca-053",
                "name": "Monterey County, CA",
                "value": 9.6
            },
            {
                "code": "us-ca-055",
                "name": "Napa County, CA",
                "value": 3.9
            },
            {
                "code": "us-ca-057",
                "name": "Nevada County, CA",
                "value": 3.8
            },
            {
                "code": "us-ca-059",
                "name": "Orange County, CA",
                "value": 3.2
            },
            {
                "code": "us-ca-061",
                "name": "Placer County, CA",
                "value": 3.5
            },
            {
                "code": "us-ca-063",
                "name": "Plumas County, CA",
                "value": 10.7
            },
            {
                "code": "us-ca-065",
                "name": "Riverside County, CA",
                "value": 4.7
            },
            {
                "code": "us-ca-067",
                "name": "Sacramento County, CA",
                "value": 4.3
            },
            {
                "code": "us-ca-069",
                "name": "San Benito County, CA",
                "value": 6
            },
            {
                "code": "us-ca-071",
                "name": "San Bernardino County, CA",
                "value": 4.4
            },
            {
                "code": "us-ca-073",
                "name": "San Diego County, CA",
                "value": 3.6
            },
            {
                "code": "us-ca-075",
                "name": "San Francisco County/city, CA",
                "value": 2.7
            },
            {
                "code": "us-ca-077",
                "name": "San Joaquin County, CA",
                "value": 7.1
            },
            {
                "code": "us-ca-079",
                "name": "San Luis Obispo County, CA",
                "value": 3.4
            },
            {
                "code": "us-ca-081",
                "name": "San Mateo County, CA",
                "value": 2.5
            },
            {
                "code": "us-ca-083",
                "name": "Santa Barbara County, CA",
                "value": 5.2
            },
            {
                "code": "us-ca-085",
                "name": "Santa Clara County, CA",
                "value": 2.9
            },
            {
                "code": "us-ca-087",
                "name": "Santa Cruz County, CA",
                "value": 6.3
            },
            {
                "code": "us-ca-089",
                "name": "Shasta County, CA",
                "value": 5.7
            },
            {
                "code": "us-ca-091",
                "name": "Sierra County, CA",
                "value": 7.4
            },
            {
                "code": "us-ca-093",
                "name": "Siskiyou County, CA",
                "value": 8.7
            },
            {
                "code": "us-ca-095",
                "name": "Solano County, CA",
                "value": 4.5
            },
            {
                "code": "us-ca-097",
                "name": "Sonoma County, CA",
                "value": 3.2
            },
            {
                "code": "us-ca-099",
                "name": "Stanislaus County, CA",
                "value": 7.4
            },
            {
                "code": "us-ca-101",
                "name": "Sutter County, CA",
                "value": 9.5
            },
            {
                "code": "us-ca-103",
                "name": "Tehama County, CA",
                "value": 6.4
            },
            {
                "code": "us-ca-105",
                "name": "Trinity County, CA",
                "value": 6.8
            },
            {
                "code": "us-ca-107",
                "name": "Tulare County, CA",
                "value": 11.1
            },
            {
                "code": "us-ca-109",
                "name": "Tuolumne County, CA",
                "value": 5.5
            },
            {
                "code": "us-ca-111",
                "name": "Ventura County, CA",
                "value": 4.3
            },
            {
                "code": "us-ca-113",
                "name": "Yolo County, CA",
                "value": 5.2
            },
            {
                "code": "us-ca-115",
                "name": "Yuba County, CA",
                "value": 7.6
            },
            {
                "code": "us-co-001",
                "name": "Adams County, CO",
                "value": 3.5
            },
            {
                "code": "us-co-003",
                "name": "Alamosa County, CO",
                "value": 4
            },
            {
                "code": "us-co-005",
                "name": "Arapahoe County, CO",
                "value": 3.1
            },
            {
                "code": "us-co-007",
                "name": "Archuleta County, CO",
                "value": 3.5
            },
            {
                "code": "us-co-009",
                "name": "Baca County, CO",
                "value": 1.6
            },
            {
                "code": "us-co-011",
                "name": "Bent County, CO",
                "value": 3.7
            },
            {
                "code": "us-co-013",
                "name": "Boulder County, CO",
                "value": 2.7
            },
            {
                "code": "us-co-014",
                "name": "Broomfield County/city, CO",
                "value": 2.8
            },
            {
                "code": "us-co-015",
                "name": "Chaffee County, CO",
                "value": 2.8
            },
            {
                "code": "us-co-017",
                "name": "Cheyenne County, CO",
                "value": 1.7
            },
            {
                "code": "us-co-019",
                "name": "Clear Creek County, CO",
                "value": 2.9
            },
            {
                "code": "us-co-021",
                "name": "Conejos County, CO",
                "value": 4.5
            },
            {
                "code": "us-co-023",
                "name": "Costilla County, CO",
                "value": 4.2
            },
            {
                "code": "us-co-025",
                "name": "Crowley County, CO",
                "value": 3.4
            },
            {
                "code": "us-co-027",
                "name": "Custer County, CO",
                "value": 3.8
            },
            {
                "code": "us-co-029",
                "name": "Delta County, CO",
                "value": 4.5
            },
            {
                "code": "us-co-031",
                "name": "Denver County/city, CO",
                "value": 3.1
            },
            {
                "code": "us-co-033",
                "name": "Dolores County, CO",
                "value": 3
            },
            {
                "code": "us-co-035",
                "name": "Douglas County, CO",
                "value": 2.6
            },
            {
                "code": "us-co-037",
                "name": "Eagle County, CO",
                "value": 2.3
            },
            {
                "code": "us-co-039",
                "name": "Elbert County, CO",
                "value": 2.8
            },
            {
                "code": "us-co-041",
                "name": "El Paso County, CO",
                "value": 3.7
            },
            {
                "code": "us-co-043",
                "name": "Fremont County, CO",
                "value": 5.2
            },
            {
                "code": "us-co-045",
                "name": "Garfield County, CO",
                "value": 3.4
            },
            {
                "code": "us-co-047",
                "name": "Gilpin County, CO",
                "value": 2.3
            },
            {
                "code": "us-co-049",
                "name": "Grand County, CO",
                "value": 2.5
            },
            {
                "code": "us-co-051",
                "name": "Gunnison County, CO",
                "value": 2.3
            },
            {
                "code": "us-co-053",
                "name": "Hinsdale County, CO",
                "value": 3
            },
            {
                "code": "us-co-055",
                "name": "Huerfano County, CO",
                "value": 7.3
            },
            {
                "code": "us-co-057",
                "name": "Jackson County, CO",
                "value": 2.1
            },
            {
                "code": "us-co-059",
                "name": "Jefferson County, CO",
                "value": 2.9
            },
            {
                "code": "us-co-061",
                "name": "Kiowa County, CO",
                "value": 1.8
            },
            {
                "code": "us-co-063",
                "name": "Kit Carson County, CO",
                "value": 1.9
            },
            {
                "code": "us-co-065",
                "name": "Lake County, CO",
                "value": 2.1
            },
            {
                "code": "us-co-067",
                "name": "La Plata County, CO",
                "value": 3
            },
            {
                "code": "us-co-069",
                "name": "Larimer County, CO",
                "value": 2.8
            },
            {
                "code": "us-co-071",
                "name": "Las Animas County, CO",
                "value": 4.6
            },
            {
                "code": "us-co-073",
                "name": "Lincoln County, CO",
                "value": 2.5
            },
            {
                "code": "us-co-075",
                "name": "Logan County, CO",
                "value": 2.7
            },
            {
                "code": "us-co-077",
                "name": "Mesa County, CO",
                "value": 4.6
            },
            {
                "code": "us-co-079",
                "name": "Mineral County, CO",
                "value": 1.7
            },
            {
                "code": "us-co-081",
                "name": "Moffat County, CO",
                "value": 4.1
            },
            {
                "code": "us-co-083",
                "name": "Montezuma County, CO",
                "value": 5.8
            },
            {
                "code": "us-co-085",
                "name": "Montrose County, CO",
                "value": 4
            },
            {
                "code": "us-co-087",
                "name": "Morgan County, CO",
                "value": 2.7
            },
            {
                "code": "us-co-089",
                "name": "Otero County, CO",
                "value": 5.1
            },
            {
                "code": "us-co-091",
                "name": "Ouray County, CO",
                "value": 3.5
            },
            {
                "code": "us-co-093",
                "name": "Park County, CO",
                "value": 3
            },
            {
                "code": "us-co-095",
                "name": "Phillips County, CO",
                "value": 1.7
            },
            {
                "code": "us-co-097",
                "name": "Pitkin County, CO",
                "value": 2.5
            },
            {
                "code": "us-co-099",
                "name": "Prowers County, CO",
                "value": 2.7
            },
            {
                "code": "us-co-101",
                "name": "Pueblo County, CO",
                "value": 4.8
            },
            {
                "code": "us-co-103",
                "name": "Rio Blanco County, CO",
                "value": 4.4
            },
            {
                "code": "us-co-105",
                "name": "Rio Grande County, CO",
                "value": 5.5
            },
            {
                "code": "us-co-107",
                "name": "Routt County, CO",
                "value": 2.3
            },
            {
                "code": "us-co-109",
                "name": "Saguache County, CO",
                "value": 4.7
            },
            {
                "code": "us-co-111",
                "name": "San Juan County, CO",
                "value": 3.2
            },
            {
                "code": "us-co-113",
                "name": "San Miguel County, CO",
                "value": 1.9
            },
            {
                "code": "us-co-115",
                "name": "Sedgwick County, CO",
                "value": 2.7
            },
            {
                "code": "us-co-117",
                "name": "Summit County, CO",
                "value": 1.7
            },
            {
                "code": "us-co-119",
                "name": "Teller County, CO",
                "value": 3.5
            },
            {
                "code": "us-co-121",
                "name": "Washington County, CO",
                "value": 2.2
            },
            {
                "code": "us-co-123",
                "name": "Weld County, CO",
                "value": 3
            },
            {
                "code": "us-co-125",
                "name": "Yuma County, CO",
                "value": 1.9
            },
            {
                "code": "us-ct-001",
                "name": "Fairfield County, CT",
                "value": 5
            },
            {
                "code": "us-ct-003",
                "name": "Hartford County, CT",
                "value": 5.3
            },
            {
                "code": "us-ct-005",
                "name": "Litchfield County, CT",
                "value": 5.3
            },
            {
                "code": "us-ct-007",
                "name": "Middlesex County, CT",
                "value": 4.7
            },
            {
                "code": "us-ct-009",
                "name": "New Haven County, CT",
                "value": 5.5
            },
            {
                "code": "us-ct-011",
                "name": "New London County, CT",
                "value": 5.2
            },
            {
                "code": "us-ct-013",
                "name": "Tolland County, CT",
                "value": 4.8
            },
            {
                "code": "us-ct-015",
                "name": "Windham County, CT",
                "value": 5.9
            },
            {
                "code": "us-de-001",
                "name": "Kent County, DE",
                "value": 4.8
            },
            {
                "code": "us-de-003",
                "name": "New Castle County, DE",
                "value": 4.2
            },
            {
                "code": "us-de-005",
                "name": "Sussex County, DE",
                "value": 5.2
            },
            {
                "code": "us-ia-001",
                "name": "District of Columbia",
                "value": 5.9
            },
            {
                "code": "us-fl-001",
                "name": "Alachua County, FL",
                "value": 3.9
            },
            {
                "code": "us-fl-003",
                "name": "Baker County, FL",
                "value": 4.2
            },
            {
                "code": "us-fl-005",
                "name": "Bay County, FL",
                "value": 4.5
            },
            {
                "code": "us-fl-007",
                "name": "Bradford County, FL",
                "value": 3.9
            },
            {
                "code": "us-fl-009",
                "name": "Brevard County, FL",
                "value": 4.2
            },
            {
                "code": "us-fl-011",
                "name": "Broward County, FL",
                "value": 3.9
            },
            {
                "code": "us-fl-013",
                "name": "Calhoun County, FL",
                "value": 4.9
            },
            {
                "code": "us-fl-015",
                "name": "Charlotte County, FL",
                "value": 4.5
            },
            {
                "code": "us-fl-017",
                "name": "Citrus County, FL",
                "value": 6.1
            },
            {
                "code": "us-fl-019",
                "name": "Clay County, FL",
                "value": 3.8
            },
            {
                "code": "us-fl-021",
                "name": "Collier County, FL",
                "value": 3.8
            },
            {
                "code": "us-fl-023",
                "name": "Columbia County, FL",
                "value": 4.3
            },
            {
                "code": "us-fl-027",
                "name": "DeSoto County, FL",
                "value": 4.4
            },
            {
                "code": "us-fl-029",
                "name": "Dixie County, FL",
                "value": 5.1
            },
            {
                "code": "us-fl-031",
                "name": "Duval County, FL",
                "value": 4.1
            },
            {
                "code": "us-fl-033",
                "name": "Escambia County, FL",
                "value": 4.4
            },
            {
                "code": "us-fl-035",
                "name": "Flagler County, FL",
                "value": 4.7
            },
            {
                "code": "us-fl-037",
                "name": "Franklin County, FL",
                "value": 3.7
            },
            {
                "code": "us-fl-039",
                "name": "Gadsden County, FL",
                "value": 5.4
            },
            {
                "code": "us-fl-041",
                "name": "Gilchrist County, FL",
                "value": 4.6
            },
            {
                "code": "us-fl-043",
                "name": "Glades County, FL",
                "value": 4.5
            },
            {
                "code": "us-fl-045",
                "name": "Gulf County, FL",
                "value": 4.4
            },
            {
                "code": "us-fl-047",
                "name": "Hamilton County, FL",
                "value": 5.1
            },
            {
                "code": "us-fl-049",
                "name": "Hardee County, FL",
                "value": 5.5
            },
            {
                "code": "us-fl-051",
                "name": "Hendry County, FL",
                "value": 6.2
            },
            {
                "code": "us-fl-053",
                "name": "Hernando County, FL",
                "value": 5.3
            },
            {
                "code": "us-fl-055",
                "name": "Highlands County, FL",
                "value": 5.4
            },
            {
                "code": "us-fl-057",
                "name": "Hillsborough County, FL",
                "value": 3.9
            },
            {
                "code": "us-fl-059",
                "name": "Holmes County, FL",
                "value": 4.7
            },
            {
                "code": "us-fl-061",
                "name": "Indian River County, FL",
                "value": 4.8
            },
            {
                "code": "us-fl-063",
                "name": "Jackson County, FL",
                "value": 4.5
            },
            {
                "code": "us-fl-065",
                "name": "Jefferson County, FL",
                "value": 4.3
            },
            {
                "code": "us-fl-067",
                "name": "Lafayette County, FL",
                "value": 3.7
            },
            {
                "code": "us-fl-069",
                "name": "Lake County, FL",
                "value": 4.1
            },
            {
                "code": "us-fl-071",
                "name": "Lee County, FL",
                "value": 3.9
            },
            {
                "code": "us-fl-073",
                "name": "Leon County, FL",
                "value": 3.9
            },
            {
                "code": "us-fl-075",
                "name": "Levy County, FL",
                "value": 4.5
            },
            {
                "code": "us-fl-077",
                "name": "Liberty County, FL",
                "value": 4.7
            },
            {
                "code": "us-fl-079",
                "name": "Madison County, FL",
                "value": 4.5
            },
            {
                "code": "us-fl-081",
                "name": "Manatee County, FL",
                "value": 3.9
            },
            {
                "code": "us-fl-083",
                "name": "Marion County, FL",
                "value": 5
            },
            {
                "code": "us-fl-085",
                "name": "Martin County, FL",
                "value": 4.1
            },
            {
                "code": "us-fl-086",
                "name": "Miami-Dade County, FL",
                "value": 4.1
            },
            {
                "code": "us-fl-087",
                "name": "Monroe County, FL",
                "value": 3.4
            },
            {
                "code": "us-fl-089",
                "name": "Nassau County, FL",
                "value": 3.8
            },
            {
                "code": "us-fl-091",
                "name": "Okaloosa County, FL",
                "value": 3.7
            },
            {
                "code": "us-fl-093",
                "name": "Okeechobee County, FL",
                "value": 4.2
            },
            {
                "code": "us-fl-095",
                "name": "Orange County, FL",
                "value": 3.7
            },
            {
                "code": "us-fl-097",
                "name": "Osceola County, FL",
                "value": 4.3
            },
            {
                "code": "us-fl-099",
                "name": "Palm Beach County, FL",
                "value": 4
            },
            {
                "code": "us-fl-101",
                "name": "Pasco County, FL",
                "value": 4.5
            },
            {
                "code": "us-fl-103",
                "name": "Pinellas County, FL",
                "value": 3.8
            },
            {
                "code": "us-fl-105",
                "name": "Polk County, FL",
                "value": 4.8
            },
            {
                "code": "us-fl-107",
                "name": "Putnam County, FL",
                "value": 5.6
            },
            {
                "code": "us-fl-109",
                "name": "St. Johns County, FL",
                "value": 3.4
            },
            {
                "code": "us-fl-111",
                "name": "St. Lucie County, FL",
                "value": 5.1
            },
            {
                "code": "us-fl-113",
                "name": "Santa Rosa County, FL",
                "value": 4.2
            },
            {
                "code": "us-fl-115",
                "name": "Sarasota County, FL",
                "value": 3.9
            },
            {
                "code": "us-fl-117",
                "name": "Seminole County, FL",
                "value": 3.7
            },
            {
                "code": "us-fl-119",
                "name": "Sumter County, FL",
                "value": 5.9
            },
            {
                "code": "us-fl-121",
                "name": "Suwannee County, FL",
                "value": 4.4
            },
            {
                "code": "us-fl-123",
                "name": "Taylor County, FL",
                "value": 4.4
            },
            {
                "code": "us-fl-125",
                "name": "Union County, FL",
                "value": 4.1
            },
            {
                "code": "us-fl-127",
                "name": "Volusia County, FL",
                "value": 4.4
            },
            {
                "code": "us-fl-129",
                "name": "Wakulla County, FL",
                "value": 3.7
            },
            {
                "code": "us-fl-131",
                "name": "Walton County, FL",
                "value": 3.9
            },
            {
                "code": "us-fl-133",
                "name": "Washington County, FL",
                "value": 4.7
            },
            {
                "code": "us-ga-001",
                "name": "Appling County, GA",
                "value": 5.3
            },
            {
                "code": "us-ga-003",
                "name": "Atkinson County, GA",
                "value": 4.6
            },
            {
                "code": "us-ga-005",
                "name": "Bacon County, GA",
                "value": 4.4
            },
            {
                "code": "us-ga-007",
                "name": "Baker County, GA",
                "value": 5.7
            },
            {
                "code": "us-ga-009",
                "name": "Baldwin County, GA",
                "value": 6.1
            },
            {
                "code": "us-ga-011",
                "name": "Banks County, GA",
                "value": 3.4
            },
            {
                "code": "us-ga-013",
                "name": "Barrow County, GA",
                "value": 3.7
            },
            {
                "code": "us-ga-015",
                "name": "Bartow County, GA",
                "value": 4.3
            },
            {
                "code": "us-ga-017",
                "name": "Ben Hill County, GA",
                "value": 7.3
            },
            {
                "code": "us-ga-019",
                "name": "Berrien County, GA",
                "value": 4.8
            },
            {
                "code": "us-ga-021",
                "name": "Bibb County, GA",
                "value": 5.1
            },
            {
                "code": "us-ga-023",
                "name": "Bleckley County, GA",
                "value": 6.4
            },
            {
                "code": "us-ga-025",
                "name": "Brantley County, GA",
                "value": 5.1
            },
            {
                "code": "us-ga-027",
                "name": "Brooks County, GA",
                "value": 4.3
            },
            {
                "code": "us-ga-029",
                "name": "Bryan County, GA",
                "value": 3.8
            },
            {
                "code": "us-ga-031",
                "name": "Bulloch County, GA",
                "value": 4.5
            },
            {
                "code": "us-ga-033",
                "name": "Burke County, GA",
                "value": 7.5
            },
            {
                "code": "us-ga-035",
                "name": "Butts County, GA",
                "value": 4.7
            },
            {
                "code": "us-ga-037",
                "name": "Calhoun County, GA",
                "value": 4.5
            },
            {
                "code": "us-ga-039",
                "name": "Camden County, GA",
                "value": 4.6
            },
            {
                "code": "us-ga-043",
                "name": "Candler County, GA",
                "value": 3.9
            },
            {
                "code": "us-ga-045",
                "name": "Carroll County, GA",
                "value": 4.6
            },
            {
                "code": "us-ga-047",
                "name": "Catoosa County, GA",
                "value": 3.8
            },
            {
                "code": "us-ga-049",
                "name": "Charlton County, GA",
                "value": 5.1
            },
            {
                "code": "us-ga-051",
                "name": "Chatham County, GA",
                "value": 4.2
            },
            {
                "code": "us-ga-053",
                "name": "Chattahoochee County, GA",
                "value": 6.5
            },
            {
                "code": "us-ga-055",
                "name": "Chattooga County, GA",
                "value": 4.8
            },
            {
                "code": "us-ga-057",
                "name": "Cherokee County, GA",
                "value": 3.4
            },
            {
                "code": "us-ga-059",
                "name": "Clarke County, GA",
                "value": 4.2
            },
            {
                "code": "us-ga-061",
                "name": "Clay County, GA",
                "value": 8
            },
            {
                "code": "us-ga-063",
                "name": "Clayton County, GA",
                "value": 5.6
            },
            {
                "code": "us-ga-065",
                "name": "Clinch County, GA",
                "value": 6
            },
            {
                "code": "us-ga-067",
                "name": "Cobb County, GA",
                "value": 3.8
            },
            {
                "code": "us-ga-069",
                "name": "Coffee County, GA",
                "value": 6.1
            },
            {
                "code": "us-ga-071",
                "name": "Colquitt County, GA",
                "value": 4.6
            },
            {
                "code": "us-ga-073",
                "name": "Columbia County, GA",
                "value": 3.8
            },
            {
                "code": "us-ga-075",
                "name": "Cook County, GA",
                "value": 4.2
            },
            {
                "code": "us-ga-077",
                "name": "Coweta County, GA",
                "value": 3.7
            },
            {
                "code": "us-ga-079",
                "name": "Crawford County, GA",
                "value": 5.2
            },
            {
                "code": "us-ga-081",
                "name": "Crisp County, GA",
                "value": 5.2
            },
            {
                "code": "us-ga-083",
                "name": "Dade County, GA",
                "value": 4
            },
            {
                "code": "us-ga-085",
                "name": "Dawson County, GA",
                "value": 3.6
            },
            {
                "code": "us-ga-087",
                "name": "Decatur County, GA",
                "value": 5.4
            },
            {
                "code": "us-ga-089",
                "name": "DeKalb County, GA",
                "value": 4.6
            },
            {
                "code": "us-ga-091",
                "name": "Dodge County, GA",
                "value": 5.7
            },
            {
                "code": "us-ga-093",
                "name": "Dooly County, GA",
                "value": 4.9
            },
            {
                "code": "us-ga-095",
                "name": "Dougherty County, GA",
                "value": 5.5
            },
            {
                "code": "us-ga-097",
                "name": "Douglas County, GA",
                "value": 4.6
            },
            {
                "code": "us-ga-099",
                "name": "Early County, GA",
                "value": 5.3
            },
            {
                "code": "us-ga-101",
                "name": "Echols County, GA",
                "value": 3.3
            },
            {
                "code": "us-ga-103",
                "name": "Effingham County, GA",
                "value": 3.7
            },
            {
                "code": "us-ga-105",
                "name": "Elbert County, GA",
                "value": 8.5
            },
            {
                "code": "us-ga-107",
                "name": "Emanuel County, GA",
                "value": 6.7
            },
            {
                "code": "us-ga-109",
                "name": "Evans County, GA",
                "value": 4.1
            },
            {
                "code": "us-ga-111",
                "name": "Fannin County, GA",
                "value": 4.8
            },
            {
                "code": "us-ga-113",
                "name": "Fayette County, GA",
                "value": 3.7
            },
            {
                "code": "us-ga-115",
                "name": "Floyd County, GA",
                "value": 4.6
            },
            {
                "code": "us-ga-117",
                "name": "Forsyth County, GA",
                "value": 3.4
            },
            {
                "code": "us-ga-119",
                "name": "Franklin County, GA",
                "value": 4.4
            },
            {
                "code": "us-ga-121",
                "name": "Fulton County, GA",
                "value": 4.5
            },
            {
                "code": "us-ga-123",
                "name": "Gilmer County, GA",
                "value": 5.1
            },
            {
                "code": "us-ga-125",
                "name": "Glascock County, GA",
                "value": 4.6
            },
            {
                "code": "us-ga-127",
                "name": "Glynn County, GA",
                "value": 4.2
            },
            {
                "code": "us-ga-129",
                "name": "Gordon County, GA",
                "value": 4.3
            },
            {
                "code": "us-ga-131",
                "name": "Grady County, GA",
                "value": 4.2
            },
            {
                "code": "us-ga-133",
                "name": "Greene County, GA",
                "value": 4.7
            },
            {
                "code": "us-ga-135",
                "name": "Gwinnett County, GA",
                "value": 3.9
            },
            {
                "code": "us-ga-137",
                "name": "Habersham County, GA",
                "value": 4.2
            },
            {
                "code": "us-ga-139",
                "name": "Hall County, GA",
                "value": 3.6
            },
            {
                "code": "us-ga-141",
                "name": "Hancock County, GA",
                "value": 7.5
            },
            {
                "code": "us-ga-143",
                "name": "Haralson County, GA",
                "value": 4.3
            },
            {
                "code": "us-ga-145",
                "name": "Harris County, GA",
                "value": 4
            },
            {
                "code": "us-ga-147",
                "name": "Hart County, GA",
                "value": 4
            },
            {
                "code": "us-ga-149",
                "name": "Heard County, GA",
                "value": 4.4
            },
            {
                "code": "us-ga-151",
                "name": "Henry County, GA",
                "value": 4.6
            },
            {
                "code": "us-ga-153",
                "name": "Houston County, GA",
                "value": 4.6
            },
            {
                "code": "us-ga-155",
                "name": "Irwin County, GA",
                "value": 6.5
            },
            {
                "code": "us-ga-157",
                "name": "Jackson County, GA",
                "value": 3.3
            },
            {
                "code": "us-ga-159",
                "name": "Jasper County, GA",
                "value": 3.9
            },
            {
                "code": "us-ga-161",
                "name": "Jeff Davis County, GA",
                "value": 5.6
            },
            {
                "code": "us-ga-163",
                "name": "Jefferson County, GA",
                "value": 6.5
            },
            {
                "code": "us-ga-165",
                "name": "Jenkins County, GA",
                "value": 6.5
            },
            {
                "code": "us-ga-167",
                "name": "Johnson County, GA",
                "value": 4.7
            },
            {
                "code": "us-ga-169",
                "name": "Jones County, GA",
                "value": 4.2
            },
            {
                "code": "us-ga-171",
                "name": "Lamar County, GA",
                "value": 5
            },
            {
                "code": "us-ga-173",
                "name": "Lanier County, GA",
                "value": 5.1
            },
            {
                "code": "us-ga-175",
                "name": "Laurens County, GA",
                "value": 5.6
            },
            {
                "code": "us-ga-177",
                "name": "Lee County, GA",
                "value": 4
            },
            {
                "code": "us-ga-179",
                "name": "Liberty County, GA",
                "value": 4.9
            },
            {
                "code": "us-ga-181",
                "name": "Lincoln County, GA",
                "value": 6.2
            },
            {
                "code": "us-ga-183",
                "name": "Long County, GA",
                "value": 4.4
            },
            {
                "code": "us-ga-185",
                "name": "Lowndes County, GA",
                "value": 4.4
            },
            {
                "code": "us-ga-187",
                "name": "Lumpkin County, GA",
                "value": 3.8
            },
            {
                "code": "us-ga-189",
                "name": "McDuffie County, GA",
                "value": 6.5
            },
            {
                "code": "us-ga-191",
                "name": "McIntosh County, GA",
                "value": 4.6
            },
            {
                "code": "us-ga-193",
                "name": "Macon County, GA",
                "value": 7.1
            },
            {
                "code": "us-ga-195",
                "name": "Madison County, GA",
                "value": 3.9
            },
            {
                "code": "us-ga-197",
                "name": "Marion County, GA",
                "value": 5.4
            },
            {
                "code": "us-ga-199",
                "name": "Meriwether County, GA",
                "value": 5.7
            },
            {
                "code": "us-ga-201",
                "name": "Miller County, GA",
                "value": 4.4
            },
            {
                "code": "us-ga-205",
                "name": "Mitchell County, GA",
                "value": 5.8
            },
            {
                "code": "us-ga-207",
                "name": "Monroe County, GA",
                "value": 4.4
            },
            {
                "code": "us-ga-209",
                "name": "Montgomery County, GA",
                "value": 6.9
            },
            {
                "code": "us-ga-211",
                "name": "Morgan County, GA",
                "value": 4.3
            },
            {
                "code": "us-ga-213",
                "name": "Murray County, GA",
                "value": 6.9
            },
            {
                "code": "us-ga-215",
                "name": "Muscogee County, GA",
                "value": 6.2
            },
            {
                "code": "us-ga-217",
                "name": "Newton County, GA",
                "value": 5.1
            },
            {
                "code": "us-ga-219",
                "name": "Oconee County, GA",
                "value": 3.1
            },
            {
                "code": "us-ga-221",
                "name": "Oglethorpe County, GA",
                "value": 4.2
            },
            {
                "code": "us-ga-223",
                "name": "Paulding County, GA",
                "value": 3.8
            },
            {
                "code": "us-ga-225",
                "name": "Peach County, GA",
                "value": 6.1
            },
            {
                "code": "us-ga-227",
                "name": "Pickens County, GA",
                "value": 3.9
            },
            {
                "code": "us-ga-229",
                "name": "Pierce County, GA",
                "value": 4.2
            },
            {
                "code": "us-ga-231",
                "name": "Pike County, GA",
                "value": 4
            },
            {
                "code": "us-ga-233",
                "name": "Polk County, GA",
                "value": 4.7
            },
            {
                "code": "us-ga-235",
                "name": "Pulaski County, GA",
                "value": 4.7
            },
            {
                "code": "us-ga-237",
                "name": "Putnam County, GA",
                "value": 5.7
            },
            {
                "code": "us-ga-239",
                "name": "Quitman County, GA",
                "value": 5.8
            },
            {
                "code": "us-ga-241",
                "name": "Rabun County, GA",
                "value": 5.1
            },
            {
                "code": "us-ga-243",
                "name": "Randolph County, GA",
                "value": 5.7
            },
            {
                "code": "us-ga-245",
                "name": "Richmond County, GA",
                "value": 6.1
            },
            {
                "code": "us-ga-247",
                "name": "Rockdale County, GA",
                "value": 4.9
            },
            {
                "code": "us-ga-249",
                "name": "Schley County, GA",
                "value": 5
            },
            {
                "code": "us-ga-251",
                "name": "Screven County, GA",
                "value": 6.4
            },
            {
                "code": "us-ga-253",
                "name": "Seminole County, GA",
                "value": 6.1
            },
            {
                "code": "us-ga-255",
                "name": "Spalding County, GA",
                "value": 5.5
            },
            {
                "code": "us-ga-257",
                "name": "Stephens County, GA",
                "value": 5.2
            },
            {
                "code": "us-ga-259",
                "name": "Stewart County, GA",
                "value": 5.7
            },
            {
                "code": "us-ga-261",
                "name": "Sumter County, GA",
                "value": 6.6
            },
            {
                "code": "us-ga-263",
                "name": "Talbot County, GA",
                "value": 6
            },
            {
                "code": "us-ga-265",
                "name": "Taliaferro County, GA",
                "value": 6.6
            },
            {
                "code": "us-ga-267",
                "name": "Tattnall County, GA",
                "value": 4.8
            },
            {
                "code": "us-ga-269",
                "name": "Taylor County, GA",
                "value": 8.8
            },
            {
                "code": "us-ga-271",
                "name": "Telfair County, GA",
                "value": 6.5
            },
            {
                "code": "us-ga-273",
                "name": "Terrell County, GA",
                "value": 5.5
            },
            {
                "code": "us-ga-275",
                "name": "Thomas County, GA",
                "value": 5.4
            },
            {
                "code": "us-ga-277",
                "name": "Tift County, GA",
                "value": 4.5
            },
            {
                "code": "us-ga-279",
                "name": "Toombs County, GA",
                "value": 6.9
            },
            {
                "code": "us-ga-281",
                "name": "Towns County, GA",
                "value": 6.1
            },
            {
                "code": "us-ga-283",
                "name": "Treutlen County, GA",
                "value": 6.6
            },
            {
                "code": "us-ga-285",
                "name": "Troup County, GA",
                "value": 4.5
            },
            {
                "code": "us-ga-287",
                "name": "Turner County, GA",
                "value": 6.5
            },
            {
                "code": "us-ga-289",
                "name": "Twiggs County, GA",
                "value": 7.8
            },
            {
                "code": "us-ga-291",
                "name": "Union County, GA",
                "value": 4.1
            },
            {
                "code": "us-ga-293",
                "name": "Upson County, GA",
                "value": 5.5
            },
            {
                "code": "us-ga-295",
                "name": "Walker County, GA",
                "value": 4.3
            },
            {
                "code": "us-ga-297",
                "name": "Walton County, GA",
                "value": 3.9
            },
            {
                "code": "us-ga-299",
                "name": "Ware County, GA",
                "value": 4.3
            },
            {
                "code": "us-ga-301",
                "name": "Warren County, GA",
                "value": 5.2
            },
            {
                "code": "us-ga-303",
                "name": "Washington County, GA",
                "value": 6.2
            },
            {
                "code": "us-ga-305",
                "name": "Wayne County, GA",
                "value": 5.3
            },
            {
                "code": "us-ga-307",
                "name": "Webster County, GA",
                "value": 7.5
            },
            {
                "code": "us-ga-309",
                "name": "Wheeler County, GA",
                "value": 7.7
            },
            {
                "code": "us-ga-311",
                "name": "White County, GA",
                "value": 3.7
            },
            {
                "code": "us-ga-313",
                "name": "Whitfield County, GA",
                "value": 6.5
            },
            {
                "code": "us-ga-315",
                "name": "Wilcox County, GA",
                "value": 6.1
            },
            {
                "code": "us-ga-317",
                "name": "Wilkes County, GA",
                "value": 5.8
            },
            {
                "code": "us-ga-319",
                "name": "Wilkinson County, GA",
                "value": 5.9
            },
            {
                "code": "us-ga-321",
                "name": "Worth County, GA",
                "value": 4.7
            },
            {
                "code": "us-hi-001",
                "name": "Hawaii County, HI",
                "value": 2.6
            },
            {
                "code": "us-hi-003",
                "name": "Honolulu County/city, HI",
                "value": 2.3
            },
            {
                "code": "us-hi-007",
                "name": "Kauai County, HI",
                "value": 2.2
            },
            {
                "code": "us-hi-009",
                "name": "Maui County, HI",
                "value": 2.4
            },
            {
                "code": "us-id-001",
                "name": "Ada County, ID",
                "value": 3.3
            },
            {
                "code": "us-id-003",
                "name": "Adams County, ID",
                "value": 6.5
            },
            {
                "code": "us-id-005",
                "name": "Bannock County, ID",
                "value": 3.8
            },
            {
                "code": "us-id-007",
                "name": "Bear Lake County, ID",
                "value": 4.4
            },
            {
                "code": "us-id-009",
                "name": "Benewah County, ID",
                "value": 5.9
            },
            {
                "code": "us-id-011",
                "name": "Bingham County, ID",
                "value": 4.1
            },
            {
                "code": "us-id-013",
                "name": "Blaine County, ID",
                "value": 3
            },
            {
                "code": "us-id-015",
                "name": "Boise County, ID",
                "value": 6.3
            },
            {
                "code": "us-id-017",
                "name": "Bonner County, ID",
                "value": 5.7
            },
            {
                "code": "us-id-019",
                "name": "Bonneville County, ID",
                "value": 3.4
            },
            {
                "code": "us-id-021",
                "name": "Boundary County, ID",
                "value": 6.6
            },
            {
                "code": "us-id-023",
                "name": "Butte County, ID",
                "value": 4.5
            },
            {
                "code": "us-id-025",
                "name": "Camas County, ID",
                "value": 4
            },
            {
                "code": "us-id-027",
                "name": "Canyon County, ID",
                "value": 4.5
            },
            {
                "code": "us-id-029",
                "name": "Caribou County, ID",
                "value": 4.3
            },
            {
                "code": "us-id-031",
                "name": "Cassia County, ID",
                "value": 3.1
            },
            {
                "code": "us-id-033",
                "name": "Clark County, ID",
                "value": 4.3
            },
            {
                "code": "us-id-035",
                "name": "Clearwater County, ID",
                "value": 7.9
            },
            {
                "code": "us-id-037",
                "name": "Custer County, ID",
                "value": 6.8
            },
            {
                "code": "us-id-039",
                "name": "Elmore County, ID",
                "value": 4.7
            },
            {
                "code": "us-id-041",
                "name": "Franklin County, ID",
                "value": 2.9
            },
            {
                "code": "us-id-043",
                "name": "Fremont County, ID",
                "value": 3.9
            },
            {
                "code": "us-id-045",
                "name": "Gem County, ID",
                "value": 4.9
            },
            {
                "code": "us-id-047",
                "name": "Gooding County, ID",
                "value": 3.6
            },
            {
                "code": "us-id-049",
                "name": "Idaho County, ID",
                "value": 6.3
            },
            {
                "code": "us-id-051",
                "name": "Jefferson County, ID",
                "value": 3.4
            },
            {
                "code": "us-id-053",
                "name": "Jerome County, ID",
                "value": 3.5
            },
            {
                "code": "us-id-055",
                "name": "Kootenai County, ID",
                "value": 5.2
            },
            {
                "code": "us-id-057",
                "name": "Latah County, ID",
                "value": 3.1
            },
            {
                "code": "us-id-059",
                "name": "Lemhi County, ID",
                "value": 7.2
            },
            {
                "code": "us-id-061",
                "name": "Lewis County, ID",
                "value": 7.1
            },
            {
                "code": "us-id-063",
                "name": "Lincoln County, ID",
                "value": 5.3
            },
            {
                "code": "us-id-065",
                "name": "Madison County, ID",
                "value": 2.3
            },
            {
                "code": "us-id-067",
                "name": "Minidoka County, ID",
                "value": 3.7
            },
            {
                "code": "us-id-069",
                "name": "Nez Perce County, ID",
                "value": 3.6
            },
            {
                "code": "us-id-071",
                "name": "Oneida County, ID",
                "value": 3.2
            },
            {
                "code": "us-id-073",
                "name": "Owyhee County, ID",
                "value": 5.8
            },
            {
                "code": "us-id-075",
                "name": "Payette County, ID",
                "value": 5
            },
            {
                "code": "us-id-077",
                "name": "Power County, ID",
                "value": 4.9
            },
            {
                "code": "us-id-079",
                "name": "Shoshone County, ID",
                "value": 7.4
            },
            {
                "code": "us-id-081",
                "name": "Teton County, ID",
                "value": 3
            },
            {
                "code": "us-id-083",
                "name": "Twin Falls County, ID",
                "value": 3.6
            },
            {
                "code": "us-id-085",
                "name": "Valley County, ID",
                "value": 5.8
            },
            {
                "code": "us-id-087",
                "name": "Washington County, ID",
                "value": 5.6
            },
            {
                "code": "us-il-001",
                "name": "Adams County, IL",
                "value": 4.4
            },
            {
                "code": "us-il-003",
                "name": "Alexander County, IL",
                "value": 8.5
            },
            {
                "code": "us-il-005",
                "name": "Bond County, IL",
                "value": 5.1
            },
            {
                "code": "us-il-007",
                "name": "Boone County, IL",
                "value": 6.5
            },
            {
                "code": "us-il-009",
                "name": "Brown County, IL",
                "value": 3.1
            },
            {
                "code": "us-il-011",
                "name": "Bureau County, IL",
                "value": 6.1
            },
            {
                "code": "us-il-013",
                "name": "Calhoun County, IL",
                "value": 6.3
            },
            {
                "code": "us-il-015",
                "name": "Carroll County, IL",
                "value": 5.4
            },
            {
                "code": "us-il-017",
                "name": "Cass County, IL",
                "value": 5.3
            },
            {
                "code": "us-il-019",
                "name": "Champaign County, IL",
                "value": 4.6
            },
            {
                "code": "us-il-021",
                "name": "Christian County, IL",
                "value": 6
            },
            {
                "code": "us-il-023",
                "name": "Clark County, IL",
                "value": 6.1
            },
            {
                "code": "us-il-025",
                "name": "Clay County, IL",
                "value": 6.1
            },
            {
                "code": "us-il-027",
                "name": "Clinton County, IL",
                "value": 4.5
            },
            {
                "code": "us-il-029",
                "name": "Coles County, IL",
                "value": 4.9
            },
            {
                "code": "us-il-031",
                "name": "Cook County, IL",
                "value": 5
            },
            {
                "code": "us-il-033",
                "name": "Crawford County, IL",
                "value": 5.9
            },
            {
                "code": "us-il-035",
                "name": "Cumberland County, IL",
                "value": 5
            },
            {
                "code": "us-il-037",
                "name": "DeKalb County, IL",
                "value": 4.9
            },
            {
                "code": "us-il-039",
                "name": "De Witt County, IL",
                "value": 5.7
            },
            {
                "code": "us-il-041",
                "name": "Douglas County, IL",
                "value": 4.5
            },
            {
                "code": "us-il-043",
                "name": "DuPage County, IL",
                "value": 3.9
            },
            {
                "code": "us-il-045",
                "name": "Edgar County, IL",
                "value": 5.2
            },
            {
                "code": "us-il-047",
                "name": "Edwards County, IL",
                "value": 5.2
            },
            {
                "code": "us-il-049",
                "name": "Effingham County, IL",
                "value": 4.6
            },
            {
                "code": "us-il-051",
                "name": "Fayette County, IL",
                "value": 6.7
            },
            {
                "code": "us-il-053",
                "name": "Ford County, IL",
                "value": 5.5
            },
            {
                "code": "us-il-055",
                "name": "Franklin County, IL",
                "value": 6.7
            },
            {
                "code": "us-il-057",
                "name": "Fulton County, IL",
                "value": 7.4
            },
            {
                "code": "us-il-059",
                "name": "Gallatin County, IL",
                "value": 5.9
            },
            {
                "code": "us-il-061",
                "name": "Greene County, IL",
                "value": 5.6
            },
            {
                "code": "us-il-063",
                "name": "Grundy County, IL",
                "value": 7.1
            },
            {
                "code": "us-il-065",
                "name": "Hamilton County, IL",
                "value": 5.1
            },
            {
                "code": "us-il-067",
                "name": "Hancock County, IL",
                "value": 5.6
            },
            {
                "code": "us-il-069",
                "name": "Hardin County, IL",
                "value": 8.6
            },
            {
                "code": "us-il-071",
                "name": "Henderson County, IL",
                "value": 6.5
            },
            {
                "code": "us-il-073",
                "name": "Henry County, IL",
                "value": 5.8
            },
            {
                "code": "us-il-075",
                "name": "Iroquois County, IL",
                "value": 5.6
            },
            {
                "code": "us-il-077",
                "name": "Jackson County, IL",
                "value": 4.8
            },
            {
                "code": "us-il-079",
                "name": "Jasper County, IL",
                "value": 5.8
            },
            {
                "code": "us-il-081",
                "name": "Jefferson County, IL",
                "value": 5.6
            },
            {
                "code": "us-il-083",
                "name": "Jersey County, IL",
                "value": 5.6
            },
            {
                "code": "us-il-085",
                "name": "Jo Daviess County, IL",
                "value": 6
            },
            {
                "code": "us-il-087",
                "name": "Johnson County, IL",
                "value": 8.9
            },
            {
                "code": "us-il-089",
                "name": "Kane County, IL",
                "value": 5.6
            },
            {
                "code": "us-il-091",
                "name": "Kankakee County, IL",
                "value": 6.2
            },
            {
                "code": "us-il-093",
                "name": "Kendall County, IL",
                "value": 4.6
            },
            {
                "code": "us-il-095",
                "name": "Knox County, IL",
                "value": 5.9
            },
            {
                "code": "us-il-097",
                "name": "Lake County, IL",
                "value": 5.2
            },
            {
                "code": "us-il-099",
                "name": "LaSalle County, IL",
                "value": 6.9
            },
            {
                "code": "us-il-101",
                "name": "Lawrence County, IL",
                "value": 6.4
            },
            {
                "code": "us-il-103",
                "name": "Lee County, IL",
                "value": 5.1
            },
            {
                "code": "us-il-105",
                "name": "Livingston County, IL",
                "value": 5
            },
            {
                "code": "us-il-107",
                "name": "Logan County, IL",
                "value": 5.2
            },
            {
                "code": "us-il-109",
                "name": "McDonough County, IL",
                "value": 5.3
            },
            {
                "code": "us-il-111",
                "name": "McHenry County, IL",
                "value": 4.8
            },
            {
                "code": "us-il-113",
                "name": "McLean County, IL",
                "value": 4.5
            },
            {
                "code": "us-il-115",
                "name": "Macon County, IL",
                "value": 5.9
            },
            {
                "code": "us-il-117",
                "name": "Macoupin County, IL",
                "value": 5.8
            },
            {
                "code": "us-il-119",
                "name": "Madison County, IL",
                "value": 4.8
            },
            {
                "code": "us-il-121",
                "name": "Marion County, IL",
                "value": 5.6
            },
            {
                "code": "us-il-123",
                "name": "Marshall County, IL",
                "value": 6.2
            },
            {
                "code": "us-il-125",
                "name": "Mason County, IL",
                "value": 7
            },
            {
                "code": "us-il-127",
                "name": "Massac County, IL",
                "value": 6.4
            },
            {
                "code": "us-il-129",
                "name": "Menard County, IL",
                "value": 5.2
            },
            {
                "code": "us-il-131",
                "name": "Mercer County, IL",
                "value": 7.1
            },
            {
                "code": "us-il-133",
                "name": "Monroe County, IL",
                "value": 3.8
            },
            {
                "code": "us-il-135",
                "name": "Montgomery County, IL",
                "value": 7
            },
            {
                "code": "us-il-137",
                "name": "Morgan County, IL",
                "value": 5
            },
            {
                "code": "us-il-139",
                "name": "Moultrie County, IL",
                "value": 4.2
            },
            {
                "code": "us-il-141",
                "name": "Ogle County, IL",
                "value": 6
            },
            {
                "code": "us-il-143",
                "name": "Peoria County, IL",
                "value": 6.2
            },
            {
                "code": "us-il-145",
                "name": "Perry County, IL",
                "value": 6.5
            },
            {
                "code": "us-il-147",
                "name": "Piatt County, IL",
                "value": 4.8
            },
            {
                "code": "us-il-149",
                "name": "Pike County, IL",
                "value": 5.4
            },
            {
                "code": "us-il-151",
                "name": "Pope County, IL",
                "value": 6.7
            },
            {
                "code": "us-il-153",
                "name": "Pulaski County, IL",
                "value": 8.7
            },
            {
                "code": "us-il-155",
                "name": "Putnam County, IL",
                "value": 6.4
            },
            {
                "code": "us-il-157",
                "name": "Randolph County, IL",
                "value": 5.2
            },
            {
                "code": "us-il-159",
                "name": "Richland County, IL",
                "value": 4.9
            },
            {
                "code": "us-il-161",
                "name": "Rock Island County, IL",
                "value": 5.8
            },
            {
                "code": "us-il-163",
                "name": "St. Clair County, IL",
                "value": 5.3
            },
            {
                "code": "us-il-165",
                "name": "Saline County, IL",
                "value": 6.8
            },
            {
                "code": "us-il-167",
                "name": "Sangamon County, IL",
                "value": 4.7
            },
            {
                "code": "us-il-169",
                "name": "Schuyler County, IL",
                "value": 5.5
            },
            {
                "code": "us-il-171",
                "name": "Scott County, IL",
                "value": 7.4
            },
            {
                "code": "us-il-173",
                "name": "Shelby County, IL",
                "value": 5.1
            },
            {
                "code": "us-il-175",
                "name": "Stark County, IL",
                "value": 8.2
            },
            {
                "code": "us-il-177",
                "name": "Stephenson County, IL",
                "value": 5.1
            },
            {
                "code": "us-il-179",
                "name": "Tazewell County, IL",
                "value": 5.8
            },
            {
                "code": "us-il-181",
                "name": "Union County, IL",
                "value": 7.9
            },
            {
                "code": "us-il-183",
                "name": "Vermilion County, IL",
                "value": 6.8
            },
            {
                "code": "us-il-185",
                "name": "Wabash County, IL",
                "value": 4.7
            },
            {
                "code": "us-il-187",
                "name": "Warren County, IL",
                "value": 4.7
            },
            {
                "code": "us-il-189",
                "name": "Washington County, IL",
                "value": 3.5
            },
            {
                "code": "us-il-191",
                "name": "Wayne County, IL",
                "value": 6.1
            },
            {
                "code": "us-il-193",
                "name": "White County, IL",
                "value": 4.6
            },
            {
                "code": "us-il-195",
                "name": "Whiteside County, IL",
                "value": 5.3
            },
            {
                "code": "us-il-197",
                "name": "Will County, IL",
                "value": 5.3
            },
            {
                "code": "us-il-199",
                "name": "Williamson County, IL",
                "value": 5.6
            },
            {
                "code": "us-il-201",
                "name": "Winnebago County, IL",
                "value": 5.7
            },
            {
                "code": "us-il-203",
                "name": "Woodford County, IL",
                "value": 4.9
            },
            {
                "code": "us-in-001",
                "name": "Adams County, IN",
                "value": 2.7
            },
            {
                "code": "us-in-003",
                "name": "Allen County, IN",
                "value": 3.3
            },
            {
                "code": "us-in-005",
                "name": "Bartholomew County, IN",
                "value": 2.9
            },
            {
                "code": "us-in-007",
                "name": "Benton County, IN",
                "value": 3.6
            },
            {
                "code": "us-in-009",
                "name": "Blackford County, IN",
                "value": 4.3
            },
            {
                "code": "us-in-011",
                "name": "Boone County, IN",
                "value": 2.8
            },
            {
                "code": "us-in-013",
                "name": "Brown County, IN",
                "value": 4
            },
            {
                "code": "us-in-015",
                "name": "Carroll County, IN",
                "value": 3.7
            },
            {
                "code": "us-in-017",
                "name": "Cass County, IN",
                "value": 4.1
            },
            {
                "code": "us-in-019",
                "name": "Clark County, IN",
                "value": 3.4
            },
            {
                "code": "us-in-021",
                "name": "Clay County, IN",
                "value": 4
            },
            {
                "code": "us-in-023",
                "name": "Clinton County, IN",
                "value": 3.1
            },
            {
                "code": "us-in-025",
                "name": "Crawford County, IN",
                "value": 5.5
            },
            {
                "code": "us-in-027",
                "name": "Daviess County, IN",
                "value": 2.9
            },
            {
                "code": "us-in-029",
                "name": "Dearborn County, IN",
                "value": 4.1
            },
            {
                "code": "us-in-031",
                "name": "Decatur County, IN",
                "value": 3.3
            },
            {
                "code": "us-in-033",
                "name": "DeKalb County, IN",
                "value": 3
            },
            {
                "code": "us-in-035",
                "name": "Delaware County, IN",
                "value": 4.2
            },
            {
                "code": "us-in-037",
                "name": "Dubois County, IN",
                "value": 2.6
            },
            {
                "code": "us-in-039",
                "name": "Elkhart County, IN",
                "value": 2.5
            },
            {
                "code": "us-in-041",
                "name": "Fayette County, IN",
                "value": 4.8
            },
            {
                "code": "us-in-043",
                "name": "Floyd County, IN",
                "value": 3.4
            },
            {
                "code": "us-in-045",
                "name": "Fountain County, IN",
                "value": 4.1
            },
            {
                "code": "us-in-047",
                "name": "Franklin County, IN",
                "value": 4.5
            },
            {
                "code": "us-in-049",
                "name": "Fulton County, IN",
                "value": 4
            },
            {
                "code": "us-in-051",
                "name": "Gibson County, IN",
                "value": 2.9
            },
            {
                "code": "us-in-053",
                "name": "Grant County, IN",
                "value": 4.1
            },
            {
                "code": "us-in-055",
                "name": "Greene County, IN",
                "value": 5
            },
            {
                "code": "us-in-057",
                "name": "Hamilton County, IN",
                "value": 2.7
            },
            {
                "code": "us-in-059",
                "name": "Hancock County, IN",
                "value": 3.2
            },
            {
                "code": "us-in-061",
                "name": "Harrison County, IN",
                "value": 3.8
            },
            {
                "code": "us-in-063",
                "name": "Hendricks County, IN",
                "value": 2.9
            },
            {
                "code": "us-in-065",
                "name": "Henry County, IN",
                "value": 3.8
            },
            {
                "code": "us-in-067",
                "name": "Howard County, IN",
                "value": 3.8
            },
            {
                "code": "us-in-069",
                "name": "Huntington County, IN",
                "value": 4
            },
            {
                "code": "us-in-071",
                "name": "Jackson County, IN",
                "value": 3
            },
            {
                "code": "us-in-073",
                "name": "Jasper County, IN",
                "value": 5
            },
            {
                "code": "us-in-075",
                "name": "Jay County, IN",
                "value": 3.5
            },
            {
                "code": "us-in-077",
                "name": "Jefferson County, IN",
                "value": 3.6
            },
            {
                "code": "us-in-079",
                "name": "Jennings County, IN",
                "value": 4.5
            },
            {
                "code": "us-in-081",
                "name": "Johnson County, IN",
                "value": 3.1
            },
            {
                "code": "us-in-083",
                "name": "Knox County, IN",
                "value": 3.5
            },
            {
                "code": "us-in-085",
                "name": "Kosciusko County, IN",
                "value": 2.7
            },
            {
                "code": "us-in-087",
                "name": "LaGrange County, IN",
                "value": 2.4
            },
            {
                "code": "us-in-089",
                "name": "Lake County, IN",
                "value": 5.3
            },
            {
                "code": "us-in-091",
                "name": "LaPorte County, IN",
                "value": 5.1
            },
            {
                "code": "us-in-093",
                "name": "Lawrence County, IN",
                "value": 4.7
            },
            {
                "code": "us-in-095",
                "name": "Madison County, IN",
                "value": 4.3
            },
            {
                "code": "us-in-097",
                "name": "Marion County, IN",
                "value": 3.5
            },
            {
                "code": "us-in-099",
                "name": "Marshall County, IN",
                "value": 3.4
            },
            {
                "code": "us-in-101",
                "name": "Martin County, IN",
                "value": 3
            },
            {
                "code": "us-in-103",
                "name": "Miami County, IN",
                "value": 4.1
            },
            {
                "code": "us-in-105",
                "name": "Monroe County, IN",
                "value": 3.6
            },
            {
                "code": "us-in-107",
                "name": "Montgomery County, IN",
                "value": 3.2
            },
            {
                "code": "us-in-109",
                "name": "Morgan County, IN",
                "value": 3.8
            },
            {
                "code": "us-in-111",
                "name": "Newton County, IN",
                "value": 5.2
            },
            {
                "code": "us-in-113",
                "name": "Noble County, IN",
                "value": 3.1
            },
            {
                "code": "us-in-115",
                "name": "Ohio County, IN",
                "value": 3.8
            },
            {
                "code": "us-in-117",
                "name": "Orange County, IN",
                "value": 4.3
            },
            {
                "code": "us-in-119",
                "name": "Owen County, IN",
                "value": 5
            },
            {
                "code": "us-in-121",
                "name": "Parke County, IN",
                "value": 4.7
            },
            {
                "code": "us-in-123",
                "name": "Perry County, IN",
                "value": 4.2
            },
            {
                "code": "us-in-125",
                "name": "Pike County, IN",
                "value": 3.7
            },
            {
                "code": "us-in-127",
                "name": "Porter County, IN",
                "value": 4.2
            },
            {
                "code": "us-in-129",
                "name": "Posey County, IN",
                "value": 3.1
            },
            {
                "code": "us-in-131",
                "name": "Pulaski County, IN",
                "value": 3.7
            },
            {
                "code": "us-in-133",
                "name": "Putnam County, IN",
                "value": 3.8
            },
            {
                "code": "us-in-135",
                "name": "Randolph County, IN",
                "value": 4.5
            },
            {
                "code": "us-in-137",
                "name": "Ripley County, IN",
                "value": 4
            },
            {
                "code": "us-in-139",
                "name": "Rush County, IN",
                "value": 3.2
            },
            {
                "code": "us-in-141",
                "name": "St. Joseph County, IN",
                "value": 3.7
            },
            {
                "code": "us-in-143",
                "name": "Scott County, IN",
                "value": 4
            },
            {
                "code": "us-in-145",
                "name": "Shelby County, IN",
                "value": 3.4
            },
            {
                "code": "us-in-147",
                "name": "Spencer County, IN",
                "value": 3.9
            },
            {
                "code": "us-in-149",
                "name": "Starke County, IN",
                "value": 5.2
            },
            {
                "code": "us-in-151",
                "name": "Steuben County, IN",
                "value": 2.9
            },
            {
                "code": "us-in-153",
                "name": "Sullivan County, IN",
                "value": 5.3
            },
            {
                "code": "us-in-155",
                "name": "Switzerland County, IN",
                "value": 4
            },
            {
                "code": "us-in-157",
                "name": "Tippecanoe County, IN",
                "value": 3.2
            },
            {
                "code": "us-in-159",
                "name": "Tipton County, IN",
                "value": 3
            },
            {
                "code": "us-in-161",
                "name": "Union County, IN",
                "value": 3.4
            },
            {
                "code": "us-in-163",
                "name": "Vanderburgh County, IN",
                "value": 3.2
            },
            {
                "code": "us-in-165",
                "name": "Vermillion County, IN",
                "value": 6.3
            },
            {
                "code": "us-in-167",
                "name": "Vigo County, IN",
                "value": 4.6
            },
            {
                "code": "us-in-169",
                "name": "Wabash County, IN",
                "value": 3.9
            },
            {
                "code": "us-in-171",
                "name": "Warren County, IN",
                "value": 3.5
            },
            {
                "code": "us-in-173",
                "name": "Warrick County, IN",
                "value": 3.1
            },
            {
                "code": "us-in-175",
                "name": "Washington County, IN",
                "value": 4.1
            },
            {
                "code": "us-in-177",
                "name": "Wayne County, IN",
                "value": 3.7
            },
            {
                "code": "us-in-179",
                "name": "Wells County, IN",
                "value": 3.4
            },
            {
                "code": "us-in-181",
                "name": "White County, IN",
                "value": 3.8
            },
            {
                "code": "us-in-183",
                "name": "Whitley County, IN",
                "value": 3.1
            },
            {
                "code": "us-ia-001",
                "name": "Adair County, IA",
                "value": 3.6
            },
            {
                "code": "us-ia-003",
                "name": "Adams County, IA",
                "value": 2.8
            },
            {
                "code": "us-ia-005",
                "name": "Allamakee County, IA",
                "value": 5.6
            },
            {
                "code": "us-ia-007",
                "name": "Appanoose County, IA",
                "value": 4.2
            },
            {
                "code": "us-ia-009",
                "name": "Audubon County, IA",
                "value": 3.8
            },
            {
                "code": "us-ia-011",
                "name": "Benton County, IA",
                "value": 4.2
            },
            {
                "code": "us-ia-013",
                "name": "Black Hawk County, IA",
                "value": 3.9
            },
            {
                "code": "us-ia-015",
                "name": "Boone County, IA",
                "value": 2.8
            },
            {
                "code": "us-ia-017",
                "name": "Bremer County, IA",
                "value": 3.1
            },
            {
                "code": "us-ia-019",
                "name": "Buchanan County, IA",
                "value": 4
            },
            {
                "code": "us-ia-021",
                "name": "Buena Vista County, IA",
                "value": 2.5
            },
            {
                "code": "us-ia-023",
                "name": "Butler County, IA",
                "value": 4.5
            },
            {
                "code": "us-ia-025",
                "name": "Calhoun County, IA",
                "value": 3.3
            },
            {
                "code": "us-ia-027",
                "name": "Carroll County, IA",
                "value": 2.5
            },
            {
                "code": "us-ia-029",
                "name": "Cass County, IA",
                "value": 4.5
            },
            {
                "code": "us-ia-031",
                "name": "Cedar County, IA",
                "value": 4
            },
            {
                "code": "us-ia-033",
                "name": "Cerro Gordo County, IA",
                "value": 3.3
            },
            {
                "code": "us-ia-035",
                "name": "Cherokee County, IA",
                "value": 3.2
            },
            {
                "code": "us-ia-037",
                "name": "Chickasaw County, IA",
                "value": 4.3
            },
            {
                "code": "us-ia-039",
                "name": "Clarke County, IA",
                "value": 4.3
            },
            {
                "code": "us-ia-041",
                "name": "Clay County, IA",
                "value": 4.6
            },
            {
                "code": "us-ia-043",
                "name": "Clayton County, IA",
                "value": 6.1
            },
            {
                "code": "us-ia-045",
                "name": "Clinton County, IA",
                "value": 4.4
            },
            {
                "code": "us-ia-047",
                "name": "Crawford County, IA",
                "value": 5.4
            },
            {
                "code": "us-ia-049",
                "name": "Dallas County, IA",
                "value": 2.3
            },
            {
                "code": "us-ia-051",
                "name": "Davis County, IA",
                "value": 3.7
            },
            {
                "code": "us-ia-053",
                "name": "Decatur County, IA",
                "value": 3.2
            },
            {
                "code": "us-ia-055",
                "name": "Delaware County, IA",
                "value": 3.3
            },
            {
                "code": "us-ia-057",
                "name": "Des Moines County, IA",
                "value": 4.6
            },
            {
                "code": "us-ia-059",
                "name": "Dickinson County, IA",
                "value": 5.3
            },
            {
                "code": "us-ia-061",
                "name": "Dubuque County, IA",
                "value": 3.8
            },
            {
                "code": "us-ia-063",
                "name": "Emmet County, IA",
                "value": 3.9
            },
            {
                "code": "us-ia-065",
                "name": "Fayette County, IA",
                "value": 4.7
            },
            {
                "code": "us-ia-067",
                "name": "Floyd County, IA",
                "value": 3.9
            },
            {
                "code": "us-ia-069",
                "name": "Franklin County, IA",
                "value": 3.2
            },
            {
                "code": "us-ia-071",
                "name": "Fremont County, IA",
                "value": 2.4
            },
            {
                "code": "us-ia-073",
                "name": "Greene County, IA",
                "value": 2.8
            },
            {
                "code": "us-ia-075",
                "name": "Grundy County, IA",
                "value": 3.8
            },
            {
                "code": "us-ia-077",
                "name": "Guthrie County, IA",
                "value": 4.2
            },
            {
                "code": "us-ia-079",
                "name": "Hamilton County, IA",
                "value": 3.6
            },
            {
                "code": "us-ia-081",
                "name": "Hancock County, IA",
                "value": 3
            },
            {
                "code": "us-ia-083",
                "name": "Hardin County, IA",
                "value": 4.4
            },
            {
                "code": "us-ia-085",
                "name": "Harrison County, IA",
                "value": 3.3
            },
            {
                "code": "us-ia-087",
                "name": "Henry County, IA",
                "value": 3.6
            },
            {
                "code": "us-ia-089",
                "name": "Howard County, IA",
                "value": 4.7
            },
            {
                "code": "us-ia-091",
                "name": "Humboldt County, IA",
                "value": 3.7
            },
            {
                "code": "us-ia-093",
                "name": "Ida County, IA",
                "value": 3.2
            },
            {
                "code": "us-ia-095",
                "name": "Iowa County, IA",
                "value": 3.4
            },
            {
                "code": "us-ia-097",
                "name": "Jackson County, IA",
                "value": 4.8
            },
            {
                "code": "us-ia-099",
                "name": "Jasper County, IA",
                "value": 3.6
            },
            {
                "code": "us-ia-101",
                "name": "Jefferson County, IA",
                "value": 3.1
            },
            {
                "code": "us-ia-103",
                "name": "Johnson County, IA",
                "value": 2.3
            },
            {
                "code": "us-ia-105",
                "name": "Jones County, IA",
                "value": 5.2
            },
            {
                "code": "us-ia-107",
                "name": "Keokuk County, IA",
                "value": 4.3
            },
            {
                "code": "us-ia-109",
                "name": "Kossuth County, IA",
                "value": 3.1
            },
            {
                "code": "us-ia-111",
                "name": "Lee County, IA",
                "value": 5.3
            },
            {
                "code": "us-ia-113",
                "name": "Linn County, IA",
                "value": 3.8
            },
            {
                "code": "us-ia-115",
                "name": "Louisa County, IA",
                "value": 3.7
            },
            {
                "code": "us-ia-117",
                "name": "Lucas County, IA",
                "value": 3
            },
            {
                "code": "us-ia-119",
                "name": "Lyon County, IA",
                "value": 2.3
            },
            {
                "code": "us-ia-121",
                "name": "Madison County, IA",
                "value": 4.7
            },
            {
                "code": "us-ia-123",
                "name": "Mahaska County, IA",
                "value": 3.9
            },
            {
                "code": "us-ia-125",
                "name": "Marion County, IA",
                "value": 3
            },
            {
                "code": "us-ia-127",
                "name": "Marshall County, IA",
                "value": 6.8
            },
            {
                "code": "us-ia-129",
                "name": "Mills County, IA",
                "value": 3.2
            },
            {
                "code": "us-ia-131",
                "name": "Mitchell County, IA",
                "value": 2.7
            },
            {
                "code": "us-ia-133",
                "name": "Monona County, IA",
                "value": 4.8
            },
            {
                "code": "us-ia-135",
                "name": "Monroe County, IA",
                "value": 4.5
            },
            {
                "code": "us-ia-137",
                "name": "Montgomery County, IA",
                "value": 3
            },
            {
                "code": "us-ia-139",
                "name": "Muscatine County, IA",
                "value": 3.5
            },
            {
                "code": "us-ia-141",
                "name": "O'Brien County, IA",
                "value": 2.9
            },
            {
                "code": "us-ia-143",
                "name": "Osceola County, IA",
                "value": 2.5
            },
            {
                "code": "us-ia-145",
                "name": "Page County, IA",
                "value": 3.6
            },
            {
                "code": "us-ia-147",
                "name": "Palo Alto County, IA",
                "value": 3.2
            },
            {
                "code": "us-ia-149",
                "name": "Plymouth County, IA",
                "value": 2.6
            },
            {
                "code": "us-ia-151",
                "name": "Pocahontas County, IA",
                "value": 2.8
            },
            {
                "code": "us-ia-153",
                "name": "Polk County, IA",
                "value": 3.4
            },
            {
                "code": "us-ia-155",
                "name": "Pottawattamie County, IA",
                "value": 3.2
            },
            {
                "code": "us-ia-157",
                "name": "Poweshiek County, IA",
                "value": 4.1
            },
            {
                "code": "us-ia-159",
                "name": "Ringgold County, IA",
                "value": 4.3
            },
            {
                "code": "us-ia-161",
                "name": "Sac County, IA",
                "value": 3.9
            },
            {
                "code": "us-ia-163",
                "name": "Scott County, IA",
                "value": 4
            },
            {
                "code": "us-ia-165",
                "name": "Shelby County, IA",
                "value": 2.9
            },
            {
                "code": "us-ia-167",
                "name": "Sioux County, IA",
                "value": 2.8
            },
            {
                "code": "us-ia-169",
                "name": "Story County, IA",
                "value": 1.9
            },
            {
                "code": "us-ia-171",
                "name": "Tama County, IA",
                "value": 4.9
            },
            {
                "code": "us-ia-173",
                "name": "Taylor County, IA",
                "value": 2.8
            },
            {
                "code": "us-ia-175",
                "name": "Union County, IA",
                "value": 5.1
            },
            {
                "code": "us-ia-177",
                "name": "Van Buren County, IA",
                "value": 3.5
            },
            {
                "code": "us-ia-179",
                "name": "Wapello County, IA",
                "value": 4.7
            },
            {
                "code": "us-ia-181",
                "name": "Warren County, IA",
                "value": 3.3
            },
            {
                "code": "us-ia-183",
                "name": "Washington County, IA",
                "value": 3.6
            },
            {
                "code": "us-ia-185",
                "name": "Wayne County, IA",
                "value": 4
            },
            {
                "code": "us-ia-187",
                "name": "Webster County, IA",
                "value": 4.1
            },
            {
                "code": "us-ia-189",
                "name": "Winnebago County, IA",
                "value": 3
            },
            {
                "code": "us-ia-191",
                "name": "Winneshiek County, IA",
                "value": 5.1
            },
            {
                "code": "us-ia-193",
                "name": "Woodbury County, IA",
                "value": 3.6
            },
            {
                "code": "us-ia-195",
                "name": "Worth County, IA",
                "value": 3.9
            },
            {
                "code": "us-ia-197",
                "name": "Wright County, IA",
                "value": 3.7
            },
            {
                "code": "us-ks-001",
                "name": "Allen County, KS",
                "value": 4.4
            },
            {
                "code": "us-ks-003",
                "name": "Anderson County, KS",
                "value": 4.3
            },
            {
                "code": "us-ks-005",
                "name": "Atchison County, KS",
                "value": 5.5
            },
            {
                "code": "us-ks-007",
                "name": "Barber County, KS",
                "value": 2.6
            },
            {
                "code": "us-ks-009",
                "name": "Barton County, KS",
                "value": 3.8
            },
            {
                "code": "us-ks-011",
                "name": "Bourbon County, KS",
                "value": 5.1
            },
            {
                "code": "us-ks-013",
                "name": "Brown County, KS",
                "value": 3.4
            },
            {
                "code": "us-ks-015",
                "name": "Butler County, KS",
                "value": 3.8
            },
            {
                "code": "us-ks-017",
                "name": "Chase County, KS",
                "value": 3.5
            },
            {
                "code": "us-ks-019",
                "name": "Chautauqua County, KS",
                "value": 4.5
            },
            {
                "code": "us-ks-021",
                "name": "Cherokee County, KS",
                "value": 4.1
            },
            {
                "code": "us-ks-023",
                "name": "Cheyenne County, KS",
                "value": 2.2
            },
            {
                "code": "us-ks-025",
                "name": "Clark County, KS",
                "value": 2.9
            },
            {
                "code": "us-ks-027",
                "name": "Clay County, KS",
                "value": 4
            },
            {
                "code": "us-ks-029",
                "name": "Cloud County, KS",
                "value": 3.7
            },
            {
                "code": "us-ks-031",
                "name": "Coffey County, KS",
                "value": 5.5
            },
            {
                "code": "us-ks-033",
                "name": "Comanche County, KS",
                "value": 2.8
            },
            {
                "code": "us-ks-035",
                "name": "Cowley County, KS",
                "value": 3.5
            },
            {
                "code": "us-ks-037",
                "name": "Crawford County, KS",
                "value": 4.5
            },
            {
                "code": "us-ks-039",
                "name": "Decatur County, KS",
                "value": 2.6
            },
            {
                "code": "us-ks-041",
                "name": "Dickinson County, KS",
                "value": 4.1
            },
            {
                "code": "us-ks-043",
                "name": "Doniphan County, KS",
                "value": 3.8
            },
            {
                "code": "us-ks-045",
                "name": "Douglas County, KS",
                "value": 3.2
            },
            {
                "code": "us-ks-047",
                "name": "Edwards County, KS",
                "value": 2.7
            },
            {
                "code": "us-ks-049",
                "name": "Elk County, KS",
                "value": 3.4
            },
            {
                "code": "us-ks-051",
                "name": "Ellis County, KS",
                "value": 2.5
            },
            {
                "code": "us-ks-053",
                "name": "Ellsworth County, KS",
                "value": 2.9
            },
            {
                "code": "us-ks-055",
                "name": "Finney County, KS",
                "value": 2.4
            },
            {
                "code": "us-ks-057",
                "name": "Ford County, KS",
                "value": 2.5
            },
            {
                "code": "us-ks-059",
                "name": "Franklin County, KS",
                "value": 4.5
            },
            {
                "code": "us-ks-061",
                "name": "Geary County, KS",
                "value": 4.8
            },
            {
                "code": "us-ks-063",
                "name": "Gove County, KS",
                "value": 2.4
            },
            {
                "code": "us-ks-065",
                "name": "Graham County, KS",
                "value": 3.1
            },
            {
                "code": "us-ks-067",
                "name": "Grant County, KS",
                "value": 2.9
            },
            {
                "code": "us-ks-069",
                "name": "Gray County, KS",
                "value": 1.9
            },
            {
                "code": "us-ks-071",
                "name": "Greeley County, KS",
                "value": 2.1
            },
            {
                "code": "us-ks-073",
                "name": "Greenwood County, KS",
                "value": 4.3
            },
            {
                "code": "us-ks-075",
                "name": "Hamilton County, KS",
                "value": 2
            },
            {
                "code": "us-ks-077",
                "name": "Harper County, KS",
                "value": 3.1
            },
            {
                "code": "us-ks-079",
                "name": "Harvey County, KS",
                "value": 3.6
            },
            {
                "code": "us-ks-081",
                "name": "Haskell County, KS",
                "value": 2.2
            },
            {
                "code": "us-ks-083",
                "name": "Hodgeman County, KS",
                "value": 2.5
            },
            {
                "code": "us-ks-085",
                "name": "Jackson County, KS",
                "value": 3.6
            },
            {
                "code": "us-ks-087",
                "name": "Jefferson County, KS",
                "value": 4.2
            },
            {
                "code": "us-ks-089",
                "name": "Jewell County, KS",
                "value": 2.7
            },
            {
                "code": "us-ks-091",
                "name": "Johnson County, KS",
                "value": 3.1
            },
            {
                "code": "us-ks-093",
                "name": "Kearny County, KS",
                "value": 2.2
            },
            {
                "code": "us-ks-095",
                "name": "Kingman County, KS",
                "value": 3.4
            },
            {
                "code": "us-ks-097",
                "name": "Kiowa County, KS",
                "value": 2.2
            },
            {
                "code": "us-ks-099",
                "name": "Labette County, KS",
                "value": 4.1
            },
            {
                "code": "us-ks-101",
                "name": "Lane County, KS",
                "value": 2.7
            },
            {
                "code": "us-ks-103",
                "name": "Leavenworth County, KS",
                "value": 4.6
            },
            {
                "code": "us-ks-105",
                "name": "Lincoln County, KS",
                "value": 3
            },
            {
                "code": "us-ks-107",
                "name": "Linn County, KS",
                "value": 7.1
            },
            {
                "code": "us-ks-109",
                "name": "Logan County, KS",
                "value": 2.4
            },
            {
                "code": "us-ks-111",
                "name": "Lyon County, KS",
                "value": 4
            },
            {
                "code": "us-ks-113",
                "name": "McPherson County, KS",
                "value": 2.5
            },
            {
                "code": "us-ks-115",
                "name": "Marion County, KS",
                "value": 3.3
            },
            {
                "code": "us-ks-117",
                "name": "Marshall County, KS",
                "value": 3.1
            },
            {
                "code": "us-ks-119",
                "name": "Meade County, KS",
                "value": 2.2
            },
            {
                "code": "us-ks-121",
                "name": "Miami County, KS",
                "value": 4.5
            },
            {
                "code": "us-ks-123",
                "name": "Mitchell County, KS",
                "value": 2.2
            },
            {
                "code": "us-ks-125",
                "name": "Montgomery County, KS",
                "value": 4.7
            },
            {
                "code": "us-ks-127",
                "name": "Morris County, KS",
                "value": 3.2
            },
            {
                "code": "us-ks-129",
                "name": "Morton County, KS",
                "value": 3
            },
            {
                "code": "us-ks-131",
                "name": "Nemaha County, KS",
                "value": 2.5
            },
            {
                "code": "us-ks-133",
                "name": "Neosho County, KS",
                "value": 5
            },
            {
                "code": "us-ks-135",
                "name": "Ness County, KS",
                "value": 2.4
            },
            {
                "code": "us-ks-137",
                "name": "Norton County, KS",
                "value": 2.1
            },
            {
                "code": "us-ks-139",
                "name": "Osage County, KS",
                "value": 4.7
            },
            {
                "code": "us-ks-141",
                "name": "Osborne County, KS",
                "value": 2.5
            },
            {
                "code": "us-ks-143",
                "name": "Ottawa County, KS",
                "value": 2.9
            },
            {
                "code": "us-ks-145",
                "name": "Pawnee County, KS",
                "value": 3
            },
            {
                "code": "us-ks-147",
                "name": "Phillips County, KS",
                "value": 2.8
            },
            {
                "code": "us-ks-149",
                "name": "Pottawatomie County, KS",
                "value": 3.2
            },
            {
                "code": "us-ks-151",
                "name": "Pratt County, KS",
                "value": 2.8
            },
            {
                "code": "us-ks-153",
                "name": "Rawlins County, KS",
                "value": 2.2
            },
            {
                "code": "us-ks-155",
                "name": "Reno County, KS",
                "value": 4
            },
            {
                "code": "us-ks-157",
                "name": "Republic County, KS",
                "value": 2.5
            },
            {
                "code": "us-ks-159",
                "name": "Rice County, KS",
                "value": 3.2
            },
            {
                "code": "us-ks-161",
                "name": "Riley County, KS",
                "value": 3
            },
            {
                "code": "us-ks-163",
                "name": "Rooks County, KS",
                "value": 4
            },
            {
                "code": "us-ks-165",
                "name": "Rush County, KS",
                "value": 2.7
            },
            {
                "code": "us-ks-167",
                "name": "Russell County, KS",
                "value": 3.1
            },
            {
                "code": "us-ks-169",
                "name": "Saline County, KS",
                "value": 3.2
            },
            {
                "code": "us-ks-171",
                "name": "Scott County, KS",
                "value": 2
            },
            {
                "code": "us-ks-173",
                "name": "Sedgwick County, KS",
                "value": 4.2
            },
            {
                "code": "us-ks-175",
                "name": "Seward County, KS",
                "value": 3.2
            },
            {
                "code": "us-ks-177",
                "name": "Shawnee County, KS",
                "value": 3.8
            },
            {
                "code": "us-ks-179",
                "name": "Sheridan County, KS",
                "value": 2.3
            },
            {
                "code": "us-ks-181",
                "name": "Sherman County, KS",
                "value": 2.8
            },
            {
                "code": "us-ks-183",
                "name": "Smith County, KS",
                "value": 2.9
            },
            {
                "code": "us-ks-185",
                "name": "Stafford County, KS",
                "value": 2.4
            },
            {
                "code": "us-ks-187",
                "name": "Stanton County, KS",
                "value": 2.8
            },
            {
                "code": "us-ks-189",
                "name": "Stevens County, KS",
                "value": 2.7
            },
            {
                "code": "us-ks-191",
                "name": "Sumner County, KS",
                "value": 3.6
            },
            {
                "code": "us-ks-193",
                "name": "Thomas County, KS",
                "value": 2.6
            },
            {
                "code": "us-ks-195",
                "name": "Trego County, KS",
                "value": 3.7
            },
            {
                "code": "us-ks-197",
                "name": "Wabaunsee County, KS",
                "value": 4.2
            },
            {
                "code": "us-ks-199",
                "name": "Wallace County, KS",
                "value": 2.6
            },
            {
                "code": "us-ks-201",
                "name": "Washington County, KS",
                "value": 3
            },
            {
                "code": "us-ks-203",
                "name": "Wichita County, KS",
                "value": 2.5
            },
            {
                "code": "us-ks-205",
                "name": "Wilson County, KS",
                "value": 4.8
            },
            {
                "code": "us-ks-207",
                "name": "Woodson County, KS",
                "value": 4.2
            },
            {
                "code": "us-ks-209",
                "name": "Wyandotte County, KS",
                "value": 6.2
            },
            {
                "code": "us-ky-001",
                "name": "Adair County, KY",
                "value": 6
            },
            {
                "code": "us-ky-003",
                "name": "Allen County, KY",
                "value": 4
            },
            {
                "code": "us-ky-005",
                "name": "Anderson County, KY",
                "value": 3.9
            },
            {
                "code": "us-ky-007",
                "name": "Ballard County, KY",
                "value": 8.6
            },
            {
                "code": "us-ky-009",
                "name": "Barren County, KY",
                "value": 5.1
            },
            {
                "code": "us-ky-011",
                "name": "Bath County, KY",
                "value": 9.8
            },
            {
                "code": "us-ky-013",
                "name": "Bell County, KY",
                "value": 7.2
            },
            {
                "code": "us-ky-015",
                "name": "Boone County, KY",
                "value": 3.9
            },
            {
                "code": "us-ky-017",
                "name": "Bourbon County, KY",
                "value": 4.5
            },
            {
                "code": "us-ky-019",
                "name": "Boyd County, KY",
                "value": 7.4
            },
            {
                "code": "us-ky-021",
                "name": "Boyle County, KY",
                "value": 4.8
            },
            {
                "code": "us-ky-023",
                "name": "Bracken County, KY",
                "value": 6.8
            },
            {
                "code": "us-ky-025",
                "name": "Breathitt County, KY",
                "value": 8.7
            },
            {
                "code": "us-ky-027",
                "name": "Breckinridge County, KY",
                "value": 6.4
            },
            {
                "code": "us-ky-029",
                "name": "Bullitt County, KY",
                "value": 4.2
            },
            {
                "code": "us-ky-031",
                "name": "Butler County, KY",
                "value": 5.9
            },
            {
                "code": "us-ky-033",
                "name": "Caldwell County, KY",
                "value": 5.2
            },
            {
                "code": "us-ky-035",
                "name": "Calloway County, KY",
                "value": 4.4
            },
            {
                "code": "us-ky-037",
                "name": "Campbell County, KY",
                "value": 3.6
            },
            {
                "code": "us-ky-039",
                "name": "Carlisle County, KY",
                "value": 6.4
            },
            {
                "code": "us-ky-041",
                "name": "Carroll County, KY",
                "value": 5
            },
            {
                "code": "us-ky-043",
                "name": "Carter County, KY",
                "value": 14.8
            },
            {
                "code": "us-ky-045",
                "name": "Casey County, KY",
                "value": 4.9
            },
            {
                "code": "us-ky-047",
                "name": "Christian County, KY",
                "value": 5.5
            },
            {
                "code": "us-ky-049",
                "name": "Clark County, KY",
                "value": 4.6
            },
            {
                "code": "us-ky-051",
                "name": "Clay County, KY",
                "value": 7.9
            },
            {
                "code": "us-ky-053",
                "name": "Clinton County, KY",
                "value": 6
            },
            {
                "code": "us-ky-055",
                "name": "Crittenden County, KY",
                "value": 6.2
            },
            {
                "code": "us-ky-057",
                "name": "Cumberland County, KY",
                "value": 6.8
            },
            {
                "code": "us-ky-059",
                "name": "Daviess County, KY",
                "value": 4.6
            },
            {
                "code": "us-ky-061",
                "name": "Edmonson County, KY",
                "value": 6.7
            },
            {
                "code": "us-ky-063",
                "name": "Elliott County, KY",
                "value": 13.5
            },
            {
                "code": "us-ky-065",
                "name": "Estill County, KY",
                "value": 6.8
            },
            {
                "code": "us-ky-067",
                "name": "Fayette County, KY",
                "value": 3.4
            },
            {
                "code": "us-ky-069",
                "name": "Fleming County, KY",
                "value": 6.6
            },
            {
                "code": "us-ky-071",
                "name": "Floyd County, KY",
                "value": 7.8
            },
            {
                "code": "us-ky-073",
                "name": "Franklin County, KY",
                "value": 4.1
            },
            {
                "code": "us-ky-075",
                "name": "Fulton County, KY",
                "value": 6.4
            },
            {
                "code": "us-ky-077",
                "name": "Gallatin County, KY",
                "value": 4.3
            },
            {
                "code": "us-ky-079",
                "name": "Garrard County, KY",
                "value": 4.7
            },
            {
                "code": "us-ky-081",
                "name": "Grant County, KY",
                "value": 5.2
            },
            {
                "code": "us-ky-083",
                "name": "Graves County, KY",
                "value": 5.7
            },
            {
                "code": "us-ky-085",
                "name": "Grayson County, KY",
                "value": 5.9
            },
            {
                "code": "us-ky-087",
                "name": "Green County, KY",
                "value": 4.4
            },
            {
                "code": "us-ky-089",
                "name": "Greenup County, KY",
                "value": 9
            },
            {
                "code": "us-ky-091",
                "name": "Hancock County, KY",
                "value": 4.9
            },
            {
                "code": "us-ky-093",
                "name": "Hardin County, KY",
                "value": 4.4
            },
            {
                "code": "us-ky-095",
                "name": "Harlan County, KY",
                "value": 8.1
            },
            {
                "code": "us-ky-097",
                "name": "Harrison County, KY",
                "value": 4.3
            },
            {
                "code": "us-ky-099",
                "name": "Hart County, KY",
                "value": 4.6
            },
            {
                "code": "us-ky-101",
                "name": "Henderson County, KY",
                "value": 4.1
            },
            {
                "code": "us-ky-103",
                "name": "Henry County, KY",
                "value": 4.2
            },
            {
                "code": "us-ky-105",
                "name": "Hickman County, KY",
                "value": 7.3
            },
            {
                "code": "us-ky-107",
                "name": "Hopkins County, KY",
                "value": 5
            },
            {
                "code": "us-ky-109",
                "name": "Jackson County, KY",
                "value": 7.8
            },
            {
                "code": "us-ky-111",
                "name": "Jefferson County, KY",
                "value": 4.1
            },
            {
                "code": "us-ky-113",
                "name": "Jessamine County, KY",
                "value": 3.8
            },
            {
                "code": "us-ky-115",
                "name": "Johnson County, KY",
                "value": 8.5
            },
            {
                "code": "us-ky-117",
                "name": "Kenton County, KY",
                "value": 4
            },
            {
                "code": "us-ky-119",
                "name": "Knott County, KY",
                "value": 7.4
            },
            {
                "code": "us-ky-121",
                "name": "Knox County, KY",
                "value": 7
            },
            {
                "code": "us-ky-123",
                "name": "Larue County, KY",
                "value": 4.9
            },
            {
                "code": "us-ky-125",
                "name": "Laurel County, KY",
                "value": 5.5
            },
            {
                "code": "us-ky-127",
                "name": "Lawrence County, KY",
                "value": 9.1
            },
            {
                "code": "us-ky-129",
                "name": "Lee County, KY",
                "value": 8.1
            },
            {
                "code": "us-ky-131",
                "name": "Leslie County, KY",
                "value": 7.9
            },
            {
                "code": "us-ky-133",
                "name": "Letcher County, KY",
                "value": 7.1
            },
            {
                "code": "us-ky-135",
                "name": "Lewis County, KY",
                "value": 11.8
            },
            {
                "code": "us-ky-137",
                "name": "Lincoln County, KY",
                "value": 5.9
            },
            {
                "code": "us-ky-139",
                "name": "Livingston County, KY",
                "value": 8.5
            },
            {
                "code": "us-ky-141",
                "name": "Logan County, KY",
                "value": 4.2
            },
            {
                "code": "us-ky-143",
                "name": "Lyon County, KY",
                "value": 6.2
            },
            {
                "code": "us-ky-145",
                "name": "McCracken County, KY",
                "value": 6.6
            },
            {
                "code": "us-ky-147",
                "name": "McCreary County, KY",
                "value": 7
            },
            {
                "code": "us-ky-149",
                "name": "McLean County, KY",
                "value": 5.9
            },
            {
                "code": "us-ky-151",
                "name": "Madison County, KY",
                "value": 4.1
            },
            {
                "code": "us-ky-153",
                "name": "Magoffin County, KY",
                "value": 17.1
            },
            {
                "code": "us-ky-155",
                "name": "Marion County, KY",
                "value": 3.7
            },
            {
                "code": "us-ky-157",
                "name": "Marshall County, KY",
                "value": 6.9
            },
            {
                "code": "us-ky-159",
                "name": "Martin County, KY",
                "value": 7.3
            },
            {
                "code": "us-ky-161",
                "name": "Mason County, KY",
                "value": 6.2
            },
            {
                "code": "us-ky-163",
                "name": "Meade County, KY",
                "value": 5.1
            },
            {
                "code": "us-ky-165",
                "name": "Menifee County, KY",
                "value": 11.1
            },
            {
                "code": "us-ky-167",
                "name": "Mercer County, KY",
                "value": 5.1
            },
            {
                "code": "us-ky-169",
                "name": "Metcalfe County, KY",
                "value": 4.5
            },
            {
                "code": "us-ky-171",
                "name": "Monroe County, KY",
                "value": 4
            },
            {
                "code": "us-ky-173",
                "name": "Montgomery County, KY",
                "value": 7.3
            },
            {
                "code": "us-ky-175",
                "name": "Morgan County, KY",
                "value": 9
            },
            {
                "code": "us-ky-177",
                "name": "Muhlenberg County, KY",
                "value": 8.4
            },
            {
                "code": "us-ky-179",
                "name": "Nelson County, KY",
                "value": 4.5
            },
            {
                "code": "us-ky-181",
                "name": "Nicholas County, KY",
                "value": 5.5
            },
            {
                "code": "us-ky-183",
                "name": "Ohio County, KY",
                "value": 6.8
            },
            {
                "code": "us-ky-185",
                "name": "Oldham County, KY",
                "value": 3.4
            },
            {
                "code": "us-ky-187",
                "name": "Owen County, KY",
                "value": 4.7
            },
            {
                "code": "us-ky-189",
                "name": "Owsley County, KY",
                "value": 7.4
            },
            {
                "code": "us-ky-191",
                "name": "Pendleton County, KY",
                "value": 5.2
            },
            {
                "code": "us-ky-193",
                "name": "Perry County, KY",
                "value": 6.9
            },
            {
                "code": "us-ky-195",
                "name": "Pike County, KY",
                "value": 6.5
            },
            {
                "code": "us-ky-197",
                "name": "Powell County, KY",
                "value": 6.9
            },
            {
                "code": "us-ky-199",
                "name": "Pulaski County, KY",
                "value": 5.8
            },
            {
                "code": "us-ky-201",
                "name": "Robertson County, KY",
                "value": 6.1
            },
            {
                "code": "us-ky-203",
                "name": "Rockcastle County, KY",
                "value": 6
            },
            {
                "code": "us-ky-205",
                "name": "Rowan County, KY",
                "value": 5.9
            },
            {
                "code": "us-ky-207",
                "name": "Russell County, KY",
                "value": 6.8
            },
            {
                "code": "us-ky-209",
                "name": "Scott County, KY",
                "value": 3.6
            },
            {
                "code": "us-ky-211",
                "name": "Shelby County, KY",
                "value": 3.6
            },
            {
                "code": "us-ky-213",
                "name": "Simpson County, KY",
                "value": 4.1
            },
            {
                "code": "us-ky-215",
                "name": "Spencer County, KY",
                "value": 3.9
            },
            {
                "code": "us-ky-217",
                "name": "Taylor County, KY",
                "value": 4.4
            },
            {
                "code": "us-ky-219",
                "name": "Todd County, KY",
                "value": 4.7
            },
            {
                "code": "us-ky-221",
                "name": "Trigg County, KY",
                "value": 5.8
            },
            {
                "code": "us-ky-223",
                "name": "Trimble County, KY",
                "value": 4.6
            },
            {
                "code": "us-ky-225",
                "name": "Union County, KY",
                "value": 5.4
            },
            {
                "code": "us-ky-227",
                "name": "Warren County, KY",
                "value": 4.1
            },
            {
                "code": "us-ky-229",
                "name": "Washington County, KY",
                "value": 4.1
            },
            {
                "code": "us-ky-231",
                "name": "Wayne County, KY",
                "value": 6.8
            },
            {
                "code": "us-ky-233",
                "name": "Webster County, KY",
                "value": 4.9
            },
            {
                "code": "us-ky-235",
                "name": "Whitley County, KY",
                "value": 5.3
            },
            {
                "code": "us-ky-237",
                "name": "Wolfe County, KY",
                "value": 9.7
            },
            {
                "code": "us-ky-239",
                "name": "Woodford County, KY",
                "value": 3.2
            },
            {
                "code": "us-la-001",
                "name": "Acadia Parish, LA",
                "value": 5.5
            },
            {
                "code": "us-la-003",
                "name": "Allen Parish, LA",
                "value": 6
            },
            {
                "code": "us-la-005",
                "name": "Ascension Parish, LA",
                "value": 4.2
            },
            {
                "code": "us-la-007",
                "name": "Assumption Parish, LA",
                "value": 7.2
            },
            {
                "code": "us-la-009",
                "name": "Avoyelles Parish, LA",
                "value": 5.8
            },
            {
                "code": "us-la-011",
                "name": "Beauregard Parish, LA",
                "value": 5.4
            },
            {
                "code": "us-la-013",
                "name": "Bienville Parish, LA",
                "value": 5.5
            },
            {
                "code": "us-la-015",
                "name": "Bossier Parish, LA",
                "value": 4.1
            },
            {
                "code": "us-la-017",
                "name": "Caddo Parish, LA",
                "value": 5.3
            },
            {
                "code": "us-la-019",
                "name": "Calcasieu Parish, LA",
                "value": 3.9
            },
            {
                "code": "us-la-021",
                "name": "Caldwell Parish, LA",
                "value": 5.7
            },
            {
                "code": "us-la-023",
                "name": "Cameron Parish, LA",
                "value": 3.3
            },
            {
                "code": "us-la-025",
                "name": "Catahoula Parish, LA",
                "value": 7.1
            },
            {
                "code": "us-la-027",
                "name": "Claiborne Parish, LA",
                "value": 5
            },
            {
                "code": "us-la-029",
                "name": "Concordia Parish, LA",
                "value": 7.4
            },
            {
                "code": "us-la-031",
                "name": "De Soto Parish, LA",
                "value": 5.6
            },
            {
                "code": "us-la-033",
                "name": "East Baton Rouge Parish, LA",
                "value": 4.2
            },
            {
                "code": "us-la-035",
                "name": "East Carroll Parish, LA",
                "value": 10.5
            },
            {
                "code": "us-la-037",
                "name": "East Feliciana Parish, LA",
                "value": 4.5
            },
            {
                "code": "us-la-039",
                "name": "Evangeline Parish, LA",
                "value": 5.9
            },
            {
                "code": "us-la-041",
                "name": "Franklin Parish, LA",
                "value": 7.6
            },
            {
                "code": "us-la-043",
                "name": "Grant Parish, LA",
                "value": 6.3
            },
            {
                "code": "us-la-045",
                "name": "Iberia Parish, LA",
                "value": 6.2
            },
            {
                "code": "us-la-047",
                "name": "Iberville Parish, LA",
                "value": 6.5
            },
            {
                "code": "us-la-049",
                "name": "Jackson Parish, LA",
                "value": 4.3
            },
            {
                "code": "us-la-051",
                "name": "Jefferson Parish, LA",
                "value": 4.3
            },
            {
                "code": "us-la-053",
                "name": "Jefferson Davis Parish, LA",
                "value": 4.7
            },
            {
                "code": "us-la-055",
                "name": "Lafayette Parish, LA",
                "value": 4.5
            },
            {
                "code": "us-la-057",
                "name": "Lafourche Parish, LA",
                "value": 4.9
            },
            {
                "code": "us-la-059",
                "name": "LaSalle Parish, LA",
                "value": 4.5
            },
            {
                "code": "us-la-061",
                "name": "Lincoln Parish, LA",
                "value": 4.9
            },
            {
                "code": "us-la-063",
                "name": "Livingston Parish, LA",
                "value": 4.1
            },
            {
                "code": "us-la-065",
                "name": "Madison Parish, LA",
                "value": 8
            },
            {
                "code": "us-la-067",
                "name": "Morehouse Parish, LA",
                "value": 8.3
            },
            {
                "code": "us-la-069",
                "name": "Natchitoches Parish, LA",
                "value": 6.1
            },
            {
                "code": "us-la-071",
                "name": "Orleans Parish, LA",
                "value": 4.9
            },
            {
                "code": "us-la-073",
                "name": "Ouachita Parish, LA",
                "value": 5.1
            },
            {
                "code": "us-la-075",
                "name": "Plaquemines Parish, LA",
                "value": 4.7
            },
            {
                "code": "us-la-077",
                "name": "Pointe Coupee Parish, LA",
                "value": 5.6
            },
            {
                "code": "us-la-079",
                "name": "Rapides Parish, LA",
                "value": 5.3
            },
            {
                "code": "us-la-081",
                "name": "Red River Parish, LA",
                "value": 5
            },
            {
                "code": "us-la-083",
                "name": "Richland Parish, LA",
                "value": 6.4
            },
            {
                "code": "us-la-085",
                "name": "Sabine Parish, LA",
                "value": 5.4
            },
            {
                "code": "us-la-087",
                "name": "St. Bernard Parish, LA",
                "value": 4.9
            },
            {
                "code": "us-la-089",
                "name": "St. Charles Parish, LA",
                "value": 4.2
            },
            {
                "code": "us-la-091",
                "name": "St. Helena Parish, LA",
                "value": 6.7
            },
            {
                "code": "us-la-093",
                "name": "St. James Parish, LA",
                "value": 6.4
            },
            {
                "code": "us-la-095",
                "name": "St. John the Baptist Parish, LA",
                "value": 5.8
            },
            {
                "code": "us-la-097",
                "name": "St. Landry Parish, LA",
                "value": 6.3
            },
            {
                "code": "us-la-099",
                "name": "St. Martin Parish, LA",
                "value": 5.4
            },
            {
                "code": "us-la-101",
                "name": "St. Mary Parish, LA",
                "value": 6.8
            },
            {
                "code": "us-la-103",
                "name": "St. Tammany Parish, LA",
                "value": 4
            },
            {
                "code": "us-la-105",
                "name": "Tangipahoa Parish, LA",
                "value": 5.4
            },
            {
                "code": "us-la-107",
                "name": "Tensas Parish, LA",
                "value": 7.9
            },
            {
                "code": "us-la-109",
                "name": "Terrebonne Parish, LA",
                "value": 5.2
            },
            {
                "code": "us-la-111",
                "name": "Union Parish, LA",
                "value": 5.7
            },
            {
                "code": "us-la-113",
                "name": "Vermilion Parish, LA",
                "value": 5.5
            },
            {
                "code": "us-la-115",
                "name": "Vernon Parish, LA",
                "value": 6.8
            },
            {
                "code": "us-la-117",
                "name": "Washington Parish, LA",
                "value": 5.4
            },
            {
                "code": "us-la-119",
                "name": "Webster Parish, LA",
                "value": 6.1
            },
            {
                "code": "us-la-121",
                "name": "West Baton Rouge Parish, LA",
                "value": 4.6
            },
            {
                "code": "us-la-123",
                "name": "West Carroll Parish, LA",
                "value": 11.4
            },
            {
                "code": "us-la-125",
                "name": "West Feliciana Parish, LA",
                "value": 4.2
            },
            {
                "code": "us-la-127",
                "name": "Winn Parish, LA",
                "value": 6.3
            },
            {
                "code": "us-me-001",
                "name": "Androscoggin County, ME",
                "value": 3.6
            },
            {
                "code": "us-me-003",
                "name": "Aroostook County, ME",
                "value": 5.4
            },
            {
                "code": "us-me-005",
                "name": "Cumberland County, ME",
                "value": 2.8
            },
            {
                "code": "us-me-007",
                "name": "Franklin County, ME",
                "value": 4.4
            },
            {
                "code": "us-me-009",
                "name": "Hancock County, ME",
                "value": 5.9
            },
            {
                "code": "us-me-011",
                "name": "Kennebec County, ME",
                "value": 3.8
            },
            {
                "code": "us-me-013",
                "name": "Knox County, ME",
                "value": 4
            },
            {
                "code": "us-me-015",
                "name": "Lincoln County, ME",
                "value": 4.3
            },
            {
                "code": "us-me-017",
                "name": "Oxford County, ME",
                "value": 4.4
            },
            {
                "code": "us-me-019",
                "name": "Penobscot County, ME",
                "value": 4.2
            },
            {
                "code": "us-me-021",
                "name": "Piscataquis County, ME",
                "value": 4.8
            },
            {
                "code": "us-me-023",
                "name": "Sagadahoc County, ME",
                "value": 3.1
            },
            {
                "code": "us-me-025",
                "name": "Somerset County, ME",
                "value": 5.8
            },
            {
                "code": "us-me-027",
                "name": "Waldo County, ME",
                "value": 4.4
            },
            {
                "code": "us-me-029",
                "name": "Washington County, ME",
                "value": 6.3
            },
            {
                "code": "us-me-031",
                "name": "York County, ME",
                "value": 3.8
            },
            {
                "code": "us-md-001",
                "name": "Allegany County, MD",
                "value": 7
            },
            {
                "code": "us-md-003",
                "name": "Anne Arundel County, MD",
                "value": 3.8
            },
            {
                "code": "us-md-005",
                "name": "Baltimore County, MD",
                "value": 4.7
            },
            {
                "code": "us-md-009",
                "name": "Calvert County, MD",
                "value": 4.1
            },
            {
                "code": "us-md-011",
                "name": "Caroline County, MD",
                "value": 5
            },
            {
                "code": "us-md-013",
                "name": "Carroll County, MD",
                "value": 3.9
            },
            {
                "code": "us-md-015",
                "name": "Cecil County, MD",
                "value": 5.4
            },
            {
                "code": "us-md-017",
                "name": "Charles County, MD",
                "value": 4.3
            },
            {
                "code": "us-md-019",
                "name": "Dorchester County, MD",
                "value": 6.6
            },
            {
                "code": "us-md-021",
                "name": "Frederick County, MD",
                "value": 4.1
            },
            {
                "code": "us-md-023",
                "name": "Garrett County, MD",
                "value": 6.5
            },
            {
                "code": "us-md-025",
                "name": "Harford County, MD",
                "value": 4.2
            },
            {
                "code": "us-md-027",
                "name": "Howard County, MD",
                "value": 3.4
            },
            {
                "code": "us-md-029",
                "name": "Kent County, MD",
                "value": 6.2
            },
            {
                "code": "us-md-031",
                "name": "Montgomery County, MD",
                "value": 3.6
            },
            {
                "code": "us-md-033",
                "name": "Prince George's County, MD",
                "value": 4.6
            },
            {
                "code": "us-md-035",
                "name": "Queen Anne's County, MD",
                "value": 4.2
            },
            {
                "code": "us-md-037",
                "name": "St. Mary's County, MD",
                "value": 4.5
            },
            {
                "code": "us-md-039",
                "name": "Somerset County, MD",
                "value": 9.1
            },
            {
                "code": "us-md-041",
                "name": "Talbot County, MD",
                "value": 4.8
            },
            {
                "code": "us-md-043",
                "name": "Washington County, MD",
                "value": 5.3
            },
            {
                "code": "us-md-045",
                "name": "Wicomico County, MD",
                "value": 7.1
            },
            {
                "code": "us-md-047",
                "name": "Worcester County, MD",
                "value": 12.9
            },
            {
                "code": "us-md-510",
                "name": "Baltimore city, MD",
                "value": 6.5
            },
            {
                "code": "us-ma-001",
                "name": "Barnstable County, MA",
                "value": 7.2
            },
            {
                "code": "us-ma-003",
                "name": "Berkshire County, MA",
                "value": 5.3
            },
            {
                "code": "us-ma-005",
                "name": "Bristol County, MA",
                "value": 5.9
            },
            {
                "code": "us-ma-007",
                "name": "Dukes County, MA",
                "value": 9.1
            },
            {
                "code": "us-ma-009",
                "name": "Essex County, MA",
                "value": 4.2
            },
            {
                "code": "us-ma-011",
                "name": "Franklin County, MA",
                "value": 3.9
            },
            {
                "code": "us-ma-013",
                "name": "Hampden County, MA",
                "value": 5.6
            },
            {
                "code": "us-ma-015",
                "name": "Hampshire County, MA",
                "value": 3.6
            },
            {
                "code": "us-ma-017",
                "name": "Middlesex County, MA",
                "value": 3.2
            },
            {
                "code": "us-ma-019",
                "name": "Nantucket County/town, MA",
                "value": 11.3
            },
            {
                "code": "us-ma-021",
                "name": "Norfolk County, MA",
                "value": 3.4
            },
            {
                "code": "us-ma-023",
                "name": "Plymouth County, MA",
                "value": 4.5
            },
            {
                "code": "us-ma-025",
                "name": "Suffolk County, MA",
                "value": 3.5
            },
            {
                "code": "us-ma-027",
                "name": "Worcester County, MA",
                "value": 4.3
            },
            {
                "code": "us-mi-001",
                "name": "Alcona County, MI",
                "value": 8.9
            },
            {
                "code": "us-mi-003",
                "name": "Alger County, MI",
                "value": 10
            },
            {
                "code": "us-mi-005",
                "name": "Allegan County, MI",
                "value": 4.3
            },
            {
                "code": "us-mi-007",
                "name": "Alpena County, MI",
                "value": 6.4
            },
            {
                "code": "us-mi-009",
                "name": "Antrim County, MI",
                "value": 7.9
            },
            {
                "code": "us-mi-011",
                "name": "Arenac County, MI",
                "value": 10.5
            },
            {
                "code": "us-mi-013",
                "name": "Baraga County, MI",
                "value": 7.3
            },
            {
                "code": "us-mi-015",
                "name": "Barry County, MI",
                "value": 4.5
            },
            {
                "code": "us-mi-017",
                "name": "Bay County, MI",
                "value": 6.3
            },
            {
                "code": "us-mi-019",
                "name": "Benzie County, MI",
                "value": 7.9
            },
            {
                "code": "us-mi-021",
                "name": "Berrien County, MI",
                "value": 5.4
            },
            {
                "code": "us-mi-023",
                "name": "Branch County, MI",
                "value": 4.5
            },
            {
                "code": "us-mi-025",
                "name": "Calhoun County, MI",
                "value": 5
            },
            {
                "code": "us-mi-027",
                "name": "Cass County, MI",
                "value": 5
            },
            {
                "code": "us-mi-029",
                "name": "Charlevoix County, MI",
                "value": 6.9
            },
            {
                "code": "us-mi-031",
                "name": "Cheboygan County, MI",
                "value": 17.9
            },
            {
                "code": "us-mi-033",
                "name": "Chippewa County, MI",
                "value": 9
            },
            {
                "code": "us-mi-035",
                "name": "Clare County, MI",
                "value": 8.2
            },
            {
                "code": "us-mi-037",
                "name": "Clinton County, MI",
                "value": 4.3
            },
            {
                "code": "us-mi-039",
                "name": "Crawford County, MI",
                "value": 7.9
            },
            {
                "code": "us-mi-041",
                "name": "Delta County, MI",
                "value": 6.9
            },
            {
                "code": "us-mi-043",
                "name": "Dickinson County, MI",
                "value": 4.8
            },
            {
                "code": "us-mi-045",
                "name": "Eaton County, MI",
                "value": 4.9
            },
            {
                "code": "us-mi-047",
                "name": "Emmet County, MI",
                "value": 8.5
            },
            {
                "code": "us-mi-049",
                "name": "Genesee County, MI",
                "value": 6.1
            },
            {
                "code": "us-mi-051",
                "name": "Gladwin County, MI",
                "value": 7.8
            },
            {
                "code": "us-mi-053",
                "name": "Gogebic County, MI",
                "value": 5.5
            },
            {
                "code": "us-mi-055",
                "name": "Grand Traverse County, MI",
                "value": 5
            },
            {
                "code": "us-mi-057",
                "name": "Gratiot County, MI",
                "value": 6.7
            },
            {
                "code": "us-mi-059",
                "name": "Hillsdale County, MI",
                "value": 5.1
            },
            {
                "code": "us-mi-061",
                "name": "Houghton County, MI",
                "value": 6.2
            },
            {
                "code": "us-mi-063",
                "name": "Huron County, MI",
                "value": 6.2
            },
            {
                "code": "us-mi-065",
                "name": "Ingham County, MI",
                "value": 4.7
            },
            {
                "code": "us-mi-067",
                "name": "Ionia County, MI",
                "value": 4.5
            },
            {
                "code": "us-mi-069",
                "name": "Iosco County, MI",
                "value": 8.9
            },
            {
                "code": "us-mi-071",
                "name": "Iron County, MI",
                "value": 7.8
            },
            {
                "code": "us-mi-073",
                "name": "Isabella County, MI",
                "value": 4.8
            },
            {
                "code": "us-mi-075",
                "name": "Jackson County, MI",
                "value": 5
            },
            {
                "code": "us-mi-077",
                "name": "Kalamazoo County, MI",
                "value": 4
            },
            {
                "code": "us-mi-079",
                "name": "Kalkaska County, MI",
                "value": 8.4
            },
            {
                "code": "us-mi-081",
                "name": "Kent County, MI",
                "value": 3.6
            },
            {
                "code": "us-mi-083",
                "name": "Keweenaw County, MI",
                "value": 8.5
            },
            {
                "code": "us-mi-085",
                "name": "Lake County, MI",
                "value": 9.1
            },
            {
                "code": "us-mi-087",
                "name": "Lapeer County, MI",
                "value": 7.4
            },
            {
                "code": "us-mi-089",
                "name": "Leelanau County, MI",
                "value": 6.2
            },
            {
                "code": "us-mi-091",
                "name": "Lenawee County, MI",
                "value": 5.2
            },
            {
                "code": "us-mi-093",
                "name": "Livingston County, MI",
                "value": 4.1
            },
            {
                "code": "us-mi-095",
                "name": "Luce County, MI",
                "value": 7.5
            },
            {
                "code": "us-mi-097",
                "name": "Mackinac County, MI",
                "value": 20.8
            },
            {
                "code": "us-mi-099",
                "name": "Macomb County, MI",
                "value": 4.8
            },
            {
                "code": "us-mi-101",
                "name": "Manistee County, MI",
                "value": 7.9
            },
            {
                "code": "us-mi-103",
                "name": "Marquette County, MI",
                "value": 6.2
            },
            {
                "code": "us-mi-105",
                "name": "Mason County, MI",
                "value": 6.9
            },
            {
                "code": "us-mi-107",
                "name": "Mecosta County, MI",
                "value": 6.3
            },
            {
                "code": "us-mi-109",
                "name": "Menominee County, MI",
                "value": 5.1
            },
            {
                "code": "us-mi-111",
                "name": "Midland County, MI",
                "value": 5.2
            },
            {
                "code": "us-mi-113",
                "name": "Missaukee County, MI",
                "value": 7.3
            },
            {
                "code": "us-mi-115",
                "name": "Monroe County, MI",
                "value": 5
            },
            {
                "code": "us-mi-117",
                "name": "Montcalm County, MI",
                "value": 5.5
            },
            {
                "code": "us-mi-119",
                "name": "Montmorency County, MI",
                "value": 12.1
            },
            {
                "code": "us-mi-121",
                "name": "Muskegon County, MI",
                "value": 5.5
            },
            {
                "code": "us-mi-123",
                "name": "Newaygo County, MI",
                "value": 5.7
            },
            {
                "code": "us-mi-125",
                "name": "Oakland County, MI",
                "value": 3.9
            },
            {
                "code": "us-mi-127",
                "name": "Oceana County, MI",
                "value": 8.9
            },
            {
                "code": "us-mi-129",
                "name": "Ogemaw County, MI",
                "value": 10
            },
            {
                "code": "us-mi-131",
                "name": "Ontonagon County, MI",
                "value": 8.6
            },
            {
                "code": "us-mi-133",
                "name": "Osceola County, MI",
                "value": 6.4
            },
            {
                "code": "us-mi-135",
                "name": "Oscoda County, MI",
                "value": 8.9
            },
            {
                "code": "us-mi-137",
                "name": "Otsego County, MI",
                "value": 6.8
            },
            {
                "code": "us-mi-139",
                "name": "Ottawa County, MI",
                "value": 3.4
            },
            {
                "code": "us-mi-141",
                "name": "Presque Isle County, MI",
                "value": 12.2
            },
            {
                "code": "us-mi-143",
                "name": "Roscommon County, MI",
                "value": 11.4
            },
            {
                "code": "us-mi-145",
                "name": "Saginaw County, MI",
                "value": 6.1
            },
            {
                "code": "us-mi-147",
                "name": "St. Clair County, MI",
                "value": 6.2
            },
            {
                "code": "us-mi-149",
                "name": "St. Joseph County, MI",
                "value": 4.1
            },
            {
                "code": "us-mi-151",
                "name": "Sanilac County, MI",
                "value": 7.2
            },
            {
                "code": "us-mi-153",
                "name": "Schoolcraft County, MI",
                "value": 10.4
            },
            {
                "code": "us-mi-155",
                "name": "Shiawassee County, MI",
                "value": 6.2
            },
            {
                "code": "us-mi-157",
                "name": "Tuscola County, MI",
                "value": 7.4
            },
            {
                "code": "us-mi-159",
                "name": "Van Buren County, MI",
                "value": 6.9
            },
            {
                "code": "us-mi-161",
                "name": "Washtenaw County, MI",
                "value": 3.4
            },
            {
                "code": "us-mi-163",
                "name": "Wayne County, MI",
                "value": 6
            },
            {
                "code": "us-mi-165",
                "name": "Wexford County, MI",
                "value": 6.1
            },
            {
                "code": "us-mn-001",
                "name": "Aitkin County, MN",
                "value": 9.1
            },
            {
                "code": "us-mn-003",
                "name": "Anoka County, MN",
                "value": 3.5
            },
            {
                "code": "us-mn-005",
                "name": "Becker County, MN",
                "value": 5.7
            },
            {
                "code": "us-mn-007",
                "name": "Beltrami County, MN",
                "value": 5.9
            },
            {
                "code": "us-mn-009",
                "name": "Benton County, MN",
                "value": 5.6
            },
            {
                "code": "us-mn-011",
                "name": "Big Stone County, MN",
                "value": 6.8
            },
            {
                "code": "us-mn-013",
                "name": "Blue Earth County, MN",
                "value": 3.3
            },
            {
                "code": "us-mn-015",
                "name": "Brown County, MN",
                "value": 5.2
            },
            {
                "code": "us-mn-017",
                "name": "Carlton County, MN",
                "value": 5.9
            },
            {
                "code": "us-mn-019",
                "name": "Carver County, MN",
                "value": 3.1
            },
            {
                "code": "us-mn-021",
                "name": "Cass County, MN",
                "value": 8.8
            },
            {
                "code": "us-mn-023",
                "name": "Chippewa County, MN",
                "value": 5
            },
            {
                "code": "us-mn-025",
                "name": "Chisago County, MN",
                "value": 4.9
            },
            {
                "code": "us-mn-027",
                "name": "Clay County, MN",
                "value": 4
            },
            {
                "code": "us-mn-029",
                "name": "Clearwater County, MN",
                "value": 14.2
            },
            {
                "code": "us-mn-031",
                "name": "Cook County, MN",
                "value": 5.8
            },
            {
                "code": "us-mn-033",
                "name": "Cottonwood County, MN",
                "value": 4.2
            },
            {
                "code": "us-mn-035",
                "name": "Crow Wing County, MN",
                "value": 6.3
            },
            {
                "code": "us-mn-037",
                "name": "Dakota County, MN",
                "value": 3.1
            },
            {
                "code": "us-mn-039",
                "name": "Dodge County, MN",
                "value": 4.4
            },
            {
                "code": "us-mn-041",
                "name": "Douglas County, MN",
                "value": 4.1
            },
            {
                "code": "us-mn-043",
                "name": "Faribault County, MN",
                "value": 5.3
            },
            {
                "code": "us-mn-045",
                "name": "Fillmore County, MN",
                "value": 4.9
            },
            {
                "code": "us-mn-047",
                "name": "Freeborn County, MN",
                "value": 4.4
            },
            {
                "code": "us-mn-049",
                "name": "Goodhue County, MN",
                "value": 4
            },
            {
                "code": "us-mn-051",
                "name": "Grant County, MN",
                "value": 6.2
            },
            {
                "code": "us-mn-053",
                "name": "Hennepin County, MN",
                "value": 2.9
            },
            {
                "code": "us-mn-055",
                "name": "Houston County, MN",
                "value": 4.7
            },
            {
                "code": "us-mn-057",
                "name": "Hubbard County, MN",
                "value": 7.9
            },
            {
                "code": "us-mn-059",
                "name": "Isanti County, MN",
                "value": 5.7
            },
            {
                "code": "us-mn-061",
                "name": "Itasca County, MN",
                "value": 7.5
            },
            {
                "code": "us-mn-063",
                "name": "Jackson County, MN",
                "value": 3.9
            },
            {
                "code": "us-mn-065",
                "name": "Kanabec County, MN",
                "value": 9.6
            },
            {
                "code": "us-mn-067",
                "name": "Kandiyohi County, MN",
                "value": 4.4
            },
            {
                "code": "us-mn-069",
                "name": "Kittson County, MN",
                "value": 4.4
            },
            {
                "code": "us-mn-071",
                "name": "Koochiching County, MN",
                "value": 6.7
            },
            {
                "code": "us-mn-073",
                "name": "Lac qui Parle County, MN",
                "value": 5.5
            },
            {
                "code": "us-mn-075",
                "name": "Lake County, MN",
                "value": 4.7
            },
            {
                "code": "us-mn-077",
                "name": "Lake of the Woods County, MN",
                "value": 4.4
            },
            {
                "code": "us-mn-079",
                "name": "Le Sueur County, MN",
                "value": 7.3
            },
            {
                "code": "us-mn-081",
                "name": "Lincoln County, MN",
                "value": 5.1
            },
            {
                "code": "us-mn-083",
                "name": "Lyon County, MN",
                "value": 4.1
            },
            {
                "code": "us-mn-085",
                "name": "McLeod County, MN",
                "value": 4.5
            },
            {
                "code": "us-mn-087",
                "name": "Mahnomen County, MN",
                "value": 6.6
            },
            {
                "code": "us-mn-089",
                "name": "Marshall County, MN",
                "value": 10.4
            },
            {
                "code": "us-mn-091",
                "name": "Martin County, MN",
                "value": 3.9
            },
            {
                "code": "us-mn-093",
                "name": "Meeker County, MN",
                "value": 5.4
            },
            {
                "code": "us-mn-095",
                "name": "Mille Lacs County, MN",
                "value": 8.1
            },
            {
                "code": "us-mn-097",
                "name": "Morrison County, MN",
                "value": 8.4
            },
            {
                "code": "us-mn-099",
                "name": "Mower County, MN",
                "value": 3.4
            },
            {
                "code": "us-mn-101",
                "name": "Murray County, MN",
                "value": 6.8
            },
            {
                "code": "us-mn-103",
                "name": "Nicollet County, MN",
                "value": 2.9
            },
            {
                "code": "us-mn-105",
                "name": "Nobles County, MN",
                "value": 3.9
            },
            {
                "code": "us-mn-107",
                "name": "Norman County, MN",
                "value": 6.3
            },
            {
                "code": "us-mn-109",
                "name": "Olmsted County, MN",
                "value": 3
            },
            {
                "code": "us-mn-111",
                "name": "Otter Tail County, MN",
                "value": 5.9
            },
            {
                "code": "us-mn-113",
                "name": "Pennington County, MN",
                "value": 8
            },
            {
                "code": "us-mn-115",
                "name": "Pine County, MN",
                "value": 8.1
            },
            {
                "code": "us-mn-117",
                "name": "Pipestone County, MN",
                "value": 5.1
            },
            {
                "code": "us-mn-119",
                "name": "Polk County, MN",
                "value": 4.8
            },
            {
                "code": "us-mn-121",
                "name": "Pope County, MN",
                "value": 4.1
            },
            {
                "code": "us-mn-123",
                "name": "Ramsey County, MN",
                "value": 3.1
            },
            {
                "code": "us-mn-125",
                "name": "Red Lake County, MN",
                "value": 8.2
            },
            {
                "code": "us-mn-127",
                "name": "Redwood County, MN",
                "value": 5.5
            },
            {
                "code": "us-mn-129",
                "name": "Renville County, MN",
                "value": 5.8
            },
            {
                "code": "us-mn-131",
                "name": "Rice County, MN",
                "value": 3.6
            },
            {
                "code": "us-mn-133",
                "name": "Rock County, MN",
                "value": 3.3
            },
            {
                "code": "us-mn-135",
                "name": "Roseau County, MN",
                "value": 5.5
            },
            {
                "code": "us-mn-137",
                "name": "St. Louis County, MN",
                "value": 4.9
            },
            {
                "code": "us-mn-139",
                "name": "Scott County, MN",
                "value": 3.1
            },
            {
                "code": "us-mn-141",
                "name": "Sherburne County, MN",
                "value": 4.7
            },
            {
                "code": "us-mn-143",
                "name": "Sibley County, MN",
                "value": 4.8
            },
            {
                "code": "us-mn-145",
                "name": "Stearns County, MN",
                "value": 4.2
            },
            {
                "code": "us-mn-147",
                "name": "Steele County, MN",
                "value": 4.1
            },
            {
                "code": "us-mn-149",
                "name": "Stevens County, MN",
                "value": 3.4
            },
            {
                "code": "us-mn-151",
                "name": "Swift County, MN",
                "value": 5.8
            },
            {
                "code": "us-mn-153",
                "name": "Todd County, MN",
                "value": 5.7
            },
            {
                "code": "us-mn-155",
                "name": "Traverse County, MN",
                "value": 5.2
            },
            {
                "code": "us-mn-157",
                "name": "Wabasha County, MN",
                "value": 4.3
            },
            {
                "code": "us-mn-159",
                "name": "Wadena County, MN",
                "value": 7.9
            },
            {
                "code": "us-mn-161",
                "name": "Waseca County, MN",
                "value": 6.7
            },
            {
                "code": "us-mn-163",
                "name": "Washington County, MN",
                "value": 3.1
            },
            {
                "code": "us-mn-165",
                "name": "Watonwan County, MN",
                "value": 5.2
            },
            {
                "code": "us-mn-167",
                "name": "Wilkin County, MN",
                "value": 3.9
            },
            {
                "code": "us-mn-169",
                "name": "Winona County, MN",
                "value": 3.1
            },
            {
                "code": "us-mn-171",
                "name": "Wright County, MN",
                "value": 4.3
            },
            {
                "code": "us-mn-173",
                "name": "Yellow Medicine County, MN",
                "value": 4.5
            },
            {
                "code": "us-ms-001",
                "name": "Adams County, MS",
                "value": 6.8
            },
            {
                "code": "us-ms-003",
                "name": "Alcorn County, MS",
                "value": 4.4
            },
            {
                "code": "us-ms-005",
                "name": "Amite County, MS",
                "value": 6.4
            },
            {
                "code": "us-ms-007",
                "name": "Attala County, MS",
                "value": 6.7
            },
            {
                "code": "us-ms-009",
                "name": "Benton County, MS",
                "value": 6
            },
            {
                "code": "us-ms-011",
                "name": "Bolivar County, MS",
                "value": 6.8
            },
            {
                "code": "us-ms-013",
                "name": "Calhoun County, MS",
                "value": 4.5
            },
            {
                "code": "us-ms-015",
                "name": "Carroll County, MS",
                "value": 6.5
            },
            {
                "code": "us-ms-017",
                "name": "Chickasaw County, MS",
                "value": 5.2
            },
            {
                "code": "us-ms-019",
                "name": "Choctaw County, MS",
                "value": 6.5
            },
            {
                "code": "us-ms-021",
                "name": "Claiborne County, MS",
                "value": 9.7
            },
            {
                "code": "us-ms-023",
                "name": "Clarke County, MS",
                "value": 6.3
            },
            {
                "code": "us-ms-025",
                "name": "Clay County, MS",
                "value": 6.4
            },
            {
                "code": "us-ms-027",
                "name": "Coahoma County, MS",
                "value": 8.2
            },
            {
                "code": "us-ms-029",
                "name": "Copiah County, MS",
                "value": 5.6
            },
            {
                "code": "us-ms-031",
                "name": "Covington County, MS",
                "value": 4.7
            },
            {
                "code": "us-ms-033",
                "name": "DeSoto County, MS",
                "value": 3.8
            },
            {
                "code": "us-ms-035",
                "name": "Forrest County, MS",
                "value": 4.7
            },
            {
                "code": "us-ms-037",
                "name": "Franklin County, MS",
                "value": 7.2
            },
            {
                "code": "us-ms-039",
                "name": "George County, MS",
                "value": 7.6
            },
            {
                "code": "us-ms-041",
                "name": "Greene County, MS",
                "value": 7.6
            },
            {
                "code": "us-ms-043",
                "name": "Grenada County, MS",
                "value": 4.5
            },
            {
                "code": "us-ms-045",
                "name": "Hancock County, MS",
                "value": 5.4
            },
            {
                "code": "us-ms-047",
                "name": "Harrison County, MS",
                "value": 4.8
            },
            {
                "code": "us-ms-049",
                "name": "Hinds County, MS",
                "value": 4.8
            },
            {
                "code": "us-ms-051",
                "name": "Holmes County, MS",
                "value": 10.3
            },
            {
                "code": "us-ms-053",
                "name": "Humphreys County, MS",
                "value": 10.6
            },
            {
                "code": "us-ms-055",
                "name": "Issaquena County, MS",
                "value": 11.9
            },
            {
                "code": "us-ms-057",
                "name": "Itawamba County, MS",
                "value": 3.9
            },
            {
                "code": "us-ms-059",
                "name": "Jackson County, MS",
                "value": 6.1
            },
            {
                "code": "us-ms-061",
                "name": "Jasper County, MS",
                "value": 6.6
            },
            {
                "code": "us-ms-063",
                "name": "Jefferson County, MS",
                "value": 14.8
            },
            {
                "code": "us-ms-065",
                "name": "Jefferson Davis County, MS",
                "value": 7.2
            },
            {
                "code": "us-ms-067",
                "name": "Jones County, MS",
                "value": 5
            },
            {
                "code": "us-ms-069",
                "name": "Kemper County, MS",
                "value": 7.5
            },
            {
                "code": "us-ms-071",
                "name": "Lafayette County, MS",
                "value": 4.3
            },
            {
                "code": "us-ms-073",
                "name": "Lamar County, MS",
                "value": 3.8
            },
            {
                "code": "us-ms-075",
                "name": "Lauderdale County, MS",
                "value": 5.3
            },
            {
                "code": "us-ms-077",
                "name": "Lawrence County, MS",
                "value": 6.3
            },
            {
                "code": "us-ms-079",
                "name": "Leake County, MS",
                "value": 5.3
            },
            {
                "code": "us-ms-081",
                "name": "Lee County, MS",
                "value": 4
            },
            {
                "code": "us-ms-083",
                "name": "Leflore County, MS",
                "value": 8.4
            },
            {
                "code": "us-ms-085",
                "name": "Lincoln County, MS",
                "value": 5.4
            },
            {
                "code": "us-ms-087",
                "name": "Lowndes County, MS",
                "value": 5.1
            },
            {
                "code": "us-ms-089",
                "name": "Madison County, MS",
                "value": 3.8
            },
            {
                "code": "us-ms-091",
                "name": "Marion County, MS",
                "value": 5.3
            },
            {
                "code": "us-ms-093",
                "name": "Marshall County, MS",
                "value": 5.2
            },
            {
                "code": "us-ms-095",
                "name": "Monroe County, MS",
                "value": 5.1
            },
            {
                "code": "us-ms-097",
                "name": "Montgomery County, MS",
                "value": 5.9
            },
            {
                "code": "us-ms-099",
                "name": "Neshoba County, MS",
                "value": 5.4
            },
            {
                "code": "us-ms-101",
                "name": "Newton County, MS",
                "value": 5.2
            },
            {
                "code": "us-ms-103",
                "name": "Noxubee County, MS",
                "value": 7.5
            },
            {
                "code": "us-ms-105",
                "name": "Oktibbeha County, MS",
                "value": 4.8
            },
            {
                "code": "us-ms-107",
                "name": "Panola County, MS",
                "value": 6.9
            },
            {
                "code": "us-ms-109",
                "name": "Pearl River County, MS",
                "value": 5
            },
            {
                "code": "us-ms-111",
                "name": "Perry County, MS",
                "value": 6.8
            },
            {
                "code": "us-ms-113",
                "name": "Pike County, MS",
                "value": 6.1
            },
            {
                "code": "us-ms-115",
                "name": "Pontotoc County, MS",
                "value": 4.1
            },
            {
                "code": "us-ms-117",
                "name": "Prentiss County, MS",
                "value": 4.3
            },
            {
                "code": "us-ms-119",
                "name": "Quitman County, MS",
                "value": 9.6
            },
            {
                "code": "us-ms-121",
                "name": "Rankin County, MS",
                "value": 3.6
            },
            {
                "code": "us-ms-123",
                "name": "Scott County, MS",
                "value": 4
            },
            {
                "code": "us-ms-125",
                "name": "Sharkey County, MS",
                "value": 9.8
            },
            {
                "code": "us-ms-127",
                "name": "Simpson County, MS",
                "value": 4.9
            },
            {
                "code": "us-ms-129",
                "name": "Smith County, MS",
                "value": 4.9
            },
            {
                "code": "us-ms-131",
                "name": "Stone County, MS",
                "value": 5.7
            },
            {
                "code": "us-ms-133",
                "name": "Sunflower County, MS",
                "value": 10.1
            },
            {
                "code": "us-ms-135",
                "name": "Tallahatchie County, MS",
                "value": 6.7
            },
            {
                "code": "us-ms-137",
                "name": "Tate County, MS",
                "value": 5.2
            },
            {
                "code": "us-ms-139",
                "name": "Tippah County, MS",
                "value": 4.8
            },
            {
                "code": "us-ms-141",
                "name": "Tishomingo County, MS",
                "value": 5.2
            },
            {
                "code": "us-ms-143",
                "name": "Tunica County, MS",
                "value": 7
            },
            {
                "code": "us-ms-145",
                "name": "Union County, MS",
                "value": 3.5
            },
            {
                "code": "us-ms-147",
                "name": "Walthall County, MS",
                "value": 6.4
            },
            {
                "code": "us-ms-149",
                "name": "Warren County, MS",
                "value": 5.9
            },
            {
                "code": "us-ms-151",
                "name": "Washington County, MS",
                "value": 8.1
            },
            {
                "code": "us-ms-153",
                "name": "Wayne County, MS",
                "value": 5.9
            },
            {
                "code": "us-ms-155",
                "name": "Webster County, MS",
                "value": 5.5
            },
            {
                "code": "us-ms-157",
                "name": "Wilkinson County, MS",
                "value": 9.4
            },
            {
                "code": "us-ms-159",
                "name": "Winston County, MS",
                "value": 6.5
            },
            {
                "code": "us-ms-161",
                "name": "Yalobusha County, MS",
                "value": 5.7
            },
            {
                "code": "us-ms-163",
                "name": "Yazoo County, MS",
                "value": 6.1
            },
            {
                "code": "us-mo-001",
                "name": "Adair County, MO",
                "value": 4.5
            },
            {
                "code": "us-mo-003",
                "name": "Andrew County, MO",
                "value": 3.1
            },
            {
                "code": "us-mo-005",
                "name": "Atchison County, MO",
                "value": 3
            },
            {
                "code": "us-mo-007",
                "name": "Audrain County, MO",
                "value": 3.7
            },
            {
                "code": "us-mo-009",
                "name": "Barry County, MO",
                "value": 3.7
            },
            {
                "code": "us-mo-011",
                "name": "Barton County, MO",
                "value": 3.4
            },
            {
                "code": "us-mo-013",
                "name": "Bates County, MO",
                "value": 5
            },
            {
                "code": "us-mo-015",
                "name": "Benton County, MO",
                "value": 5.6
            },
            {
                "code": "us-mo-017",
                "name": "Bollinger County, MO",
                "value": 5
            },
            {
                "code": "us-mo-019",
                "name": "Boone County, MO",
                "value": 2.7
            },
            {
                "code": "us-mo-021",
                "name": "Buchanan County, MO",
                "value": 3.4
            },
            {
                "code": "us-mo-023",
                "name": "Butler County, MO",
                "value": 5.3
            },
            {
                "code": "us-mo-025",
                "name": "Caldwell County, MO",
                "value": 4.1
            },
            {
                "code": "us-mo-027",
                "name": "Callaway County, MO",
                "value": 3.7
            },
            {
                "code": "us-mo-029",
                "name": "Camden County, MO",
                "value": 6.5
            },
            {
                "code": "us-mo-031",
                "name": "Cape Girardeau County, MO",
                "value": 3.3
            },
            {
                "code": "us-mo-033",
                "name": "Carroll County, MO",
                "value": 4.4
            },
            {
                "code": "us-mo-035",
                "name": "Carter County, MO",
                "value": 6.5
            },
            {
                "code": "us-mo-037",
                "name": "Cass County, MO",
                "value": 3.7
            },
            {
                "code": "us-mo-039",
                "name": "Cedar County, MO",
                "value": 3.8
            },
            {
                "code": "us-mo-041",
                "name": "Chariton County, MO",
                "value": 3.5
            },
            {
                "code": "us-mo-043",
                "name": "Christian County, MO",
                "value": 3.2
            },
            {
                "code": "us-mo-045",
                "name": "Clark County, MO",
                "value": 4.6
            },
            {
                "code": "us-mo-047",
                "name": "Clay County, MO",
                "value": 3.7
            },
            {
                "code": "us-mo-049",
                "name": "Clinton County, MO",
                "value": 4.1
            },
            {
                "code": "us-mo-051",
                "name": "Cole County, MO",
                "value": 3.1
            },
            {
                "code": "us-mo-053",
                "name": "Cooper County, MO",
                "value": 3.8
            },
            {
                "code": "us-mo-055",
                "name": "Crawford County, MO",
                "value": 5.1
            },
            {
                "code": "us-mo-057",
                "name": "Dade County, MO",
                "value": 3.5
            },
            {
                "code": "us-mo-059",
                "name": "Dallas County, MO",
                "value": 4.6
            },
            {
                "code": "us-mo-061",
                "name": "Daviess County, MO",
                "value": 4
            },
            {
                "code": "us-mo-063",
                "name": "DeKalb County, MO",
                "value": 4.1
            },
            {
                "code": "us-mo-065",
                "name": "Dent County, MO",
                "value": 3.9
            },
            {
                "code": "us-mo-067",
                "name": "Douglas County, MO",
                "value": 4.3
            },
            {
                "code": "us-mo-069",
                "name": "Dunklin County, MO",
                "value": 6.2
            },
            {
                "code": "us-mo-071",
                "name": "Franklin County, MO",
                "value": 3.7
            },
            {
                "code": "us-mo-073",
                "name": "Gasconade County, MO",
                "value": 4
            },
            {
                "code": "us-mo-075",
                "name": "Gentry County, MO",
                "value": 2.6
            },
            {
                "code": "us-mo-077",
                "name": "Greene County, MO",
                "value": 3
            },
            {
                "code": "us-mo-079",
                "name": "Grundy County, MO",
                "value": 3.3
            },
            {
                "code": "us-mo-081",
                "name": "Harrison County, MO",
                "value": 4.3
            },
            {
                "code": "us-mo-083",
                "name": "Henry County, MO",
                "value": 4.2
            },
            {
                "code": "us-mo-085",
                "name": "Hickory County, MO",
                "value": 5
            },
            {
                "code": "us-mo-087",
                "name": "Holt County, MO",
                "value": 2.9
            },
            {
                "code": "us-mo-089",
                "name": "Howard County, MO",
                "value": 3.9
            },
            {
                "code": "us-mo-091",
                "name": "Howell County, MO",
                "value": 4.1
            },
            {
                "code": "us-mo-093",
                "name": "Iron County, MO",
                "value": 6.7
            },
            {
                "code": "us-mo-095",
                "name": "Jackson County, MO",
                "value": 4.3
            },
            {
                "code": "us-mo-097",
                "name": "Jasper County, MO",
                "value": 3.1
            },
            {
                "code": "us-mo-099",
                "name": "Jefferson County, MO",
                "value": 3.9
            },
            {
                "code": "us-mo-101",
                "name": "Johnson County, MO",
                "value": 4.7
            },
            {
                "code": "us-mo-103",
                "name": "Knox County, MO",
                "value": 3.6
            },
            {
                "code": "us-mo-105",
                "name": "Laclede County, MO",
                "value": 4.3
            },
            {
                "code": "us-mo-107",
                "name": "Lafayette County, MO",
                "value": 4
            },
            {
                "code": "us-mo-109",
                "name": "Lawrence County, MO",
                "value": 3.7
            },
            {
                "code": "us-mo-111",
                "name": "Lewis County, MO",
                "value": 3.4
            },
            {
                "code": "us-mo-113",
                "name": "Lincoln County, MO",
                "value": 4.2
            },
            {
                "code": "us-mo-115",
                "name": "Linn County, MO",
                "value": 6.2
            },
            {
                "code": "us-mo-117",
                "name": "Livingston County, MO",
                "value": 3.1
            },
            {
                "code": "us-mo-119",
                "name": "McDonald County, MO",
                "value": 3.5
            },
            {
                "code": "us-mo-121",
                "name": "Macon County, MO",
                "value": 3.8
            },
            {
                "code": "us-mo-123",
                "name": "Madison County, MO",
                "value": 4.7
            },
            {
                "code": "us-mo-125",
                "name": "Maries County, MO",
                "value": 3.8
            },
            {
                "code": "us-mo-127",
                "name": "Marion County, MO",
                "value": 3.7
            },
            {
                "code": "us-mo-129",
                "name": "Mercer County, MO",
                "value": 4
            },
            {
                "code": "us-mo-131",
                "name": "Miller County, MO",
                "value": 5.5
            },
            {
                "code": "us-mo-133",
                "name": "Mississippi County, MO",
                "value": 4.1
            },
            {
                "code": "us-mo-135",
                "name": "Moniteau County, MO",
                "value": 3.9
            },
            {
                "code": "us-mo-137",
                "name": "Monroe County, MO",
                "value": 4.8
            },
            {
                "code": "us-mo-139",
                "name": "Montgomery County, MO",
                "value": 3.4
            },
            {
                "code": "us-mo-141",
                "name": "Morgan County, MO",
                "value": 5.8
            },
            {
                "code": "us-mo-143",
                "name": "New Madrid County, MO",
                "value": 5.4
            },
            {
                "code": "us-mo-145",
                "name": "Newton County, MO",
                "value": 3.3
            },
            {
                "code": "us-mo-147",
                "name": "Nodaway County, MO",
                "value": 3.3
            },
            {
                "code": "us-mo-149",
                "name": "Oregon County, MO",
                "value": 3.8
            },
            {
                "code": "us-mo-151",
                "name": "Osage County, MO",
                "value": 3
            },
            {
                "code": "us-mo-153",
                "name": "Ozark County, MO",
                "value": 5.8
            },
            {
                "code": "us-mo-155",
                "name": "Pemiscot County, MO",
                "value": 6.7
            },
            {
                "code": "us-mo-157",
                "name": "Perry County, MO",
                "value": 2.8
            },
            {
                "code": "us-mo-159",
                "name": "Pettis County, MO",
                "value": 4.2
            },
            {
                "code": "us-mo-161",
                "name": "Phelps County, MO",
                "value": 3.8
            },
            {
                "code": "us-mo-163",
                "name": "Pike County, MO",
                "value": 3.9
            },
            {
                "code": "us-mo-165",
                "name": "Platte County, MO",
                "value": 3.4
            },
            {
                "code": "us-mo-167",
                "name": "Polk County, MO",
                "value": 4
            },
            {
                "code": "us-mo-169",
                "name": "Pulaski County, MO",
                "value": 4.2
            },
            {
                "code": "us-mo-171",
                "name": "Putnam County, MO",
                "value": 4.3
            },
            {
                "code": "us-mo-173",
                "name": "Ralls County, MO",
                "value": 3.5
            },
            {
                "code": "us-mo-175",
                "name": "Randolph County, MO",
                "value": 4.5
            },
            {
                "code": "us-mo-177",
                "name": "Ray County, MO",
                "value": 4.6
            },
            {
                "code": "us-mo-179",
                "name": "Reynolds County, MO",
                "value": 3.7
            },
            {
                "code": "us-mo-181",
                "name": "Ripley County, MO",
                "value": 5.9
            },
            {
                "code": "us-mo-183",
                "name": "St. Charles County, MO",
                "value": 3
            },
            {
                "code": "us-mo-185",
                "name": "St. Clair County, MO",
                "value": 5
            },
            {
                "code": "us-mo-186",
                "name": "Ste. Genevieve County, MO",
                "value": 3.7
            },
            {
                "code": "us-mo-187",
                "name": "St. Francois County, MO",
                "value": 4.6
            },
            {
                "code": "us-mo-189",
                "name": "St. Louis County, MO",
                "value": 3.3
            },
            {
                "code": "us-mo-195",
                "name": "Saline County, MO",
                "value": 3.5
            },
            {
                "code": "us-mo-197",
                "name": "Schuyler County, MO",
                "value": 5.6
            },
            {
                "code": "us-mo-199",
                "name": "Scotland County, MO",
                "value": 3.7
            },
            {
                "code": "us-mo-201",
                "name": "Scott County, MO",
                "value": 3.8
            },
            {
                "code": "us-mo-203",
                "name": "Shannon County, MO",
                "value": 6
            },
            {
                "code": "us-mo-205",
                "name": "Shelby County, MO",
                "value": 4.1
            },
            {
                "code": "us-mo-207",
                "name": "Stoddard County, MO",
                "value": 5.5
            },
            {
                "code": "us-mo-209",
                "name": "Stone County, MO",
                "value": 9.6
            },
            {
                "code": "us-mo-211",
                "name": "Sullivan County, MO",
                "value": 4.1
            },
            {
                "code": "us-mo-213",
                "name": "Taney County, MO",
                "value": 12
            },
            {
                "code": "us-mo-215",
                "name": "Texas County, MO",
                "value": 4.9
            },
            {
                "code": "us-mo-217",
                "name": "Vernon County, MO",
                "value": 3.5
            },
            {
                "code": "us-mo-219",
                "name": "Warren County, MO",
                "value": 3.6
            },
            {
                "code": "us-mo-221",
                "name": "Washington County, MO",
                "value": 5.8
            },
            {
                "code": "us-mo-223",
                "name": "Wayne County, MO",
                "value": 5.1
            },
            {
                "code": "us-mo-225",
                "name": "Webster County, MO",
                "value": 3.6
            },
            {
                "code": "us-mo-227",
                "name": "Worth County, MO",
                "value": 3
            },
            {
                "code": "us-mo-229",
                "name": "Wright County, MO",
                "value": 4.6
            },
            {
                "code": "us-mo-510",
                "name": "St. Louis city, MO",
                "value": 4.2
            },
            {
                "code": "us-mt-001",
                "name": "Beaverhead County, MT",
                "value": 4
            },
            {
                "code": "us-mt-003",
                "name": "Big Horn County, MT",
                "value": 11.2
            },
            {
                "code": "us-mt-005",
                "name": "Blaine County, MT",
                "value": 5.6
            },
            {
                "code": "us-mt-007",
                "name": "Broadwater County, MT",
                "value": 5.1
            },
            {
                "code": "us-mt-009",
                "name": "Carbon County, MT",
                "value": 4.5
            },
            {
                "code": "us-mt-011",
                "name": "Carter County, MT",
                "value": 3.3
            },
            {
                "code": "us-mt-013",
                "name": "Cascade County, MT",
                "value": 4.5
            },
            {
                "code": "us-mt-015",
                "name": "Chouteau County, MT",
                "value": 3.6
            },
            {
                "code": "us-mt-017",
                "name": "Custer County, MT",
                "value": 3.9
            },
            {
                "code": "us-mt-019",
                "name": "Daniels County, MT",
                "value": 2.7
            },
            {
                "code": "us-mt-021",
                "name": "Dawson County, MT",
                "value": 2.9
            },
            {
                "code": "us-mt-023",
                "name": "Deer Lodge County, MT",
                "value": 5.1
            },
            {
                "code": "us-mt-025",
                "name": "Fallon County, MT",
                "value": 2.6
            },
            {
                "code": "us-mt-027",
                "name": "Fergus County, MT",
                "value": 5.7
            },
            {
                "code": "us-mt-029",
                "name": "Flathead County, MT",
                "value": 6.5
            },
            {
                "code": "us-mt-031",
                "name": "Gallatin County, MT",
                "value": 3
            },
            {
                "code": "us-mt-033",
                "name": "Garfield County, MT",
                "value": 2.9
            },
            {
                "code": "us-mt-035",
                "name": "Glacier County, MT",
                "value": 9.1
            },
            {
                "code": "us-mt-037",
                "name": "Golden Valley County, MT",
                "value": 6
            },
            {
                "code": "us-mt-039",
                "name": "Granite County, MT",
                "value": 7.6
            },
            {
                "code": "us-mt-041",
                "name": "Hill County, MT",
                "value": 3.8
            },
            {
                "code": "us-mt-043",
                "name": "Jefferson County, MT",
                "value": 4.9
            },
            {
                "code": "us-mt-045",
                "name": "Judith Basin County, MT",
                "value": 5.2
            },
            {
                "code": "us-mt-047",
                "name": "Lake County, MT",
                "value": 5.8
            },
            {
                "code": "us-mt-049",
                "name": "Lewis and Clark County, MT",
                "value": 4.3
            },
            {
                "code": "us-mt-051",
                "name": "Liberty County, MT",
                "value": 2.5
            },
            {
                "code": "us-mt-053",
                "name": "Lincoln County, MT",
                "value": 10.3
            },
            {
                "code": "us-mt-055",
                "name": "McCone County, MT",
                "value": 2.1
            },
            {
                "code": "us-mt-057",
                "name": "Madison County, MT",
                "value": 4.8
            },
            {
                "code": "us-mt-059",
                "name": "Meagher County, MT",
                "value": 4.8
            },
            {
                "code": "us-mt-061",
                "name": "Mineral County, MT",
                "value": 10.8
            },
            {
                "code": "us-mt-063",
                "name": "Missoula County, MT",
                "value": 4.4
            },
            {
                "code": "us-mt-065",
                "name": "Musselshell County, MT",
                "value": 5.7
            },
            {
                "code": "us-mt-067",
                "name": "Park County, MT",
                "value": 5
            },
            {
                "code": "us-mt-069",
                "name": "Petroleum County, MT",
                "value": 6.1
            },
            {
                "code": "us-mt-071",
                "name": "Phillips County, MT",
                "value": 6.9
            },
            {
                "code": "us-mt-073",
                "name": "Pondera County, MT",
                "value": 4.8
            },
            {
                "code": "us-mt-075",
                "name": "Powder River County, MT",
                "value": 3.4
            },
            {
                "code": "us-mt-077",
                "name": "Powell County, MT",
                "value": 5.5
            },
            {
                "code": "us-mt-079",
                "name": "Prairie County, MT",
                "value": 4.7
            },
            {
                "code": "us-mt-081",
                "name": "Ravalli County, MT",
                "value": 5.9
            },
            {
                "code": "us-mt-083",
                "name": "Richland County, MT",
                "value": 3.3
            },
            {
                "code": "us-mt-085",
                "name": "Roosevelt County, MT",
                "value": 5
            },
            {
                "code": "us-mt-087",
                "name": "Rosebud County, MT",
                "value": 6.6
            },
            {
                "code": "us-mt-089",
                "name": "Sanders County, MT",
                "value": 9.8
            },
            {
                "code": "us-mt-091",
                "name": "Sheridan County, MT",
                "value": 3.1
            },
            {
                "code": "us-mt-093",
                "name": "Silver Bow County, MT",
                "value": 5
            },
            {
                "code": "us-mt-095",
                "name": "Stillwater County, MT",
                "value": 4.5
            },
            {
                "code": "us-mt-097",
                "name": "Sweet Grass County, MT",
                "value": 4.4
            },
            {
                "code": "us-mt-099",
                "name": "Teton County, MT",
                "value": 4.6
            },
            {
                "code": "us-mt-101",
                "name": "Toole County, MT",
                "value": 3.1
            },
            {
                "code": "us-mt-103",
                "name": "Treasure County, MT",
                "value": 3.9
            },
            {
                "code": "us-mt-105",
                "name": "Valley County, MT",
                "value": 4
            },
            {
                "code": "us-mt-107",
                "name": "Wheatland County, MT",
                "value": 6.2
            },
            {
                "code": "us-mt-109",
                "name": "Wibaux County, MT",
                "value": 3.5
            },
            {
                "code": "us-mt-111",
                "name": "Yellowstone County, MT",
                "value": 4.1
            },
            {
                "code": "us-ne-001",
                "name": "Adams County, NE",
                "value": 3.5
            },
            {
                "code": "us-ne-003",
                "name": "Antelope County, NE",
                "value": 2.8
            },
            {
                "code": "us-ne-005",
                "name": "Arthur County, NE",
                "value": 5.8
            },
            {
                "code": "us-ne-007",
                "name": "Banner County, NE",
                "value": 3.8
            },
            {
                "code": "us-ne-009",
                "name": "Blaine County, NE",
                "value": 4.9
            },
            {
                "code": "us-ne-011",
                "name": "Boone County, NE",
                "value": 2.6
            },
            {
                "code": "us-ne-013",
                "name": "Box Butte County, NE",
                "value": 3.4
            },
            {
                "code": "us-ne-015",
                "name": "Boyd County, NE",
                "value": 3.9
            },
            {
                "code": "us-ne-017",
                "name": "Brown County, NE",
                "value": 3.5
            },
            {
                "code": "us-ne-019",
                "name": "Buffalo County, NE",
                "value": 2.4
            },
            {
                "code": "us-ne-021",
                "name": "Burt County, NE",
                "value": 4.5
            },
            {
                "code": "us-ne-023",
                "name": "Butler County, NE",
                "value": 2.4
            },
            {
                "code": "us-ne-025",
                "name": "Cass County, NE",
                "value": 3.7
            },
            {
                "code": "us-ne-027",
                "name": "Cedar County, NE",
                "value": 2.4
            },
            {
                "code": "us-ne-029",
                "name": "Chase County, NE",
                "value": 2.4
            },
            {
                "code": "us-ne-031",
                "name": "Cherry County, NE",
                "value": 2.3
            },
            {
                "code": "us-ne-033",
                "name": "Cheyenne County, NE",
                "value": 2.8
            },
            {
                "code": "us-ne-035",
                "name": "Clay County, NE",
                "value": 4.5
            },
            {
                "code": "us-ne-037",
                "name": "Colfax County, NE",
                "value": 2.5
            },
            {
                "code": "us-ne-039",
                "name": "Cuming County, NE",
                "value": 2.6
            },
            {
                "code": "us-ne-041",
                "name": "Custer County, NE",
                "value": 2.3
            },
            {
                "code": "us-ne-043",
                "name": "Dakota County, NE",
                "value": 4.8
            },
            {
                "code": "us-ne-045",
                "name": "Dawes County, NE",
                "value": 3
            },
            {
                "code": "us-ne-047",
                "name": "Dawson County, NE",
                "value": 3.2
            },
            {
                "code": "us-ne-049",
                "name": "Deuel County, NE",
                "value": 3.4
            },
            {
                "code": "us-ne-051",
                "name": "Dixon County, NE",
                "value": 3.6
            },
            {
                "code": "us-ne-053",
                "name": "Dodge County, NE",
                "value": 3.2
            },
            {
                "code": "us-ne-055",
                "name": "Douglas County, NE",
                "value": 3.4
            },
            {
                "code": "us-ne-057",
                "name": "Dundy County, NE",
                "value": 2.1
            },
            {
                "code": "us-ne-059",
                "name": "Fillmore County, NE",
                "value": 2.6
            },
            {
                "code": "us-ne-061",
                "name": "Franklin County, NE",
                "value": 3.2
            },
            {
                "code": "us-ne-063",
                "name": "Frontier County, NE",
                "value": 2.4
            },
            {
                "code": "us-ne-065",
                "name": "Furnas County, NE",
                "value": 2.8
            },
            {
                "code": "us-ne-067",
                "name": "Gage County, NE",
                "value": 3.9
            },
            {
                "code": "us-ne-069",
                "name": "Garden County, NE",
                "value": 2.7
            },
            {
                "code": "us-ne-071",
                "name": "Garfield County, NE",
                "value": 2.3
            },
            {
                "code": "us-ne-073",
                "name": "Gosper County, NE",
                "value": 2.4
            },
            {
                "code": "us-ne-075",
                "name": "Grant County, NE",
                "value": 2.1
            },
            {
                "code": "us-ne-077",
                "name": "Greeley County, NE",
                "value": 3.2
            },
            {
                "code": "us-ne-079",
                "name": "Hall County, NE",
                "value": 5.2
            },
            {
                "code": "us-ne-081",
                "name": "Hamilton County, NE",
                "value": 3.3
            },
            {
                "code": "us-ne-083",
                "name": "Harlan County, NE",
                "value": 2.5
            },
            {
                "code": "us-ne-085",
                "name": "Hayes County, NE",
                "value": 2.6
            },
            {
                "code": "us-ne-087",
                "name": "Hitchcock County, NE",
                "value": 3.6
            },
            {
                "code": "us-ne-089",
                "name": "Holt County, NE",
                "value": 2.9
            },
            {
                "code": "us-ne-091",
                "name": "Hooker County, NE",
                "value": 6.6
            },
            {
                "code": "us-ne-093",
                "name": "Howard County, NE",
                "value": 6.3
            },
            {
                "code": "us-ne-095",
                "name": "Jefferson County, NE",
                "value": 2.6
            },
            {
                "code": "us-ne-097",
                "name": "Johnson County, NE",
                "value": 4.5
            },
            {
                "code": "us-ne-099",
                "name": "Kearney County, NE",
                "value": 2.2
            },
            {
                "code": "us-ne-101",
                "name": "Keith County, NE",
                "value": 3.7
            },
            {
                "code": "us-ne-103",
                "name": "Keya Paha County, NE",
                "value": 1.9
            },
            {
                "code": "us-ne-105",
                "name": "Kimball County, NE",
                "value": 2.6
            },
            {
                "code": "us-ne-107",
                "name": "Knox County, NE",
                "value": 4.6
            },
            {
                "code": "us-ne-109",
                "name": "Lancaster County, NE",
                "value": 2.8
            },
            {
                "code": "us-ne-111",
                "name": "Lincoln County, NE",
                "value": 3.5
            },
            {
                "code": "us-ne-113",
                "name": "Logan County, NE",
                "value": 2.3
            },
            {
                "code": "us-ne-115",
                "name": "Loup County, NE",
                "value": 3.3
            },
            {
                "code": "us-ne-117",
                "name": "McPherson County, NE",
                "value": 2.9
            },
            {
                "code": "us-ne-119",
                "name": "Madison County, NE",
                "value": 2.9
            },
            {
                "code": "us-ne-121",
                "name": "Merrick County, NE",
                "value": 3.9
            },
            {
                "code": "us-ne-123",
                "name": "Morrill County, NE",
                "value": 2.8
            },
            {
                "code": "us-ne-125",
                "name": "Nance County, NE",
                "value": 2.7
            },
            {
                "code": "us-ne-127",
                "name": "Nemaha County, NE",
                "value": 3.6
            },
            {
                "code": "us-ne-129",
                "name": "Nuckolls County, NE",
                "value": 3.5
            },
            {
                "code": "us-ne-131",
                "name": "Otoe County, NE",
                "value": 3.6
            },
            {
                "code": "us-ne-133",
                "name": "Pawnee County, NE",
                "value": 2.4
            },
            {
                "code": "us-ne-135",
                "name": "Perkins County, NE",
                "value": 1.9
            },
            {
                "code": "us-ne-137",
                "name": "Phelps County, NE",
                "value": 2.3
            },
            {
                "code": "us-ne-139",
                "name": "Pierce County, NE",
                "value": 3.5
            },
            {
                "code": "us-ne-141",
                "name": "Platte County, NE",
                "value": 2.8
            },
            {
                "code": "us-ne-143",
                "name": "Polk County, NE",
                "value": 2.8
            },
            {
                "code": "us-ne-145",
                "name": "Red Willow County, NE",
                "value": 2.3
            },
            {
                "code": "us-ne-147",
                "name": "Richardson County, NE",
                "value": 3.6
            },
            {
                "code": "us-ne-149",
                "name": "Rock County, NE",
                "value": 2.9
            },
            {
                "code": "us-ne-151",
                "name": "Saline County, NE",
                "value": 3.8
            },
            {
                "code": "us-ne-153",
                "name": "Sarpy County, NE",
                "value": 2.9
            },
            {
                "code": "us-ne-155",
                "name": "Saunders County, NE",
                "value": 3.1
            },
            {
                "code": "us-ne-157",
                "name": "Scotts Bluff County, NE",
                "value": 3.5
            },
            {
                "code": "us-ne-159",
                "name": "Seward County, NE",
                "value": 2.7
            },
            {
                "code": "us-ne-161",
                "name": "Sheridan County, NE",
                "value": 2.8
            },
            {
                "code": "us-ne-163",
                "name": "Sherman County, NE",
                "value": 4.1
            },
            {
                "code": "us-ne-165",
                "name": "Sioux County, NE",
                "value": 2.4
            },
            {
                "code": "us-ne-167",
                "name": "Stanton County, NE",
                "value": 2.9
            },
            {
                "code": "us-ne-169",
                "name": "Thayer County, NE",
                "value": 2.5
            },
            {
                "code": "us-ne-171",
                "name": "Thomas County, NE",
                "value": 3.4
            },
            {
                "code": "us-ne-173",
                "name": "Thurston County, NE",
                "value": 4.9
            },
            {
                "code": "us-ne-175",
                "name": "Valley County, NE",
                "value": 3.3
            },
            {
                "code": "us-ne-177",
                "name": "Washington County, NE",
                "value": 3.3
            },
            {
                "code": "us-ne-179",
                "name": "Wayne County, NE",
                "value": 2.2
            },
            {
                "code": "us-ne-181",
                "name": "Webster County, NE",
                "value": 2.7
            },
            {
                "code": "us-ne-183",
                "name": "Wheeler County, NE",
                "value": 2.6
            },
            {
                "code": "us-ne-185",
                "name": "York County, NE",
                "value": 2.8
            },
            {
                "code": "us-nv-001",
                "name": "Churchill County, NV",
                "value": 4.6
            },
            {
                "code": "us-nv-003",
                "name": "Clark County, NV",
                "value": 5.3
            },
            {
                "code": "us-nv-005",
                "name": "Douglas County, NV",
                "value": 5.2
            },
            {
                "code": "us-nv-007",
                "name": "Elko County, NV",
                "value": 4
            },
            {
                "code": "us-nv-009",
                "name": "Esmeralda County, NV",
                "value": 4.8
            },
            {
                "code": "us-nv-011",
                "name": "Eureka County, NV",
                "value": 3.6
            },
            {
                "code": "us-nv-013",
                "name": "Humboldt County, NV",
                "value": 4.1
            },
            {
                "code": "us-nv-015",
                "name": "Lander County, NV",
                "value": 5.1
            },
            {
                "code": "us-nv-017",
                "name": "Lincoln County, NV",
                "value": 5.3
            },
            {
                "code": "us-nv-019",
                "name": "Lyon County, NV",
                "value": 6.5
            },
            {
                "code": "us-nv-021",
                "name": "Mineral County, NV",
                "value": 6.2
            },
            {
                "code": "us-nv-023",
                "name": "Nye County, NV",
                "value": 6.4
            },
            {
                "code": "us-nv-027",
                "name": "Pershing County, NV",
                "value": 4.8
            },
            {
                "code": "us-nv-029",
                "name": "Storey County, NV",
                "value": 5.4
            },
            {
                "code": "us-nv-031",
                "name": "Washoe County, NV",
                "value": 4.4
            },
            {
                "code": "us-nv-033",
                "name": "White Pine County, NV",
                "value": 4.4
            },
            {
                "code": "us-nv-510",
                "name": "Carson City, NV",
                "value": 5.8
            },
            {
                "code": "us-nh-001",
                "name": "Belknap County, NH",
                "value": 3.3
            },
            {
                "code": "us-nh-003",
                "name": "Carroll County, NH",
                "value": 3.3
            },
            {
                "code": "us-nh-005",
                "name": "Cheshire County, NH",
                "value": 3
            },
            {
                "code": "us-nh-007",
                "name": "Coos County, NH",
                "value": 4.4
            },
            {
                "code": "us-nh-009",
                "name": "Grafton County, NH",
                "value": 2.5
            },
            {
                "code": "us-nh-011",
                "name": "Hillsborough County, NH",
                "value": 3.3
            },
            {
                "code": "us-nh-013",
                "name": "Merrimack County, NH",
                "value": 2.8
            },
            {
                "code": "us-nh-015",
                "name": "Rockingham County, NH",
                "value": 3.5
            },
            {
                "code": "us-nh-017",
                "name": "Strafford County, NH",
                "value": 2.8
            },
            {
                "code": "us-nh-019",
                "name": "Sullivan County, NH",
                "value": 2.6
            },
            {
                "code": "us-nj-001",
                "name": "Atlantic County, NJ",
                "value": 8.2
            },
            {
                "code": "us-nj-003",
                "name": "Bergen County, NJ",
                "value": 3.9
            },
            {
                "code": "us-nj-005",
                "name": "Burlington County, NJ",
                "value": 4.3
            },
            {
                "code": "us-nj-007",
                "name": "Camden County, NJ",
                "value": 5.4
            },
            {
                "code": "us-nj-009",
                "name": "Cape May County, NJ",
                "value": 15.5
            },
            {
                "code": "us-nj-011",
                "name": "Cumberland County, NJ",
                "value": 8.4
            },
            {
                "code": "us-nj-013",
                "name": "Essex County, NJ",
                "value": 5.9
            },
            {
                "code": "us-nj-015",
                "name": "Gloucester County, NJ",
                "value": 5.1
            },
            {
                "code": "us-nj-017",
                "name": "Hudson County, NJ",
                "value": 4.4
            },
            {
                "code": "us-nj-019",
                "name": "Hunterdon County, NJ",
                "value": 3.9
            },
            {
                "code": "us-nj-021",
                "name": "Mercer County, NJ",
                "value": 4.4
            },
            {
                "code": "us-nj-023",
                "name": "Middlesex County, NJ",
                "value": 4.2
            },
            {
                "code": "us-nj-025",
                "name": "Monmouth County, NJ",
                "value": 4.4
            },
            {
                "code": "us-nj-027",
                "name": "Morris County, NJ",
                "value": 3.8
            },
            {
                "code": "us-nj-029",
                "name": "Ocean County, NJ",
                "value": 5.5
            },
            {
                "code": "us-nj-031",
                "name": "Passaic County, NJ",
                "value": 6.2
            },
            {
                "code": "us-nj-033",
                "name": "Salem County, NJ",
                "value": 6.8
            },
            {
                "code": "us-nj-035",
                "name": "Somerset County, NJ",
                "value": 3.9
            },
            {
                "code": "us-nj-037",
                "name": "Sussex County, NJ",
                "value": 5
            },
            {
                "code": "us-nj-039",
                "name": "Union County, NJ",
                "value": 5
            },
            {
                "code": "us-nj-041",
                "name": "Warren County, NJ",
                "value": 4.7
            },
            {
                "code": "us-nm-001",
                "name": "Bernalillo County, NM",
                "value": 4.8
            },
            {
                "code": "us-nm-003",
                "name": "Catron County, NM",
                "value": 7.9
            },
            {
                "code": "us-nm-005",
                "name": "Chaves County, NM",
                "value": 5.3
            },
            {
                "code": "us-nm-006",
                "name": "Cibola County, NM",
                "value": 6.7
            },
            {
                "code": "us-nm-007",
                "name": "Colfax County, NM",
                "value": 5.4
            },
            {
                "code": "us-nm-009",
                "name": "Curry County, NM",
                "value": 4.1
            },
            {
                "code": "us-nm-011",
                "name": "De Baca County, NM",
                "value": 4.1
            },
            {
                "code": "us-nm-013",
                "name": "Dona Ana County, NM",
                "value": 6.4
            },
            {
                "code": "us-nm-015",
                "name": "Eddy County, NM",
                "value": 3.7
            },
            {
                "code": "us-nm-017",
                "name": "Grant County, NM",
                "value": 5.4
            },
            {
                "code": "us-nm-019",
                "name": "Guadalupe County, NM",
                "value": 5.9
            },
            {
                "code": "us-nm-021",
                "name": "Harding County, NM",
                "value": 4.7
            },
            {
                "code": "us-nm-023",
                "name": "Hidalgo County, NM",
                "value": 5
            },
            {
                "code": "us-nm-025",
                "name": "Lea County, NM",
                "value": 4.7
            },
            {
                "code": "us-nm-027",
                "name": "Lincoln County, NM",
                "value": 5.2
            },
            {
                "code": "us-nm-028",
                "name": "Los Alamos County, NM",
                "value": 3.5
            },
            {
                "code": "us-nm-029",
                "name": "Luna County, NM",
                "value": 16.8
            },
            {
                "code": "us-nm-031",
                "name": "McKinley County, NM",
                "value": 7.7
            },
            {
                "code": "us-nm-033",
                "name": "Mora County, NM",
                "value": 7.8
            },
            {
                "code": "us-nm-035",
                "name": "Otero County, NM",
                "value": 5.2
            },
            {
                "code": "us-nm-037",
                "name": "Quay County, NM",
                "value": 4.8
            },
            {
                "code": "us-nm-039",
                "name": "Rio Arriba County, NM",
                "value": 5.9
            },
            {
                "code": "us-nm-041",
                "name": "Roosevelt County, NM",
                "value": 4.3
            },
            {
                "code": "us-nm-043",
                "name": "Sandoval County, NM",
                "value": 5.4
            },
            {
                "code": "us-nm-045",
                "name": "San Juan County, NM",
                "value": 6.4
            },
            {
                "code": "us-nm-047",
                "name": "San Miguel County, NM",
                "value": 6.7
            },
            {
                "code": "us-nm-049",
                "name": "Santa Fe County, NM",
                "value": 4.5
            },
            {
                "code": "us-nm-051",
                "name": "Sierra County, NM",
                "value": 8.6
            },
            {
                "code": "us-nm-053",
                "name": "Socorro County, NM",
                "value": 5.6
            },
            {
                "code": "us-nm-055",
                "name": "Taos County, NM",
                "value": 6.9
            },
            {
                "code": "us-nm-057",
                "name": "Torrance County, NM",
                "value": 9.3
            },
            {
                "code": "us-nm-059",
                "name": "Union County, NM",
                "value": 3.1
            },
            {
                "code": "us-nm-061",
                "name": "Valencia County, NM",
                "value": 5.7
            },
            {
                "code": "us-ny-001",
                "name": "Albany County, NY",
                "value": 4.6
            },
            {
                "code": "us-ny-003",
                "name": "Allegany County, NY",
                "value": 8.2
            },
            {
                "code": "us-ny-005",
                "name": "Bronx County, NY",
                "value": 6.4
            },
            {
                "code": "us-ny-007",
                "name": "Broome County, NY",
                "value": 6.6
            },
            {
                "code": "us-ny-009",
                "name": "Cattaraugus County, NY",
                "value": 7.5
            },
            {
                "code": "us-ny-011",
                "name": "Cayuga County, NY",
                "value": 6.1
            },
            {
                "code": "us-ny-013",
                "name": "Chautauqua County, NY",
                "value": 6.9
            },
            {
                "code": "us-ny-015",
                "name": "Chemung County, NY",
                "value": 6
            },
            {
                "code": "us-ny-017",
                "name": "Chenango County, NY",
                "value": 6.9
            },
            {
                "code": "us-ny-019",
                "name": "Clinton County, NY",
                "value": 6
            },
            {
                "code": "us-ny-021",
                "name": "Columbia County, NY",
                "value": 4.6
            },
            {
                "code": "us-ny-023",
                "name": "Cortland County, NY",
                "value": 7.6
            },
            {
                "code": "us-ny-025",
                "name": "Delaware County, NY",
                "value": 7
            },
            {
                "code": "us-ny-027",
                "name": "Dutchess County, NY",
                "value": 4.6
            },
            {
                "code": "us-ny-029",
                "name": "Erie County, NY",
                "value": 5.7
            },
            {
                "code": "us-ny-031",
                "name": "Essex County, NY",
                "value": 6.9
            },
            {
                "code": "us-ny-033",
                "name": "Franklin County, NY",
                "value": 7.2
            },
            {
                "code": "us-ny-035",
                "name": "Fulton County, NY",
                "value": 7.2
            },
            {
                "code": "us-ny-037",
                "name": "Genesee County, NY",
                "value": 6.1
            },
            {
                "code": "us-ny-039",
                "name": "Greene County, NY",
                "value": 6.1
            },
            {
                "code": "us-ny-041",
                "name": "Hamilton County, NY",
                "value": 11.3
            },
            {
                "code": "us-ny-043",
                "name": "Herkimer County, NY",
                "value": 7.1
            },
            {
                "code": "us-ny-045",
                "name": "Jefferson County, NY",
                "value": 8.3
            },
            {
                "code": "us-ny-047",
                "name": "Kings County, NY",
                "value": 4.7
            },
            {
                "code": "us-ny-049",
                "name": "Lewis County, NY",
                "value": 8.6
            },
            {
                "code": "us-ny-051",
                "name": "Livingston County, NY",
                "value": 6
            },
            {
                "code": "us-ny-053",
                "name": "Madison County, NY",
                "value": 6.8
            },
            {
                "code": "us-ny-055",
                "name": "Monroe County, NY",
                "value": 5.3
            },
            {
                "code": "us-ny-057",
                "name": "Montgomery County, NY",
                "value": 7.3
            },
            {
                "code": "us-ny-059",
                "name": "Nassau County, NY",
                "value": 4.4
            },
            {
                "code": "us-ny-061",
                "name": "New York County, NY",
                "value": 4.1
            },
            {
                "code": "us-ny-063",
                "name": "Niagara County, NY",
                "value": 7.4
            },
            {
                "code": "us-ny-065",
                "name": "Oneida County, NY",
                "value": 5.8
            },
            {
                "code": "us-ny-067",
                "name": "Onondaga County, NY",
                "value": 5.1
            },
            {
                "code": "us-ny-069",
                "name": "Ontario County, NY",
                "value": 5.4
            },
            {
                "code": "us-ny-071",
                "name": "Orange County, NY",
                "value": 4.9
            },
            {
                "code": "us-ny-073",
                "name": "Orleans County, NY",
                "value": 7
            },
            {
                "code": "us-ny-075",
                "name": "Oswego County, NY",
                "value": 7.9
            },
            {
                "code": "us-ny-077",
                "name": "Otsego County, NY",
                "value": 6.3
            },
            {
                "code": "us-ny-079",
                "name": "Putnam County, NY",
                "value": 4.6
            },
            {
                "code": "us-ny-081",
                "name": "Queens County, NY",
                "value": 4.1
            },
            {
                "code": "us-ny-083",
                "name": "Rensselaer County, NY",
                "value": 5.1
            },
            {
                "code": "us-ny-085",
                "name": "Richmond County, NY",
                "value": 4.6
            },
            {
                "code": "us-ny-087",
                "name": "Rockland County, NY",
                "value": 4.6
            },
            {
                "code": "us-ny-089",
                "name": "St. Lawrence County, NY",
                "value": 7.8
            },
            {
                "code": "us-ny-091",
                "name": "Saratoga County, NY",
                "value": 4.6
            },
            {
                "code": "us-ny-093",
                "name": "Schenectady County, NY",
                "value": 5
            },
            {
                "code": "us-ny-095",
                "name": "Schoharie County, NY",
                "value": 7.5
            },
            {
                "code": "us-ny-097",
                "name": "Schuyler County, NY",
                "value": 8
            },
            {
                "code": "us-ny-099",
                "name": "Seneca County, NY",
                "value": 5.4
            },
            {
                "code": "us-ny-101",
                "name": "Steuben County, NY",
                "value": 7
            },
            {
                "code": "us-ny-103",
                "name": "Suffolk County, NY",
                "value": 5.1
            },
            {
                "code": "us-ny-105",
                "name": "Sullivan County, NY",
                "value": 5.7
            },
            {
                "code": "us-ny-107",
                "name": "Tioga County, NY",
                "value": 6.4
            },
            {
                "code": "us-ny-109",
                "name": "Tompkins County, NY",
                "value": 4.6
            },
            {
                "code": "us-ny-111",
                "name": "Ulster County, NY",
                "value": 5.2
            },
            {
                "code": "us-ny-113",
                "name": "Warren County, NY",
                "value": 7.1
            },
            {
                "code": "us-ny-115",
                "name": "Washington County, NY",
                "value": 6.1
            },
            {
                "code": "us-ny-117",
                "name": "Wayne County, NY",
                "value": 5.7
            },
            {
                "code": "us-ny-119",
                "name": "Westchester County, NY",
                "value": 4.7
            },
            {
                "code": "us-ny-121",
                "name": "Wyoming County, NY",
                "value": 7.4
            },
            {
                "code": "us-ny-123",
                "name": "Yates County, NY",
                "value": 5.4
            },
            {
                "code": "us-nc-001",
                "name": "Alamance County, NC",
                "value": 4
            },
            {
                "code": "us-nc-003",
                "name": "Alexander County, NC",
                "value": 3.5
            },
            {
                "code": "us-nc-005",
                "name": "Alleghany County, NC",
                "value": 5.7
            },
            {
                "code": "us-nc-007",
                "name": "Anson County, NC",
                "value": 4.9
            },
            {
                "code": "us-nc-009",
                "name": "Ashe County, NC",
                "value": 4.3
            },
            {
                "code": "us-nc-011",
                "name": "Avery County, NC",
                "value": 4.6
            },
            {
                "code": "us-nc-013",
                "name": "Beaufort County, NC",
                "value": 5.1
            },
            {
                "code": "us-nc-015",
                "name": "Bertie County, NC",
                "value": 5.9
            },
            {
                "code": "us-nc-017",
                "name": "Bladen County, NC",
                "value": 6
            },
            {
                "code": "us-nc-019",
                "name": "Brunswick County, NC",
                "value": 6.5
            },
            {
                "code": "us-nc-021",
                "name": "Buncombe County, NC",
                "value": 3.4
            },
            {
                "code": "us-nc-023",
                "name": "Burke County, NC",
                "value": 4
            },
            {
                "code": "us-nc-025",
                "name": "Cabarrus County, NC",
                "value": 4
            },
            {
                "code": "us-nc-027",
                "name": "Caldwell County, NC",
                "value": 4.3
            },
            {
                "code": "us-nc-029",
                "name": "Camden County, NC",
                "value": 4.2
            },
            {
                "code": "us-nc-031",
                "name": "Carteret County, NC",
                "value": 4.9
            },
            {
                "code": "us-nc-033",
                "name": "Caswell County, NC",
                "value": 4.9
            },
            {
                "code": "us-nc-035",
                "name": "Catawba County, NC",
                "value": 3.9
            },
            {
                "code": "us-nc-037",
                "name": "Chatham County, NC",
                "value": 3.8
            },
            {
                "code": "us-nc-039",
                "name": "Cherokee County, NC",
                "value": 5.4
            },
            {
                "code": "us-nc-041",
                "name": "Chowan County, NC",
                "value": 5.3
            },
            {
                "code": "us-nc-043",
                "name": "Clay County, NC",
                "value": 5
            },
            {
                "code": "us-nc-045",
                "name": "Cleveland County, NC",
                "value": 4.6
            },
            {
                "code": "us-nc-047",
                "name": "Columbus County, NC",
                "value": 5.9
            },
            {
                "code": "us-nc-049",
                "name": "Craven County, NC",
                "value": 4.5
            },
            {
                "code": "us-nc-051",
                "name": "Cumberland County, NC",
                "value": 5.7
            },
            {
                "code": "us-nc-053",
                "name": "Currituck County, NC",
                "value": 4.8
            },
            {
                "code": "us-nc-055",
                "name": "Dare County, NC",
                "value": 10
            },
            {
                "code": "us-nc-057",
                "name": "Davidson County, NC",
                "value": 4.1
            },
            {
                "code": "us-nc-059",
                "name": "Davie County, NC",
                "value": 4
            },
            {
                "code": "us-nc-061",
                "name": "Duplin County, NC",
                "value": 5
            },
            {
                "code": "us-nc-063",
                "name": "Durham County, NC",
                "value": 3.9
            },
            {
                "code": "us-nc-065",
                "name": "Edgecombe County, NC",
                "value": 7.9
            },
            {
                "code": "us-nc-067",
                "name": "Forsyth County, NC",
                "value": 4.3
            },
            {
                "code": "us-nc-069",
                "name": "Franklin County, NC",
                "value": 4.5
            },
            {
                "code": "us-nc-071",
                "name": "Gaston County, NC",
                "value": 4.5
            },
            {
                "code": "us-nc-073",
                "name": "Gates County, NC",
                "value": 4.2
            },
            {
                "code": "us-nc-075",
                "name": "Graham County, NC",
                "value": 8.1
            },
            {
                "code": "us-nc-077",
                "name": "Granville County, NC",
                "value": 3.9
            },
            {
                "code": "us-nc-079",
                "name": "Greene County, NC",
                "value": 4.1
            },
            {
                "code": "us-nc-081",
                "name": "Guilford County, NC",
                "value": 4.7
            },
            {
                "code": "us-nc-083",
                "name": "Halifax County, NC",
                "value": 7.2
            },
            {
                "code": "us-nc-085",
                "name": "Harnett County, NC",
                "value": 5.1
            },
            {
                "code": "us-nc-087",
                "name": "Haywood County, NC",
                "value": 3.9
            },
            {
                "code": "us-nc-089",
                "name": "Henderson County, NC",
                "value": 3.7
            },
            {
                "code": "us-nc-091",
                "name": "Hertford County, NC",
                "value": 5.7
            },
            {
                "code": "us-nc-093",
                "name": "Hoke County, NC",
                "value": 5.6
            },
            {
                "code": "us-nc-095",
                "name": "Hyde County, NC",
                "value": 14.4
            },
            {
                "code": "us-nc-097",
                "name": "Iredell County, NC",
                "value": 4.2
            },
            {
                "code": "us-nc-099",
                "name": "Jackson County, NC",
                "value": 5.1
            },
            {
                "code": "us-nc-101",
                "name": "Johnston County, NC",
                "value": 4
            },
            {
                "code": "us-nc-103",
                "name": "Jones County, NC",
                "value": 4.5
            },
            {
                "code": "us-nc-105",
                "name": "Lee County, NC",
                "value": 4.8
            },
            {
                "code": "us-nc-107",
                "name": "Lenoir County, NC",
                "value": 4.4
            },
            {
                "code": "us-nc-109",
                "name": "Lincoln County, NC",
                "value": 4
            },
            {
                "code": "us-nc-111",
                "name": "McDowell County, NC",
                "value": 3.8
            },
            {
                "code": "us-nc-113",
                "name": "Macon County, NC",
                "value": 4.8
            },
            {
                "code": "us-nc-115",
                "name": "Madison County, NC",
                "value": 4.2
            },
            {
                "code": "us-nc-117",
                "name": "Martin County, NC",
                "value": 5.6
            },
            {
                "code": "us-nc-119",
                "name": "Mecklenburg County, NC",
                "value": 4.2
            },
            {
                "code": "us-nc-121",
                "name": "Mitchell County, NC",
                "value": 5.5
            },
            {
                "code": "us-nc-123",
                "name": "Montgomery County, NC",
                "value": 4.3
            },
            {
                "code": "us-nc-125",
                "name": "Moore County, NC",
                "value": 4.4
            },
            {
                "code": "us-nc-127",
                "name": "Nash County, NC",
                "value": 5.7
            },
            {
                "code": "us-nc-129",
                "name": "New Hanover County, NC",
                "value": 4.2
            },
            {
                "code": "us-nc-131",
                "name": "Northampton County, NC",
                "value": 6.3
            },
            {
                "code": "us-nc-133",
                "name": "Onslow County, NC",
                "value": 5.2
            },
            {
                "code": "us-nc-135",
                "name": "Orange County, NC",
                "value": 3.5
            },
            {
                "code": "us-nc-137",
                "name": "Pamlico County, NC",
                "value": 4.8
            },
            {
                "code": "us-nc-139",
                "name": "Pasquotank County, NC",
                "value": 5.9
            },
            {
                "code": "us-nc-141",
                "name": "Pender County, NC",
                "value": 4.7
            },
            {
                "code": "us-nc-143",
                "name": "Perquimans County, NC",
                "value": 5.5
            },
            {
                "code": "us-nc-145",
                "name": "Person County, NC",
                "value": 4.4
            },
            {
                "code": "us-nc-147",
                "name": "Pitt County, NC",
                "value": 4.6
            },
            {
                "code": "us-nc-149",
                "name": "Polk County, NC",
                "value": 4.3
            },
            {
                "code": "us-nc-151",
                "name": "Randolph County, NC",
                "value": 4.2
            },
            {
                "code": "us-nc-153",
                "name": "Richmond County, NC",
                "value": 6.2
            },
            {
                "code": "us-nc-155",
                "name": "Robeson County, NC",
                "value": 6.5
            },
            {
                "code": "us-nc-157",
                "name": "Rockingham County, NC",
                "value": 5.2
            },
            {
                "code": "us-nc-159",
                "name": "Rowan County, NC",
                "value": 4.5
            },
            {
                "code": "us-nc-161",
                "name": "Rutherford County, NC",
                "value": 6.1
            },
            {
                "code": "us-nc-163",
                "name": "Sampson County, NC",
                "value": 4.6
            },
            {
                "code": "us-nc-165",
                "name": "Scotland County, NC",
                "value": 8.3
            },
            {
                "code": "us-nc-167",
                "name": "Stanly County, NC",
                "value": 4
            },
            {
                "code": "us-nc-169",
                "name": "Stokes County, NC",
                "value": 4.2
            },
            {
                "code": "us-nc-171",
                "name": "Surry County, NC",
                "value": 4
            },
            {
                "code": "us-nc-173",
                "name": "Swain County, NC",
                "value": 6.7
            },
            {
                "code": "us-nc-175",
                "name": "Transylvania County, NC",
                "value": 4.5
            },
            {
                "code": "us-nc-177",
                "name": "Tyrrell County, NC",
                "value": 10.3
            },
            {
                "code": "us-nc-179",
                "name": "Union County, NC",
                "value": 3.8
            },
            {
                "code": "us-nc-181",
                "name": "Vance County, NC",
                "value": 6.3
            },
            {
                "code": "us-nc-183",
                "name": "Wake County, NC",
                "value": 3.7
            },
            {
                "code": "us-nc-185",
                "name": "Warren County, NC",
                "value": 7.1
            },
            {
                "code": "us-nc-187",
                "name": "Washington County, NC",
                "value": 7.1
            },
            {
                "code": "us-nc-189",
                "name": "Watauga County, NC",
                "value": 3.9
            },
            {
                "code": "us-nc-191",
                "name": "Wayne County, NC",
                "value": 4.8
            },
            {
                "code": "us-nc-193",
                "name": "Wilkes County, NC",
                "value": 4.2
            },
            {
                "code": "us-nc-195",
                "name": "Wilson County, NC",
                "value": 6.9
            },
            {
                "code": "us-nc-197",
                "name": "Yadkin County, NC",
                "value": 3.7
            },
            {
                "code": "us-nc-199",
                "name": "Yancey County, NC",
                "value": 4
            },
            {
                "code": "us-nd-001",
                "name": "Adams County, ND",
                "value": 3.4
            },
            {
                "code": "us-nd-003",
                "name": "Barnes County, ND",
                "value": 3.2
            },
            {
                "code": "us-nd-005",
                "name": "Benson County, ND",
                "value": 4.5
            },
            {
                "code": "us-nd-007",
                "name": "Billings County, ND",
                "value": 4
            },
            {
                "code": "us-nd-009",
                "name": "Bottineau County, ND",
                "value": 4.3
            },
            {
                "code": "us-nd-011",
                "name": "Bowman County, ND",
                "value": 2.6
            },
            {
                "code": "us-nd-013",
                "name": "Burke County, ND",
                "value": 3.1
            },
            {
                "code": "us-nd-015",
                "name": "Burleigh County, ND",
                "value": 3.6
            },
            {
                "code": "us-nd-017",
                "name": "Cass County, ND",
                "value": 3
            },
            {
                "code": "us-nd-019",
                "name": "Cavalier County, ND",
                "value": 3.4
            },
            {
                "code": "us-nd-021",
                "name": "Dickey County, ND",
                "value": 1.9
            },
            {
                "code": "us-nd-023",
                "name": "Divide County, ND",
                "value": 1.5
            },
            {
                "code": "us-nd-025",
                "name": "Dunn County, ND",
                "value": 2
            },
            {
                "code": "us-nd-027",
                "name": "Eddy County, ND",
                "value": 6.3
            },
            {
                "code": "us-nd-029",
                "name": "Emmons County, ND",
                "value": 7.2
            },
            {
                "code": "us-nd-031",
                "name": "Foster County, ND",
                "value": 3.7
            },
            {
                "code": "us-nd-033",
                "name": "Golden Valley County, ND",
                "value": 2.5
            },
            {
                "code": "us-nd-035",
                "name": "Grand Forks County, ND",
                "value": 2.8
            },
            {
                "code": "us-nd-037",
                "name": "Grant County, ND",
                "value": 3.7
            },
            {
                "code": "us-nd-039",
                "name": "Griggs County, ND",
                "value": 2.9
            },
            {
                "code": "us-nd-041",
                "name": "Hettinger County, ND",
                "value": 2.3
            },
            {
                "code": "us-nd-043",
                "name": "Kidder County, ND",
                "value": 7
            },
            {
                "code": "us-nd-045",
                "name": "LaMoure County, ND",
                "value": 2.5
            },
            {
                "code": "us-nd-047",
                "name": "Logan County, ND",
                "value": 2.7
            },
            {
                "code": "us-nd-049",
                "name": "McHenry County, ND",
                "value": 6.1
            },
            {
                "code": "us-nd-051",
                "name": "McIntosh County, ND",
                "value": 3.2
            },
            {
                "code": "us-nd-053",
                "name": "McKenzie County, ND",
                "value": 2.3
            },
            {
                "code": "us-nd-055",
                "name": "McLean County, ND",
                "value": 4.9
            },
            {
                "code": "us-nd-057",
                "name": "Mercer County, ND",
                "value": 6.1
            },
            {
                "code": "us-nd-059",
                "name": "Morton County, ND",
                "value": 4.6
            },
            {
                "code": "us-nd-061",
                "name": "Mountrail County, ND",
                "value": 2.2
            },
            {
                "code": "us-nd-063",
                "name": "Nelson County, ND",
                "value": 4
            },
            {
                "code": "us-nd-065",
                "name": "Oliver County, ND",
                "value": 5.9
            },
            {
                "code": "us-nd-067",
                "name": "Pembina County, ND",
                "value": 5.9
            },
            {
                "code": "us-nd-069",
                "name": "Pierce County, ND",
                "value": 4.2
            },
            {
                "code": "us-nd-071",
                "name": "Ramsey County, ND",
                "value": 3.7
            },
            {
                "code": "us-nd-073",
                "name": "Ransom County, ND",
                "value": 2.7
            },
            {
                "code": "us-nd-075",
                "name": "Renville County, ND",
                "value": 2.9
            },
            {
                "code": "us-nd-077",
                "name": "Richland County, ND",
                "value": 3.4
            },
            {
                "code": "us-nd-079",
                "name": "Rolette County, ND",
                "value": 11
            },
            {
                "code": "us-nd-081",
                "name": "Sargent County, ND",
                "value": 2.7
            },
            {
                "code": "us-nd-083",
                "name": "Sheridan County, ND",
                "value": 8.1
            },
            {
                "code": "us-nd-085",
                "name": "Sioux County, ND",
                "value": 3.7
            },
            {
                "code": "us-nd-087",
                "name": "Slope County, ND",
                "value": 2.3
            },
            {
                "code": "us-nd-089",
                "name": "Stark County, ND",
                "value": 3.3
            },
            {
                "code": "us-nd-091",
                "name": "Steele County, ND",
                "value": 2.7
            },
            {
                "code": "us-nd-093",
                "name": "Stutsman County, ND",
                "value": 3.2
            },
            {
                "code": "us-nd-095",
                "name": "Towner County, ND",
                "value": 2.9
            },
            {
                "code": "us-nd-097",
                "name": "Traill County, ND",
                "value": 3.4
            },
            {
                "code": "us-nd-099",
                "name": "Walsh County, ND",
                "value": 4.2
            },
            {
                "code": "us-nd-101",
                "name": "Ward County, ND",
                "value": 3.9
            },
            {
                "code": "us-nd-103",
                "name": "Wells County, ND",
                "value": 4.4
            },
            {
                "code": "us-nd-105",
                "name": "Williams County, ND",
                "value": 2.6
            },
            {
                "code": "us-oh-001",
                "name": "Adams County, OH",
                "value": 9.3
            },
            {
                "code": "us-oh-003",
                "name": "Allen County, OH",
                "value": 5
            },
            {
                "code": "us-oh-005",
                "name": "Ashland County, OH",
                "value": 5.9
            },
            {
                "code": "us-oh-007",
                "name": "Ashtabula County, OH",
                "value": 6.7
            },
            {
                "code": "us-oh-009",
                "name": "Athens County, OH",
                "value": 6.5
            },
            {
                "code": "us-oh-011",
                "name": "Auglaize County, OH",
                "value": 3.6
            },
            {
                "code": "us-oh-013",
                "name": "Belmont County, OH",
                "value": 7.3
            },
            {
                "code": "us-oh-015",
                "name": "Brown County, OH",
                "value": 6.6
            },
            {
                "code": "us-oh-017",
                "name": "Butler County, OH",
                "value": 4.5
            },
            {
                "code": "us-oh-019",
                "name": "Carroll County, OH",
                "value": 6.9
            },
            {
                "code": "us-oh-021",
                "name": "Champaign County, OH",
                "value": 4.1
            },
            {
                "code": "us-oh-023",
                "name": "Clark County, OH",
                "value": 4.8
            },
            {
                "code": "us-oh-025",
                "name": "Clermont County, OH",
                "value": 4.6
            },
            {
                "code": "us-oh-027",
                "name": "Clinton County, OH",
                "value": 5.9
            },
            {
                "code": "us-oh-029",
                "name": "Columbiana County, OH",
                "value": 6.6
            },
            {
                "code": "us-oh-031",
                "name": "Coshocton County, OH",
                "value": 7.2
            },
            {
                "code": "us-oh-033",
                "name": "Crawford County, OH",
                "value": 6.1
            },
            {
                "code": "us-oh-035",
                "name": "Cuyahoga County, OH",
                "value": 5.5
            },
            {
                "code": "us-oh-037",
                "name": "Darke County, OH",
                "value": 4.7
            },
            {
                "code": "us-oh-039",
                "name": "Defiance County, OH",
                "value": 5
            },
            {
                "code": "us-oh-041",
                "name": "Delaware County, OH",
                "value": 3.4
            },
            {
                "code": "us-oh-043",
                "name": "Erie County, OH",
                "value": 7.5
            },
            {
                "code": "us-oh-045",
                "name": "Fairfield County, OH",
                "value": 4.5
            },
            {
                "code": "us-oh-047",
                "name": "Fayette County, OH",
                "value": 4.8
            },
            {
                "code": "us-oh-049",
                "name": "Franklin County, OH",
                "value": 3.9
            },
            {
                "code": "us-oh-051",
                "name": "Fulton County, OH",
                "value": 5.5
            },
            {
                "code": "us-oh-053",
                "name": "Gallia County, OH",
                "value": 7.9
            },
            {
                "code": "us-oh-055",
                "name": "Geauga County, OH",
                "value": 4.9
            },
            {
                "code": "us-oh-057",
                "name": "Greene County, OH",
                "value": 4.3
            },
            {
                "code": "us-oh-059",
                "name": "Guernsey County, OH",
                "value": 7.5
            },
            {
                "code": "us-oh-061",
                "name": "Hamilton County, OH",
                "value": 4.3
            },
            {
                "code": "us-oh-063",
                "name": "Hancock County, OH",
                "value": 3.6
            },
            {
                "code": "us-oh-065",
                "name": "Hardin County, OH",
                "value": 5.1
            },
            {
                "code": "us-oh-067",
                "name": "Harrison County, OH",
                "value": 6.5
            },
            {
                "code": "us-oh-069",
                "name": "Henry County, OH",
                "value": 6.8
            },
            {
                "code": "us-oh-071",
                "name": "Highland County, OH",
                "value": 6.7
            },
            {
                "code": "us-oh-073",
                "name": "Hocking County, OH",
                "value": 6.6
            },
            {
                "code": "us-oh-075",
                "name": "Holmes County, OH",
                "value": 3.7
            },
            {
                "code": "us-oh-077",
                "name": "Huron County, OH",
                "value": 8.7
            },
            {
                "code": "us-oh-079",
                "name": "Jackson County, OH",
                "value": 8.2
            },
            {
                "code": "us-oh-081",
                "name": "Jefferson County, OH",
                "value": 7.8
            },
            {
                "code": "us-oh-083",
                "name": "Knox County, OH",
                "value": 5.2
            },
            {
                "code": "us-oh-085",
                "name": "Lake County, OH",
                "value": 5.3
            },
            {
                "code": "us-oh-087",
                "name": "Lawrence County, OH",
                "value": 6.3
            },
            {
                "code": "us-oh-089",
                "name": "Licking County, OH",
                "value": 4.4
            },
            {
                "code": "us-oh-091",
                "name": "Logan County, OH",
                "value": 4.1
            },
            {
                "code": "us-oh-093",
                "name": "Lorain County, OH",
                "value": 6.1
            },
            {
                "code": "us-oh-095",
                "name": "Lucas County, OH",
                "value": 5.8
            },
            {
                "code": "us-oh-097",
                "name": "Madison County, OH",
                "value": 4.1
            },
            {
                "code": "us-oh-099",
                "name": "Mahoning County, OH",
                "value": 8.2
            },
            {
                "code": "us-oh-101",
                "name": "Marion County, OH",
                "value": 5
            },
            {
                "code": "us-oh-103",
                "name": "Medina County, OH",
                "value": 4.7
            },
            {
                "code": "us-oh-105",
                "name": "Meigs County, OH",
                "value": 9.7
            },
            {
                "code": "us-oh-107",
                "name": "Mercer County, OH",
                "value": 3.1
            },
            {
                "code": "us-oh-109",
                "name": "Miami County, OH",
                "value": 4.5
            },
            {
                "code": "us-oh-111",
                "name": "Monroe County, OH",
                "value": 11.1
            },
            {
                "code": "us-oh-113",
                "name": "Montgomery County, OH",
                "value": 4.9
            },
            {
                "code": "us-oh-115",
                "name": "Morgan County, OH",
                "value": 9.2
            },
            {
                "code": "us-oh-117",
                "name": "Morrow County, OH",
                "value": 5.6
            },
            {
                "code": "us-oh-119",
                "name": "Muskingum County, OH",
                "value": 6.8
            },
            {
                "code": "us-oh-121",
                "name": "Noble County, OH",
                "value": 9.6
            },
            {
                "code": "us-oh-123",
                "name": "Ottawa County, OH",
                "value": 9.3
            },
            {
                "code": "us-oh-125",
                "name": "Paulding County, OH",
                "value": 4.7
            },
            {
                "code": "us-oh-127",
                "name": "Perry County, OH",
                "value": 7.3
            },
            {
                "code": "us-oh-129",
                "name": "Pickaway County, OH",
                "value": 5.1
            },
            {
                "code": "us-oh-131",
                "name": "Pike County, OH",
                "value": 8.2
            },
            {
                "code": "us-oh-133",
                "name": "Portage County, OH",
                "value": 5.6
            },
            {
                "code": "us-oh-135",
                "name": "Preble County, OH",
                "value": 4.8
            },
            {
                "code": "us-oh-137",
                "name": "Putnam County, OH",
                "value": 4.1
            },
            {
                "code": "us-oh-139",
                "name": "Richland County, OH",
                "value": 5.8
            },
            {
                "code": "us-oh-141",
                "name": "Ross County, OH",
                "value": 5.5
            },
            {
                "code": "us-oh-143",
                "name": "Sandusky County, OH",
                "value": 5.6
            },
            {
                "code": "us-oh-145",
                "name": "Scioto County, OH",
                "value": 8.1
            },
            {
                "code": "us-oh-147",
                "name": "Seneca County, OH",
                "value": 5.2
            },
            {
                "code": "us-oh-149",
                "name": "Shelby County, OH",
                "value": 4.1
            },
            {
                "code": "us-oh-151",
                "name": "Stark County, OH",
                "value": 5.7
            },
            {
                "code": "us-oh-153",
                "name": "Summit County, OH",
                "value": 5.4
            },
            {
                "code": "us-oh-155",
                "name": "Trumbull County, OH",
                "value": 8.6
            },
            {
                "code": "us-oh-157",
                "name": "Tuscarawas County, OH",
                "value": 5.8
            },
            {
                "code": "us-oh-159",
                "name": "Union County, OH",
                "value": 3.9
            },
            {
                "code": "us-oh-161",
                "name": "Van Wert County, OH",
                "value": 3.9
            },
            {
                "code": "us-oh-163",
                "name": "Vinton County, OH",
                "value": 8.6
            },
            {
                "code": "us-oh-165",
                "name": "Warren County, OH",
                "value": 4.1
            },
            {
                "code": "us-oh-167",
                "name": "Washington County, OH",
                "value": 6.9
            },
            {
                "code": "us-oh-169",
                "name": "Wayne County, OH",
                "value": 4.1
            },
            {
                "code": "us-oh-171",
                "name": "Williams County, OH",
                "value": 4.1
            },
            {
                "code": "us-oh-173",
                "name": "Wood County, OH",
                "value": 4.4
            },
            {
                "code": "us-oh-175",
                "name": "Wyandot County, OH",
                "value": 3.8
            },
            {
                "code": "us-ok-001",
                "name": "Adair County, OK",
                "value": 4.6
            },
            {
                "code": "us-ok-003",
                "name": "Alfalfa County, OK",
                "value": 2.2
            },
            {
                "code": "us-ok-005",
                "name": "Atoka County, OK",
                "value": 5.5
            },
            {
                "code": "us-ok-007",
                "name": "Beaver County, OK",
                "value": 2.5
            },
            {
                "code": "us-ok-009",
                "name": "Beckham County, OK",
                "value": 3.3
            },
            {
                "code": "us-ok-011",
                "name": "Blaine County, OK",
                "value": 2.5
            },
            {
                "code": "us-ok-013",
                "name": "Bryan County, OK",
                "value": 3.7
            },
            {
                "code": "us-ok-015",
                "name": "Caddo County, OK",
                "value": 4
            },
            {
                "code": "us-ok-017",
                "name": "Canadian County, OK",
                "value": 3.3
            },
            {
                "code": "us-ok-019",
                "name": "Carter County, OK",
                "value": 4.4
            },
            {
                "code": "us-ok-021",
                "name": "Cherokee County, OK",
                "value": 5.2
            },
            {
                "code": "us-ok-023",
                "name": "Choctaw County, OK",
                "value": 6.3
            },
            {
                "code": "us-ok-025",
                "name": "Cimarron County, OK",
                "value": 2.2
            },
            {
                "code": "us-ok-027",
                "name": "Cleveland County, OK",
                "value": 3.4
            },
            {
                "code": "us-ok-029",
                "name": "Coal County, OK",
                "value": 4.7
            },
            {
                "code": "us-ok-031",
                "name": "Comanche County, OK",
                "value": 4.4
            },
            {
                "code": "us-ok-033",
                "name": "Cotton County, OK",
                "value": 4
            },
            {
                "code": "us-ok-035",
                "name": "Craig County, OK",
                "value": 4.1
            },
            {
                "code": "us-ok-037",
                "name": "Creek County, OK",
                "value": 4.7
            },
            {
                "code": "us-ok-039",
                "name": "Custer County, OK",
                "value": 2.8
            },
            {
                "code": "us-ok-041",
                "name": "Delaware County, OK",
                "value": 5
            },
            {
                "code": "us-ok-043",
                "name": "Dewey County, OK",
                "value": 2.1
            },
            {
                "code": "us-ok-045",
                "name": "Ellis County, OK",
                "value": 2.6
            },
            {
                "code": "us-ok-047",
                "name": "Garfield County, OK",
                "value": 3.6
            },
            {
                "code": "us-ok-049",
                "name": "Garvin County, OK",
                "value": 3.8
            },
            {
                "code": "us-ok-051",
                "name": "Grady County, OK",
                "value": 3.8
            },
            {
                "code": "us-ok-053",
                "name": "Grant County, OK",
                "value": 2.8
            },
            {
                "code": "us-ok-055",
                "name": "Greer County, OK",
                "value": 5.1
            },
            {
                "code": "us-ok-057",
                "name": "Harmon County, OK",
                "value": 2.7
            },
            {
                "code": "us-ok-059",
                "name": "Harper County, OK",
                "value": 2.6
            },
            {
                "code": "us-ok-061",
                "name": "Haskell County, OK",
                "value": 6.5
            },
            {
                "code": "us-ok-063",
                "name": "Hughes County, OK",
                "value": 5.3
            },
            {
                "code": "us-ok-065",
                "name": "Jackson County, OK",
                "value": 3.5
            },
            {
                "code": "us-ok-067",
                "name": "Jefferson County, OK",
                "value": 4.6
            },
            {
                "code": "us-ok-069",
                "name": "Johnston County, OK",
                "value": 3.4
            },
            {
                "code": "us-ok-071",
                "name": "Kay County, OK",
                "value": 6.4
            },
            {
                "code": "us-ok-073",
                "name": "Kingfisher County, OK",
                "value": 2.5
            },
            {
                "code": "us-ok-075",
                "name": "Kiowa County, OK",
                "value": 5
            },
            {
                "code": "us-ok-077",
                "name": "Latimer County, OK",
                "value": 7.4
            },
            {
                "code": "us-ok-079",
                "name": "Le Flore County, OK",
                "value": 5.8
            },
            {
                "code": "us-ok-081",
                "name": "Lincoln County, OK",
                "value": 4
            },
            {
                "code": "us-ok-083",
                "name": "Logan County, OK",
                "value": 3.5
            },
            {
                "code": "us-ok-085",
                "name": "Love County, OK",
                "value": 2.8
            },
            {
                "code": "us-ok-087",
                "name": "McClain County, OK",
                "value": 3.4
            },
            {
                "code": "us-ok-089",
                "name": "McCurtain County, OK",
                "value": 7.3
            },
            {
                "code": "us-ok-091",
                "name": "McIntosh County, OK",
                "value": 7.6
            },
            {
                "code": "us-ok-093",
                "name": "Major County, OK",
                "value": 2.3
            },
            {
                "code": "us-ok-095",
                "name": "Marshall County, OK",
                "value": 4.5
            },
            {
                "code": "us-ok-097",
                "name": "Mayes County, OK",
                "value": 4.5
            },
            {
                "code": "us-ok-099",
                "name": "Murray County, OK",
                "value": 3.5
            },
            {
                "code": "us-ok-101",
                "name": "Muskogee County, OK",
                "value": 5.2
            },
            {
                "code": "us-ok-103",
                "name": "Noble County, OK",
                "value": 3.2
            },
            {
                "code": "us-ok-105",
                "name": "Nowata County, OK",
                "value": 5.7
            },
            {
                "code": "us-ok-107",
                "name": "Okfuskee County, OK",
                "value": 6
            },
            {
                "code": "us-ok-109",
                "name": "Oklahoma County, OK",
                "value": 3.9
            },
            {
                "code": "us-ok-111",
                "name": "Okmulgee County, OK",
                "value": 6.4
            },
            {
                "code": "us-ok-113",
                "name": "Osage County, OK",
                "value": 5.3
            },
            {
                "code": "us-ok-115",
                "name": "Ottawa County, OK",
                "value": 4
            },
            {
                "code": "us-ok-117",
                "name": "Pawnee County, OK",
                "value": 5.6
            },
            {
                "code": "us-ok-119",
                "name": "Payne County, OK",
                "value": 3.5
            },
            {
                "code": "us-ok-121",
                "name": "Pittsburg County, OK",
                "value": 4.7
            },
            {
                "code": "us-ok-123",
                "name": "Pontotoc County, OK",
                "value": 3.6
            },
            {
                "code": "us-ok-125",
                "name": "Pottawatomie County, OK",
                "value": 4.2
            },
            {
                "code": "us-ok-127",
                "name": "Pushmataha County, OK",
                "value": 6.9
            },
            {
                "code": "us-ok-129",
                "name": "Roger Mills County, OK",
                "value": 2.7
            },
            {
                "code": "us-ok-131",
                "name": "Rogers County, OK",
                "value": 4.1
            },
            {
                "code": "us-ok-133",
                "name": "Seminole County, OK",
                "value": 5.2
            },
            {
                "code": "us-ok-135",
                "name": "Sequoyah County, OK",
                "value": 5.5
            },
            {
                "code": "us-ok-137",
                "name": "Stephens County, OK",
                "value": 5
            },
            {
                "code": "us-ok-139",
                "name": "Texas County, OK",
                "value": 3.6
            },
            {
                "code": "us-ok-141",
                "name": "Tillman County, OK",
                "value": 4.5
            },
            {
                "code": "us-ok-143",
                "name": "Tulsa County, OK",
                "value": 4.1
            },
            {
                "code": "us-ok-145",
                "name": "Wagoner County, OK",
                "value": 4.1
            },
            {
                "code": "us-ok-147",
                "name": "Washington County, OK",
                "value": 4.9
            },
            {
                "code": "us-ok-149",
                "name": "Washita County, OK",
                "value": 3.8
            },
            {
                "code": "us-ok-151",
                "name": "Woods County, OK",
                "value": 2.2
            },
            {
                "code": "us-ok-153",
                "name": "Woodward County, OK",
                "value": 3.5
            },
            {
                "code": "us-or-001",
                "name": "Baker County, OR",
                "value": 7.6
            },
            {
                "code": "us-or-003",
                "name": "Benton County, OR",
                "value": 3.1
            },
            {
                "code": "us-or-005",
                "name": "Clackamas County, OR",
                "value": 4.1
            },
            {
                "code": "us-or-007",
                "name": "Clatsop County, OR",
                "value": 5.1
            },
            {
                "code": "us-or-009",
                "name": "Columbia County, OR",
                "value": 5.6
            },
            {
                "code": "us-or-011",
                "name": "Coos County, OR",
                "value": 6.3
            },
            {
                "code": "us-or-013",
                "name": "Crook County, OR",
                "value": 8.2
            },
            {
                "code": "us-or-015",
                "name": "Curry County, OR",
                "value": 7.8
            },
            {
                "code": "us-or-017",
                "name": "Deschutes County, OR",
                "value": 5.3
            },
            {
                "code": "us-or-019",
                "name": "Douglas County, OR",
                "value": 6.2
            },
            {
                "code": "us-or-021",
                "name": "Gilliam County, OR",
                "value": 4.1
            },
            {
                "code": "us-or-023",
                "name": "Grant County, OR",
                "value": 11.5
            },
            {
                "code": "us-or-025",
                "name": "Harney County, OR",
                "value": 9.2
            },
            {
                "code": "us-or-027",
                "name": "Hood River County, OR",
                "value": 4.1
            },
            {
                "code": "us-or-029",
                "name": "Jackson County, OR",
                "value": 5.5
            },
            {
                "code": "us-or-031",
                "name": "Jefferson County, OR",
                "value": 8
            },
            {
                "code": "us-or-033",
                "name": "Josephine County, OR",
                "value": 6.5
            },
            {
                "code": "us-or-035",
                "name": "Klamath County, OR",
                "value": 8.4
            },
            {
                "code": "us-or-037",
                "name": "Lake County, OR",
                "value": 7.9
            },
            {
                "code": "us-or-039",
                "name": "Lane County, OR",
                "value": 4.9
            },
            {
                "code": "us-or-041",
                "name": "Lincoln County, OR",
                "value": 5.9
            },
            {
                "code": "us-or-043",
                "name": "Linn County, OR",
                "value": 5.3
            },
            {
                "code": "us-or-045",
                "name": "Malheur County, OR",
                "value": 6.2
            },
            {
                "code": "us-or-047",
                "name": "Marion County, OR",
                "value": 4.8
            },
            {
                "code": "us-or-049",
                "name": "Morrow County, OR",
                "value": 5.6
            },
            {
                "code": "us-or-051",
                "name": "Multnomah County, OR",
                "value": 4
            },
            {
                "code": "us-or-053",
                "name": "Polk County, OR",
                "value": 4.8
            },
            {
                "code": "us-or-055",
                "name": "Sherman County, OR",
                "value": 4.6
            },
            {
                "code": "us-or-057",
                "name": "Tillamook County, OR",
                "value": 5.2
            },
            {
                "code": "us-or-059",
                "name": "Umatilla County, OR",
                "value": 6.9
            },
            {
                "code": "us-or-061",
                "name": "Union County, OR",
                "value": 7.1
            },
            {
                "code": "us-or-063",
                "name": "Wallowa County, OR",
                "value": 8.5
            },
            {
                "code": "us-or-065",
                "name": "Wasco County, OR",
                "value": 5.6
            },
            {
                "code": "us-or-067",
                "name": "Washington County, OR",
                "value": 3.7
            },
            {
                "code": "us-or-069",
                "name": "Wheeler County, OR",
                "value": 3.4
            },
            {
                "code": "us-or-071",
                "name": "Yamhill County, OR",
                "value": 3.9
            },
            {
                "code": "us-pa-001",
                "name": "Adams County, PA",
                "value": 3.9
            },
            {
                "code": "us-pa-003",
                "name": "Allegheny County, PA",
                "value": 4.7
            },
            {
                "code": "us-pa-005",
                "name": "Armstrong County, PA",
                "value": 7
            },
            {
                "code": "us-pa-007",
                "name": "Beaver County, PA",
                "value": 5.7
            },
            {
                "code": "us-pa-009",
                "name": "Bedford County, PA",
                "value": 6.3
            },
            {
                "code": "us-pa-011",
                "name": "Berks County, PA",
                "value": 4.7
            },
            {
                "code": "us-pa-013",
                "name": "Blair County, PA",
                "value": 4.8
            },
            {
                "code": "us-pa-015",
                "name": "Bradford County, PA",
                "value": 5.4
            },
            {
                "code": "us-pa-017",
                "name": "Bucks County, PA",
                "value": 4.3
            },
            {
                "code": "us-pa-019",
                "name": "Butler County, PA",
                "value": 5
            },
            {
                "code": "us-pa-021",
                "name": "Cambria County, PA",
                "value": 6.1
            },
            {
                "code": "us-pa-023",
                "name": "Cameron County, PA",
                "value": 6.7
            },
            {
                "code": "us-pa-025",
                "name": "Carbon County, PA",
                "value": 5.9
            },
            {
                "code": "us-pa-027",
                "name": "Centre County, PA",
                "value": 3.7
            },
            {
                "code": "us-pa-029",
                "name": "Chester County, PA",
                "value": 3.5
            },
            {
                "code": "us-pa-031",
                "name": "Clarion County, PA",
                "value": 6.1
            },
            {
                "code": "us-pa-033",
                "name": "Clearfield County, PA",
                "value": 6.7
            },
            {
                "code": "us-pa-035",
                "name": "Clinton County, PA",
                "value": 7.2
            },
            {
                "code": "us-pa-037",
                "name": "Columbia County, PA",
                "value": 6.2
            },
            {
                "code": "us-pa-039",
                "name": "Crawford County, PA",
                "value": 5.9
            },
            {
                "code": "us-pa-041",
                "name": "Cumberland County, PA",
                "value": 3.8
            },
            {
                "code": "us-pa-043",
                "name": "Dauphin County, PA",
                "value": 4.5
            },
            {
                "code": "us-pa-045",
                "name": "Delaware County, PA",
                "value": 4.4
            },
            {
                "code": "us-pa-047",
                "name": "Elk County, PA",
                "value": 4.4
            },
            {
                "code": "us-pa-049",
                "name": "Erie County, PA",
                "value": 5.8
            },
            {
                "code": "us-pa-051",
                "name": "Fayette County, PA",
                "value": 7.8
            },
            {
                "code": "us-pa-053",
                "name": "Forest County, PA",
                "value": 8.2
            },
            {
                "code": "us-pa-055",
                "name": "Franklin County, PA",
                "value": 4.4
            },
            {
                "code": "us-pa-057",
                "name": "Fulton County, PA",
                "value": 5.6
            },
            {
                "code": "us-pa-059",
                "name": "Greene County, PA",
                "value": 5.9
            },
            {
                "code": "us-pa-061",
                "name": "Huntingdon County, PA",
                "value": 7.6
            },
            {
                "code": "us-pa-063",
                "name": "Indiana County, PA",
                "value": 6.4
            },
            {
                "code": "us-pa-065",
                "name": "Jefferson County, PA",
                "value": 6.2
            },
            {
                "code": "us-pa-067",
                "name": "Juniata County, PA",
                "value": 5.9
            },
            {
                "code": "us-pa-069",
                "name": "Lackawanna County, PA",
                "value": 5.3
            },
            {
                "code": "us-pa-071",
                "name": "Lancaster County, PA",
                "value": 4
            },
            {
                "code": "us-pa-073",
                "name": "Lawrence County, PA",
                "value": 7.1
            },
            {
                "code": "us-pa-075",
                "name": "Lebanon County, PA",
                "value": 4.4
            },
            {
                "code": "us-pa-077",
                "name": "Lehigh County, PA",
                "value": 5.1
            },
            {
                "code": "us-pa-079",
                "name": "Luzerne County, PA",
                "value": 6.2
            },
            {
                "code": "us-pa-081",
                "name": "Lycoming County, PA",
                "value": 5.9
            },
            {
                "code": "us-pa-083",
                "name": "McKean County, PA",
                "value": 5.8
            },
            {
                "code": "us-pa-085",
                "name": "Mercer County, PA",
                "value": 5.9
            },
            {
                "code": "us-pa-087",
                "name": "Mifflin County, PA",
                "value": 5.8
            },
            {
                "code": "us-pa-089",
                "name": "Monroe County, PA",
                "value": 6.1
            },
            {
                "code": "us-pa-091",
                "name": "Montgomery County, PA",
                "value": 3.8
            },
            {
                "code": "us-pa-093",
                "name": "Montour County, PA",
                "value": 4.2
            },
            {
                "code": "us-pa-095",
                "name": "Northampton County, PA",
                "value": 5.1
            },
            {
                "code": "us-pa-097",
                "name": "Northumberland County, PA",
                "value": 6.6
            },
            {
                "code": "us-pa-099",
                "name": "Perry County, PA",
                "value": 4.8
            },
            {
                "code": "us-pa-101",
                "name": "Philadelphia County/city, PA",
                "value": 6
            },
            {
                "code": "us-pa-103",
                "name": "Pike County, PA",
                "value": 6.5
            },
            {
                "code": "us-pa-105",
                "name": "Potter County, PA",
                "value": 7.4
            },
            {
                "code": "us-pa-107",
                "name": "Schuylkill County, PA",
                "value": 6.2
            },
            {
                "code": "us-pa-109",
                "name": "Snyder County, PA",
                "value": 4.9
            },
            {
                "code": "us-pa-111",
                "name": "Somerset County, PA",
                "value": 6.9
            },
            {
                "code": "us-pa-113",
                "name": "Sullivan County, PA",
                "value": 6.1
            },
            {
                "code": "us-pa-115",
                "name": "Susquehanna County, PA",
                "value": 5.6
            },
            {
                "code": "us-pa-117",
                "name": "Tioga County, PA",
                "value": 6.8
            },
            {
                "code": "us-pa-119",
                "name": "Union County, PA",
                "value": 4.5
            },
            {
                "code": "us-pa-121",
                "name": "Venango County, PA",
                "value": 6.2
            },
            {
                "code": "us-pa-123",
                "name": "Warren County, PA",
                "value": 5.3
            },
            {
                "code": "us-pa-125",
                "name": "Washington County, PA",
                "value": 5.4
            },
            {
                "code": "us-pa-127",
                "name": "Wayne County, PA",
                "value": 6.6
            },
            {
                "code": "us-pa-129",
                "name": "Westmoreland County, PA",
                "value": 5.6
            },
            {
                "code": "us-pa-131",
                "name": "Wyoming County, PA",
                "value": 5.9
            },
            {
                "code": "us-pa-133",
                "name": "York County, PA",
                "value": 4.5
            },
            {
                "code": "us-ri-001",
                "name": "Bristol County, RI",
                "value": 4.7
            },
            {
                "code": "us-ri-003",
                "name": "Kent County, RI",
                "value": 4.9
            },
            {
                "code": "us-ri-005",
                "name": "Newport County, RI",
                "value": 5.3
            },
            {
                "code": "us-ri-007",
                "name": "Providence County, RI",
                "value": 5.5
            },
            {
                "code": "us-ri-009",
                "name": "Washington County, RI",
                "value": 4.9
            },
            {
                "code": "us-sc-001",
                "name": "Abbeville County, SC",
                "value": 5.1
            },
            {
                "code": "us-sc-003",
                "name": "Aiken County, SC",
                "value": 4.2
            },
            {
                "code": "us-sc-005",
                "name": "Allendale County, SC",
                "value": 7.4
            },
            {
                "code": "us-sc-007",
                "name": "Anderson County, SC",
                "value": 4.2
            },
            {
                "code": "us-sc-009",
                "name": "Bamberg County, SC",
                "value": 7.3
            },
            {
                "code": "us-sc-011",
                "name": "Barnwell County, SC",
                "value": 5.8
            },
            {
                "code": "us-sc-013",
                "name": "Beaufort County, SC",
                "value": 4.2
            },
            {
                "code": "us-sc-015",
                "name": "Berkeley County, SC",
                "value": 3.9
            },
            {
                "code": "us-sc-017",
                "name": "Calhoun County, SC",
                "value": 5
            },
            {
                "code": "us-sc-019",
                "name": "Charleston County, SC",
                "value": 3.5
            },
            {
                "code": "us-sc-021",
                "name": "Cherokee County, SC",
                "value": 4.6
            },
            {
                "code": "us-sc-023",
                "name": "Chester County, SC",
                "value": 6
            },
            {
                "code": "us-sc-025",
                "name": "Chesterfield County, SC",
                "value": 4.2
            },
            {
                "code": "us-sc-027",
                "name": "Clarendon County, SC",
                "value": 6.1
            },
            {
                "code": "us-sc-029",
                "name": "Colleton County, SC",
                "value": 5.2
            },
            {
                "code": "us-sc-031",
                "name": "Darlington County, SC",
                "value": 5.1
            },
            {
                "code": "us-sc-033",
                "name": "Dillon County, SC",
                "value": 5.7
            },
            {
                "code": "us-sc-035",
                "name": "Dorchester County, SC",
                "value": 3.9
            },
            {
                "code": "us-sc-037",
                "name": "Edgefield County, SC",
                "value": 4.4
            },
            {
                "code": "us-sc-039",
                "name": "Fairfield County, SC",
                "value": 8.9
            },
            {
                "code": "us-sc-041",
                "name": "Florence County, SC",
                "value": 4.6
            },
            {
                "code": "us-sc-043",
                "name": "Georgetown County, SC",
                "value": 6.3
            },
            {
                "code": "us-sc-045",
                "name": "Greenville County, SC",
                "value": 3.7
            },
            {
                "code": "us-sc-047",
                "name": "Greenwood County, SC",
                "value": 4.7
            },
            {
                "code": "us-sc-049",
                "name": "Hampton County, SC",
                "value": 4.3
            },
            {
                "code": "us-sc-051",
                "name": "Horry County, SC",
                "value": 6.2
            },
            {
                "code": "us-sc-053",
                "name": "Jasper County, SC",
                "value": 4
            },
            {
                "code": "us-sc-055",
                "name": "Kershaw County, SC",
                "value": 4.5
            },
            {
                "code": "us-sc-057",
                "name": "Lancaster County, SC",
                "value": 4.8
            },
            {
                "code": "us-sc-059",
                "name": "Laurens County, SC",
                "value": 4.6
            },
            {
                "code": "us-sc-061",
                "name": "Lee County, SC",
                "value": 5.4
            },
            {
                "code": "us-sc-063",
                "name": "Lexington County, SC",
                "value": 3.7
            },
            {
                "code": "us-sc-065",
                "name": "McCormick County, SC",
                "value": 4.9
            },
            {
                "code": "us-sc-067",
                "name": "Marion County, SC",
                "value": 7.1
            },
            {
                "code": "us-sc-069",
                "name": "Marlboro County, SC",
                "value": 6.3
            },
            {
                "code": "us-sc-071",
                "name": "Newberry County, SC",
                "value": 4.2
            },
            {
                "code": "us-sc-073",
                "name": "Oconee County, SC",
                "value": 4.5
            },
            {
                "code": "us-sc-075",
                "name": "Orangeburg County, SC",
                "value": 7
            },
            {
                "code": "us-sc-077",
                "name": "Pickens County, SC",
                "value": 4.3
            },
            {
                "code": "us-sc-079",
                "name": "Richland County, SC",
                "value": 4.4
            },
            {
                "code": "us-sc-081",
                "name": "Saluda County, SC",
                "value": 4
            },
            {
                "code": "us-sc-083",
                "name": "Spartanburg County, SC",
                "value": 4
            },
            {
                "code": "us-sc-085",
                "name": "Sumter County, SC",
                "value": 5.2
            },
            {
                "code": "us-sc-087",
                "name": "Union County, SC",
                "value": 5.5
            },
            {
                "code": "us-sc-089",
                "name": "Williamsburg County, SC",
                "value": 6.8
            },
            {
                "code": "us-sc-091",
                "name": "York County, SC",
                "value": 4.1
            },
            {
                "code": "us-sd-003",
                "name": "Aurora County, SD",
                "value": 3.6
            },
            {
                "code": "us-sd-005",
                "name": "Beadle County, SD",
                "value": 3
            },
            {
                "code": "us-sd-007",
                "name": "Bennett County, SD",
                "value": 4.3
            },
            {
                "code": "us-sd-009",
                "name": "Bon Homme County, SD",
                "value": 2.7
            },
            {
                "code": "us-sd-011",
                "name": "Brookings County, SD",
                "value": 3.2
            },
            {
                "code": "us-sd-013",
                "name": "Brown County, SD",
                "value": 3.2
            },
            {
                "code": "us-sd-015",
                "name": "Brule County, SD",
                "value": 3
            },
            {
                "code": "us-sd-017",
                "name": "Buffalo County, SD",
                "value": 7.4
            },
            {
                "code": "us-sd-019",
                "name": "Butte County, SD",
                "value": 3.8
            },
            {
                "code": "us-sd-021",
                "name": "Campbell County, SD",
                "value": 4.5
            },
            {
                "code": "us-sd-023",
                "name": "Charles Mix County, SD",
                "value": 3.3
            },
            {
                "code": "us-sd-025",
                "name": "Clark County, SD",
                "value": 5.6
            },
            {
                "code": "us-sd-027",
                "name": "Clay County, SD",
                "value": 2.9
            },
            {
                "code": "us-sd-029",
                "name": "Codington County, SD",
                "value": 3.9
            },
            {
                "code": "us-sd-031",
                "name": "Corson County, SD",
                "value": 3.6
            },
            {
                "code": "us-sd-033",
                "name": "Custer County, SD",
                "value": 5.1
            },
            {
                "code": "us-sd-035",
                "name": "Davison County, SD",
                "value": 3.1
            },
            {
                "code": "us-sd-037",
                "name": "Day County, SD",
                "value": 5.8
            },
            {
                "code": "us-sd-039",
                "name": "Deuel County, SD",
                "value": 7
            },
            {
                "code": "us-sd-041",
                "name": "Dewey County, SD",
                "value": 8.3
            },
            {
                "code": "us-sd-043",
                "name": "Douglas County, SD",
                "value": 3.3
            },
            {
                "code": "us-sd-045",
                "name": "Edmunds County, SD",
                "value": 3
            },
            {
                "code": "us-sd-047",
                "name": "Fall River County, SD",
                "value": 4.9
            },
            {
                "code": "us-sd-049",
                "name": "Faulk County, SD",
                "value": 3.4
            },
            {
                "code": "us-sd-051",
                "name": "Grant County, SD",
                "value": 4.7
            },
            {
                "code": "us-sd-053",
                "name": "Gregory County, SD",
                "value": 3.7
            },
            {
                "code": "us-sd-055",
                "name": "Haakon County, SD",
                "value": 3.2
            },
            {
                "code": "us-sd-057",
                "name": "Hamlin County, SD",
                "value": 4.8
            },
            {
                "code": "us-sd-059",
                "name": "Hand County, SD",
                "value": 2.7
            },
            {
                "code": "us-sd-061",
                "name": "Hanson County, SD",
                "value": 5.8
            },
            {
                "code": "us-sd-063",
                "name": "Harding County, SD",
                "value": 2.5
            },
            {
                "code": "us-sd-065",
                "name": "Hughes County, SD",
                "value": 3.3
            },
            {
                "code": "us-sd-067",
                "name": "Hutchinson County, SD",
                "value": 3.6
            },
            {
                "code": "us-sd-069",
                "name": "Hyde County, SD",
                "value": 2.9
            },
            {
                "code": "us-sd-071",
                "name": "Jackson County, SD",
                "value": 7.5
            },
            {
                "code": "us-sd-073",
                "name": "Jerauld County, SD",
                "value": 2.4
            },
            {
                "code": "us-sd-075",
                "name": "Jones County, SD",
                "value": 3.3
            },
            {
                "code": "us-sd-077",
                "name": "Kingsbury County, SD",
                "value": 4
            },
            {
                "code": "us-sd-079",
                "name": "Lake County, SD",
                "value": 4
            },
            {
                "code": "us-sd-081",
                "name": "Lawrence County, SD",
                "value": 3.3
            },
            {
                "code": "us-sd-083",
                "name": "Lincoln County, SD",
                "value": 2.6
            },
            {
                "code": "us-sd-085",
                "name": "Lyman County, SD",
                "value": 4.9
            },
            {
                "code": "us-sd-087",
                "name": "McCook County, SD",
                "value": 3.2
            },
            {
                "code": "us-sd-089",
                "name": "McPherson County, SD",
                "value": 4.5
            },
            {
                "code": "us-sd-091",
                "name": "Marshall County, SD",
                "value": 4.8
            },
            {
                "code": "us-sd-093",
                "name": "Meade County, SD",
                "value": 4.1
            },
            {
                "code": "us-sd-095",
                "name": "Mellette County, SD",
                "value": 4.9
            },
            {
                "code": "us-sd-097",
                "name": "Miner County, SD",
                "value": 2.9
            },
            {
                "code": "us-sd-099",
                "name": "Minnehaha County, SD",
                "value": 3.2
            },
            {
                "code": "us-sd-101",
                "name": "Moody County, SD",
                "value": 3.4
            },
            {
                "code": "us-sd-102",
                "name": "Oglala Lakota County, SD",
                "value": 10.9
            },
            {
                "code": "us-sd-103",
                "name": "Pennington County, SD",
                "value": 3.5
            },
            {
                "code": "us-sd-105",
                "name": "Perkins County, SD",
                "value": 3.3
            },
            {
                "code": "us-sd-107",
                "name": "Potter County, SD",
                "value": 4.9
            },
            {
                "code": "us-sd-109",
                "name": "Roberts County, SD",
                "value": 6.1
            },
            {
                "code": "us-sd-111",
                "name": "Sanborn County, SD",
                "value": 3
            },
            {
                "code": "us-sd-115",
                "name": "Spink County, SD",
                "value": 4.7
            },
            {
                "code": "us-sd-117",
                "name": "Stanley County, SD",
                "value": 3.8
            },
            {
                "code": "us-sd-119",
                "name": "Sully County, SD",
                "value": 3.3
            },
            {
                "code": "us-sd-121",
                "name": "Todd County, SD",
                "value": 6.6
            },
            {
                "code": "us-sd-123",
                "name": "Tripp County, SD",
                "value": 3.2
            },
            {
                "code": "us-sd-125",
                "name": "Turner County, SD",
                "value": 3.5
            },
            {
                "code": "us-sd-127",
                "name": "Union County, SD",
                "value": 3.7
            },
            {
                "code": "us-sd-129",
                "name": "Walworth County, SD",
                "value": 5.4
            },
            {
                "code": "us-sd-135",
                "name": "Yankton County, SD",
                "value": 3.1
            },
            {
                "code": "us-sd-137",
                "name": "Ziebach County, SD",
                "value": 4.1
            },
            {
                "code": "us-tn-001",
                "name": "Anderson County, TN",
                "value": 4.1
            },
            {
                "code": "us-tn-003",
                "name": "Bedford County, TN",
                "value": 4
            },
            {
                "code": "us-tn-005",
                "name": "Benton County, TN",
                "value": 6.8
            },
            {
                "code": "us-tn-007",
                "name": "Bledsoe County, TN",
                "value": 6.6
            },
            {
                "code": "us-tn-009",
                "name": "Blount County, TN",
                "value": 3.9
            },
            {
                "code": "us-tn-011",
                "name": "Bradley County, TN",
                "value": 3.9
            },
            {
                "code": "us-tn-013",
                "name": "Campbell County, TN",
                "value": 5.4
            },
            {
                "code": "us-tn-015",
                "name": "Cannon County, TN",
                "value": 3.5
            },
            {
                "code": "us-tn-017",
                "name": "Carroll County, TN",
                "value": 5.7
            },
            {
                "code": "us-tn-019",
                "name": "Carter County, TN",
                "value": 5
            },
            {
                "code": "us-tn-021",
                "name": "Cheatham County, TN",
                "value": 2.9
            },
            {
                "code": "us-tn-023",
                "name": "Chester County, TN",
                "value": 4.4
            },
            {
                "code": "us-tn-025",
                "name": "Claiborne County, TN",
                "value": 4.8
            },
            {
                "code": "us-tn-027",
                "name": "Clay County, TN",
                "value": 6.1
            },
            {
                "code": "us-tn-029",
                "name": "Cocke County, TN",
                "value": 6.8
            },
            {
                "code": "us-tn-031",
                "name": "Coffee County, TN",
                "value": 3.7
            },
            {
                "code": "us-tn-033",
                "name": "Crockett County, TN",
                "value": 4.7
            },
            {
                "code": "us-tn-035",
                "name": "Cumberland County, TN",
                "value": 5.8
            },
            {
                "code": "us-tn-037",
                "name": "Davidson County, TN",
                "value": 2.8
            },
            {
                "code": "us-tn-039",
                "name": "Decatur County, TN",
                "value": 6
            },
            {
                "code": "us-tn-041",
                "name": "DeKalb County, TN",
                "value": 5
            },
            {
                "code": "us-tn-043",
                "name": "Dickson County, TN",
                "value": 3.6
            },
            {
                "code": "us-tn-045",
                "name": "Dyer County, TN",
                "value": 5.4
            },
            {
                "code": "us-tn-047",
                "name": "Fayette County, TN",
                "value": 4.3
            },
            {
                "code": "us-tn-049",
                "name": "Fentress County, TN",
                "value": 4.7
            },
            {
                "code": "us-tn-051",
                "name": "Franklin County, TN",
                "value": 3.8
            },
            {
                "code": "us-tn-053",
                "name": "Gibson County, TN",
                "value": 4.9
            },
            {
                "code": "us-tn-055",
                "name": "Giles County, TN",
                "value": 4.1
            },
            {
                "code": "us-tn-057",
                "name": "Grainger County, TN",
                "value": 4.7
            },
            {
                "code": "us-tn-059",
                "name": "Greene County, TN",
                "value": 5.2
            },
            {
                "code": "us-tn-061",
                "name": "Grundy County, TN",
                "value": 5.2
            },
            {
                "code": "us-tn-063",
                "name": "Hamblen County, TN",
                "value": 4.5
            },
            {
                "code": "us-tn-065",
                "name": "Hamilton County, TN",
                "value": 3.8
            },
            {
                "code": "us-tn-067",
                "name": "Hancock County, TN",
                "value": 5.6
            },
            {
                "code": "us-tn-069",
                "name": "Hardeman County, TN",
                "value": 5.8
            },
            {
                "code": "us-tn-071",
                "name": "Hardin County, TN",
                "value": 5.1
            },
            {
                "code": "us-tn-073",
                "name": "Hawkins County, TN",
                "value": 4.5
            },
            {
                "code": "us-tn-075",
                "name": "Haywood County, TN",
                "value": 6.1
            },
            {
                "code": "us-tn-077",
                "name": "Henderson County, TN",
                "value": 5.9
            },
            {
                "code": "us-tn-079",
                "name": "Henry County, TN",
                "value": 5.1
            },
            {
                "code": "us-tn-081",
                "name": "Hickman County, TN",
                "value": 3.6
            },
            {
                "code": "us-tn-083",
                "name": "Houston County, TN",
                "value": 7.2
            },
            {
                "code": "us-tn-085",
                "name": "Humphreys County, TN",
                "value": 5.5
            },
            {
                "code": "us-tn-087",
                "name": "Jackson County, TN",
                "value": 5.5
            },
            {
                "code": "us-tn-089",
                "name": "Jefferson County, TN",
                "value": 4.8
            },
            {
                "code": "us-tn-091",
                "name": "Johnson County, TN",
                "value": 4.4
            },
            {
                "code": "us-tn-093",
                "name": "Knox County, TN",
                "value": 3.2
            },
            {
                "code": "us-tn-095",
                "name": "Lake County, TN",
                "value": 6.7
            },
            {
                "code": "us-tn-097",
                "name": "Lauderdale County, TN",
                "value": 6.3
            },
            {
                "code": "us-tn-099",
                "name": "Lawrence County, TN",
                "value": 4.9
            },
            {
                "code": "us-tn-101",
                "name": "Lewis County, TN",
                "value": 5.3
            },
            {
                "code": "us-tn-103",
                "name": "Lincoln County, TN",
                "value": 3.4
            },
            {
                "code": "us-tn-105",
                "name": "Loudon County, TN",
                "value": 3.9
            },
            {
                "code": "us-tn-107",
                "name": "McMinn County, TN",
                "value": 4.8
            },
            {
                "code": "us-tn-109",
                "name": "McNairy County, TN",
                "value": 6.2
            },
            {
                "code": "us-tn-111",
                "name": "Macon County, TN",
                "value": 3.5
            },
            {
                "code": "us-tn-113",
                "name": "Madison County, TN",
                "value": 4.2
            },
            {
                "code": "us-tn-115",
                "name": "Marion County, TN",
                "value": 5.5
            },
            {
                "code": "us-tn-117",
                "name": "Marshall County, TN",
                "value": 4
            },
            {
                "code": "us-tn-119",
                "name": "Maury County, TN",
                "value": 4.1
            },
            {
                "code": "us-tn-121",
                "name": "Meigs County, TN",
                "value": 5.4
            },
            {
                "code": "us-tn-123",
                "name": "Monroe County, TN",
                "value": 4.2
            },
            {
                "code": "us-tn-125",
                "name": "Montgomery County, TN",
                "value": 4.2
            },
            {
                "code": "us-tn-127",
                "name": "Moore County, TN",
                "value": 3.2
            },
            {
                "code": "us-tn-129",
                "name": "Morgan County, TN",
                "value": 5.5
            },
            {
                "code": "us-tn-131",
                "name": "Obion County, TN",
                "value": 5.8
            },
            {
                "code": "us-tn-133",
                "name": "Overton County, TN",
                "value": 4.7
            },
            {
                "code": "us-tn-135",
                "name": "Perry County, TN",
                "value": 4.9
            },
            {
                "code": "us-tn-137",
                "name": "Pickett County, TN",
                "value": 4.6
            },
            {
                "code": "us-tn-139",
                "name": "Polk County, TN",
                "value": 5.2
            },
            {
                "code": "us-tn-141",
                "name": "Putnam County, TN",
                "value": 3.9
            },
            {
                "code": "us-tn-143",
                "name": "Rhea County, TN",
                "value": 7.2
            },
            {
                "code": "us-tn-145",
                "name": "Roane County, TN",
                "value": 4.8
            },
            {
                "code": "us-tn-147",
                "name": "Robertson County, TN",
                "value": 3.5
            },
            {
                "code": "us-tn-149",
                "name": "Rutherford County, TN",
                "value": 2.9
            },
            {
                "code": "us-tn-151",
                "name": "Scott County, TN",
                "value": 4.9
            },
            {
                "code": "us-tn-153",
                "name": "Sequatchie County, TN",
                "value": 5.1
            },
            {
                "code": "us-tn-155",
                "name": "Sevier County, TN",
                "value": 6.4
            },
            {
                "code": "us-tn-157",
                "name": "Shelby County, TN",
                "value": 4.5
            },
            {
                "code": "us-tn-159",
                "name": "Smith County, TN",
                "value": 3.7
            },
            {
                "code": "us-tn-161",
                "name": "Stewart County, TN",
                "value": 6.1
            },
            {
                "code": "us-tn-163",
                "name": "Sullivan County, TN",
                "value": 4.1
            },
            {
                "code": "us-tn-165",
                "name": "Sumner County, TN",
                "value": 3.1
            },
            {
                "code": "us-tn-167",
                "name": "Tipton County, TN",
                "value": 4.8
            },
            {
                "code": "us-tn-169",
                "name": "Trousdale County, TN",
                "value": 3.8
            },
            {
                "code": "us-tn-171",
                "name": "Unicoi County, TN",
                "value": 6.3
            },
            {
                "code": "us-tn-173",
                "name": "Union County, TN",
                "value": 4.7
            },
            {
                "code": "us-tn-175",
                "name": "Van Buren County, TN",
                "value": 5
            },
            {
                "code": "us-tn-177",
                "name": "Warren County, TN",
                "value": 4.3
            },
            {
                "code": "us-tn-179",
                "name": "Washington County, TN",
                "value": 4
            },
            {
                "code": "us-tn-181",
                "name": "Wayne County, TN",
                "value": 6.3
            },
            {
                "code": "us-tn-183",
                "name": "Weakley County, TN",
                "value": 4.5
            },
            {
                "code": "us-tn-185",
                "name": "White County, TN",
                "value": 4.1
            },
            {
                "code": "us-tn-187",
                "name": "Williamson County, TN",
                "value": 2.7
            },
            {
                "code": "us-tn-189",
                "name": "Wilson County, TN",
                "value": 3
            },
            {
                "code": "us-tx-001",
                "name": "Anderson County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-003",
                "name": "Andrews County, TX",
                "value": 2.8
            },
            {
                "code": "us-tx-005",
                "name": "Angelina County, TX",
                "value": 4.8
            },
            {
                "code": "us-tx-007",
                "name": "Aransas County, TX",
                "value": 8.1
            },
            {
                "code": "us-tx-009",
                "name": "Archer County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-011",
                "name": "Armstrong County, TX",
                "value": 3
            },
            {
                "code": "us-tx-013",
                "name": "Atascosa County, TX",
                "value": 4
            },
            {
                "code": "us-tx-015",
                "name": "Austin County, TX",
                "value": 4.1
            },
            {
                "code": "us-tx-017",
                "name": "Bailey County, TX",
                "value": 4.3
            },
            {
                "code": "us-tx-019",
                "name": "Bandera County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-021",
                "name": "Bastrop County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-023",
                "name": "Baylor County, TX",
                "value": 3.1
            },
            {
                "code": "us-tx-025",
                "name": "Bee County, TX",
                "value": 5.9
            },
            {
                "code": "us-tx-027",
                "name": "Bell County, TX",
                "value": 4.3
            },
            {
                "code": "us-tx-029",
                "name": "Bexar County, TX",
                "value": 3.5
            },
            {
                "code": "us-tx-031",
                "name": "Blanco County, TX",
                "value": 2.9
            },
            {
                "code": "us-tx-033",
                "name": "Borden County, TX",
                "value": 3.7
            },
            {
                "code": "us-tx-035",
                "name": "Bosque County, TX",
                "value": 4.1
            },
            {
                "code": "us-tx-037",
                "name": "Bowie County, TX",
                "value": 4.7
            },
            {
                "code": "us-tx-039",
                "name": "Brazoria County, TX",
                "value": 5.3
            },
            {
                "code": "us-tx-041",
                "name": "Brazos County, TX",
                "value": 3
            },
            {
                "code": "us-tx-043",
                "name": "Brewster County, TX",
                "value": 3.9
            },
            {
                "code": "us-tx-045",
                "name": "Briscoe County, TX",
                "value": 4.1
            },
            {
                "code": "us-tx-047",
                "name": "Brooks County, TX",
                "value": 7.2
            },
            {
                "code": "us-tx-049",
                "name": "Brown County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-051",
                "name": "Burleson County, TX",
                "value": 4
            },
            {
                "code": "us-tx-053",
                "name": "Burnet County, TX",
                "value": 3
            },
            {
                "code": "us-tx-055",
                "name": "Caldwell County, TX",
                "value": 3.7
            },
            {
                "code": "us-tx-057",
                "name": "Calhoun County, TX",
                "value": 5.7
            },
            {
                "code": "us-tx-059",
                "name": "Callahan County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-061",
                "name": "Cameron County, TX",
                "value": 6.9
            },
            {
                "code": "us-tx-063",
                "name": "Camp County, TX",
                "value": 5.3
            },
            {
                "code": "us-tx-065",
                "name": "Carson County, TX",
                "value": 3.2
            },
            {
                "code": "us-tx-067",
                "name": "Cass County, TX",
                "value": 5.8
            },
            {
                "code": "us-tx-069",
                "name": "Castro County, TX",
                "value": 3
            },
            {
                "code": "us-tx-071",
                "name": "Chambers County, TX",
                "value": 6.6
            },
            {
                "code": "us-tx-073",
                "name": "Cherokee County, TX",
                "value": 4.6
            },
            {
                "code": "us-tx-075",
                "name": "Childress County, TX",
                "value": 2.9
            },
            {
                "code": "us-tx-077",
                "name": "Clay County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-079",
                "name": "Cochran County, TX",
                "value": 4.7
            },
            {
                "code": "us-tx-081",
                "name": "Coke County, TX",
                "value": 3.9
            },
            {
                "code": "us-tx-083",
                "name": "Coleman County, TX",
                "value": 4.1
            },
            {
                "code": "us-tx-085",
                "name": "Collin County, TX",
                "value": 3.5
            },
            {
                "code": "us-tx-087",
                "name": "Collingsworth County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-089",
                "name": "Colorado County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-091",
                "name": "Comal County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-093",
                "name": "Comanche County, TX",
                "value": 3.9
            },
            {
                "code": "us-tx-095",
                "name": "Concho County, TX",
                "value": 4.1
            },
            {
                "code": "us-tx-097",
                "name": "Cooke County, TX",
                "value": 3.7
            },
            {
                "code": "us-tx-099",
                "name": "Coryell County, TX",
                "value": 4.4
            },
            {
                "code": "us-tx-101",
                "name": "Cottle County, TX",
                "value": 4.3
            },
            {
                "code": "us-tx-103",
                "name": "Crane County, TX",
                "value": 4.4
            },
            {
                "code": "us-tx-105",
                "name": "Crockett County, TX",
                "value": 3.5
            },
            {
                "code": "us-tx-107",
                "name": "Crosby County, TX",
                "value": 4.1
            },
            {
                "code": "us-tx-109",
                "name": "Culberson County, TX",
                "value": 3.2
            },
            {
                "code": "us-tx-111",
                "name": "Dallam County, TX",
                "value": 2.1
            },
            {
                "code": "us-tx-113",
                "name": "Dallas County, TX",
                "value": 3.9
            },
            {
                "code": "us-tx-115",
                "name": "Dawson County, TX",
                "value": 4.3
            },
            {
                "code": "us-tx-117",
                "name": "Deaf Smith County, TX",
                "value": 3
            },
            {
                "code": "us-tx-119",
                "name": "Delta County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-121",
                "name": "Denton County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-123",
                "name": "DeWitt County, TX",
                "value": 3.5
            },
            {
                "code": "us-tx-125",
                "name": "Dickens County, TX",
                "value": 4.3
            },
            {
                "code": "us-tx-127",
                "name": "Dimmit County, TX",
                "value": 4
            },
            {
                "code": "us-tx-129",
                "name": "Donley County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-131",
                "name": "Duval County, TX",
                "value": 5.9
            },
            {
                "code": "us-tx-133",
                "name": "Eastland County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-135",
                "name": "Ector County, TX",
                "value": 3.2
            },
            {
                "code": "us-tx-137",
                "name": "Edwards County, TX",
                "value": 2.9
            },
            {
                "code": "us-tx-139",
                "name": "Ellis County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-141",
                "name": "El Paso County, TX",
                "value": 4.6
            },
            {
                "code": "us-tx-143",
                "name": "Erath County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-145",
                "name": "Falls County, TX",
                "value": 4.4
            },
            {
                "code": "us-tx-147",
                "name": "Fannin County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-149",
                "name": "Fayette County, TX",
                "value": 3.2
            },
            {
                "code": "us-tx-151",
                "name": "Fisher County, TX",
                "value": 3.7
            },
            {
                "code": "us-tx-153",
                "name": "Floyd County, TX",
                "value": 5.7
            },
            {
                "code": "us-tx-155",
                "name": "Foard County, TX",
                "value": 2.7
            },
            {
                "code": "us-tx-157",
                "name": "Fort Bend County, TX",
                "value": 4.5
            },
            {
                "code": "us-tx-159",
                "name": "Franklin County, TX",
                "value": 4.6
            },
            {
                "code": "us-tx-161",
                "name": "Freestone County, TX",
                "value": 6
            },
            {
                "code": "us-tx-163",
                "name": "Frio County, TX",
                "value": 3.5
            },
            {
                "code": "us-tx-165",
                "name": "Gaines County, TX",
                "value": 2.6
            },
            {
                "code": "us-tx-167",
                "name": "Galveston County, TX",
                "value": 5.3
            },
            {
                "code": "us-tx-169",
                "name": "Garza County, TX",
                "value": 3
            },
            {
                "code": "us-tx-171",
                "name": "Gillespie County, TX",
                "value": 2.6
            },
            {
                "code": "us-tx-173",
                "name": "Glasscock County, TX",
                "value": 2.3
            },
            {
                "code": "us-tx-175",
                "name": "Goliad County, TX",
                "value": 4.3
            },
            {
                "code": "us-tx-177",
                "name": "Gonzales County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-179",
                "name": "Gray County, TX",
                "value": 4.7
            },
            {
                "code": "us-tx-181",
                "name": "Grayson County, TX",
                "value": 3.5
            },
            {
                "code": "us-tx-183",
                "name": "Gregg County, TX",
                "value": 4.7
            },
            {
                "code": "us-tx-185",
                "name": "Grimes County, TX",
                "value": 4.8
            },
            {
                "code": "us-tx-187",
                "name": "Guadalupe County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-189",
                "name": "Hale County, TX",
                "value": 4.6
            },
            {
                "code": "us-tx-191",
                "name": "Hall County, TX",
                "value": 5
            },
            {
                "code": "us-tx-193",
                "name": "Hamilton County, TX",
                "value": 3.9
            },
            {
                "code": "us-tx-195",
                "name": "Hansford County, TX",
                "value": 2.7
            },
            {
                "code": "us-tx-197",
                "name": "Hardeman County, TX",
                "value": 4.2
            },
            {
                "code": "us-tx-199",
                "name": "Hardin County, TX",
                "value": 6.2
            },
            {
                "code": "us-tx-201",
                "name": "Harris County, TX",
                "value": 5
            },
            {
                "code": "us-tx-203",
                "name": "Harrison County, TX",
                "value": 4.8
            },
            {
                "code": "us-tx-205",
                "name": "Hartley County, TX",
                "value": 2
            },
            {
                "code": "us-tx-207",
                "name": "Haskell County, TX",
                "value": 4.3
            },
            {
                "code": "us-tx-209",
                "name": "Hays County, TX",
                "value": 3.1
            },
            {
                "code": "us-tx-211",
                "name": "Hemphill County, TX",
                "value": 2.2
            },
            {
                "code": "us-tx-213",
                "name": "Henderson County, TX",
                "value": 4
            },
            {
                "code": "us-tx-215",
                "name": "Hidalgo County, TX",
                "value": 7.7
            },
            {
                "code": "us-tx-217",
                "name": "Hill County, TX",
                "value": 3.9
            },
            {
                "code": "us-tx-219",
                "name": "Hockley County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-221",
                "name": "Hood County, TX",
                "value": 4.1
            },
            {
                "code": "us-tx-223",
                "name": "Hopkins County, TX",
                "value": 3.5
            },
            {
                "code": "us-tx-225",
                "name": "Houston County, TX",
                "value": 4.7
            },
            {
                "code": "us-tx-227",
                "name": "Howard County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-229",
                "name": "Hudspeth County, TX",
                "value": 5.1
            },
            {
                "code": "us-tx-231",
                "name": "Hunt County, TX",
                "value": 3.9
            },
            {
                "code": "us-tx-233",
                "name": "Hutchinson County, TX",
                "value": 5.8
            },
            {
                "code": "us-tx-235",
                "name": "Irion County, TX",
                "value": 3.2
            },
            {
                "code": "us-tx-237",
                "name": "Jack County, TX",
                "value": 2.9
            },
            {
                "code": "us-tx-239",
                "name": "Jackson County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-241",
                "name": "Jasper County, TX",
                "value": 7.8
            },
            {
                "code": "us-tx-243",
                "name": "Jeff Davis County, TX",
                "value": 2.9
            },
            {
                "code": "us-tx-245",
                "name": "Jefferson County, TX",
                "value": 7.8
            },
            {
                "code": "us-tx-247",
                "name": "Jim Hogg County, TX",
                "value": 6.4
            },
            {
                "code": "us-tx-249",
                "name": "Jim Wells County, TX",
                "value": 6.5
            },
            {
                "code": "us-tx-251",
                "name": "Johnson County, TX",
                "value": 3.7
            },
            {
                "code": "us-tx-253",
                "name": "Jones County, TX",
                "value": 5.4
            },
            {
                "code": "us-tx-255",
                "name": "Karnes County, TX",
                "value": 2.9
            },
            {
                "code": "us-tx-257",
                "name": "Kaufman County, TX",
                "value": 3.5
            },
            {
                "code": "us-tx-259",
                "name": "Kendall County, TX",
                "value": 3
            },
            {
                "code": "us-tx-261",
                "name": "Kenedy County, TX",
                "value": 3.2
            },
            {
                "code": "us-tx-263",
                "name": "Kent County, TX",
                "value": 2.8
            },
            {
                "code": "us-tx-265",
                "name": "Kerr County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-267",
                "name": "Kimble County, TX",
                "value": 3.2
            },
            {
                "code": "us-tx-269",
                "name": "King County, TX",
                "value": 3
            },
            {
                "code": "us-tx-271",
                "name": "Kinney County, TX",
                "value": 5.8
            },
            {
                "code": "us-tx-273",
                "name": "Kleberg County, TX",
                "value": 5.5
            },
            {
                "code": "us-tx-275",
                "name": "Knox County, TX",
                "value": 3.9
            },
            {
                "code": "us-tx-277",
                "name": "Lamar County, TX",
                "value": 4.4
            },
            {
                "code": "us-tx-279",
                "name": "Lamb County, TX",
                "value": 4.5
            },
            {
                "code": "us-tx-281",
                "name": "Lampasas County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-283",
                "name": "La Salle County, TX",
                "value": 3.1
            },
            {
                "code": "us-tx-285",
                "name": "Lavaca County, TX",
                "value": 3.5
            },
            {
                "code": "us-tx-287",
                "name": "Lee County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-289",
                "name": "Leon County, TX",
                "value": 6
            },
            {
                "code": "us-tx-291",
                "name": "Liberty County, TX",
                "value": 7
            },
            {
                "code": "us-tx-293",
                "name": "Limestone County, TX",
                "value": 5.3
            },
            {
                "code": "us-tx-295",
                "name": "Lipscomb County, TX",
                "value": 3
            },
            {
                "code": "us-tx-297",
                "name": "Live Oak County, TX",
                "value": 4.5
            },
            {
                "code": "us-tx-299",
                "name": "Llano County, TX",
                "value": 3.9
            },
            {
                "code": "us-tx-301",
                "name": "Loving County, TX",
                "value": 4.1
            },
            {
                "code": "us-tx-303",
                "name": "Lubbock County, TX",
                "value": 3.1
            },
            {
                "code": "us-tx-305",
                "name": "Lynn County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-307",
                "name": "McCulloch County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-309",
                "name": "McLennan County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-311",
                "name": "McMullen County, TX",
                "value": 1.7
            },
            {
                "code": "us-tx-313",
                "name": "Madison County, TX",
                "value": 4.6
            },
            {
                "code": "us-tx-315",
                "name": "Marion County, TX",
                "value": 5.1
            },
            {
                "code": "us-tx-317",
                "name": "Martin County, TX",
                "value": 2.4
            },
            {
                "code": "us-tx-319",
                "name": "Mason County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-321",
                "name": "Matagorda County, TX",
                "value": 7.6
            },
            {
                "code": "us-tx-323",
                "name": "Maverick County, TX",
                "value": 9.7
            },
            {
                "code": "us-tx-325",
                "name": "Medina County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-327",
                "name": "Menard County, TX",
                "value": 4.4
            },
            {
                "code": "us-tx-329",
                "name": "Midland County, TX",
                "value": 2.4
            },
            {
                "code": "us-tx-331",
                "name": "Milam County, TX",
                "value": 5.3
            },
            {
                "code": "us-tx-333",
                "name": "Mills County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-335",
                "name": "Mitchell County, TX",
                "value": 5.5
            },
            {
                "code": "us-tx-337",
                "name": "Montague County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-339",
                "name": "Montgomery County, TX",
                "value": 4.2
            },
            {
                "code": "us-tx-341",
                "name": "Moore County, TX",
                "value": 3
            },
            {
                "code": "us-tx-343",
                "name": "Morris County, TX",
                "value": 7.3
            },
            {
                "code": "us-tx-345",
                "name": "Motley County, TX",
                "value": 4.2
            },
            {
                "code": "us-tx-347",
                "name": "Nacogdoches County, TX",
                "value": 4.2
            },
            {
                "code": "us-tx-349",
                "name": "Navarro County, TX",
                "value": 4.2
            },
            {
                "code": "us-tx-351",
                "name": "Newton County, TX",
                "value": 8.5
            },
            {
                "code": "us-tx-353",
                "name": "Nolan County, TX",
                "value": 3.7
            },
            {
                "code": "us-tx-355",
                "name": "Nueces County, TX",
                "value": 5.4
            },
            {
                "code": "us-tx-357",
                "name": "Ochiltree County, TX",
                "value": 3.2
            },
            {
                "code": "us-tx-359",
                "name": "Oldham County, TX",
                "value": 2.5
            },
            {
                "code": "us-tx-361",
                "name": "Orange County, TX",
                "value": 7.2
            },
            {
                "code": "us-tx-363",
                "name": "Palo Pinto County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-365",
                "name": "Panola County, TX",
                "value": 4.9
            },
            {
                "code": "us-tx-367",
                "name": "Parker County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-369",
                "name": "Parmer County, TX",
                "value": 2.5
            },
            {
                "code": "us-tx-371",
                "name": "Pecos County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-373",
                "name": "Polk County, TX",
                "value": 6.1
            },
            {
                "code": "us-tx-375",
                "name": "Potter County, TX",
                "value": 3.1
            },
            {
                "code": "us-tx-377",
                "name": "Presidio County, TX",
                "value": 8.9
            },
            {
                "code": "us-tx-379",
                "name": "Rains County, TX",
                "value": 3.7
            },
            {
                "code": "us-tx-381",
                "name": "Randall County, TX",
                "value": 2.7
            },
            {
                "code": "us-tx-383",
                "name": "Reagan County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-385",
                "name": "Real County, TX",
                "value": 5.6
            },
            {
                "code": "us-tx-387",
                "name": "Red River County, TX",
                "value": 5.5
            },
            {
                "code": "us-tx-389",
                "name": "Reeves County, TX",
                "value": 2.6
            },
            {
                "code": "us-tx-391",
                "name": "Refugio County, TX",
                "value": 5.9
            },
            {
                "code": "us-tx-393",
                "name": "Roberts County, TX",
                "value": 2.8
            },
            {
                "code": "us-tx-395",
                "name": "Robertson County, TX",
                "value": 4.7
            },
            {
                "code": "us-tx-397",
                "name": "Rockwall County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-399",
                "name": "Runnels County, TX",
                "value": 3.5
            },
            {
                "code": "us-tx-401",
                "name": "Rusk County, TX",
                "value": 4.8
            },
            {
                "code": "us-tx-403",
                "name": "Sabine County, TX",
                "value": 9.6
            },
            {
                "code": "us-tx-405",
                "name": "San Augustine County, TX",
                "value": 7.9
            },
            {
                "code": "us-tx-407",
                "name": "San Jacinto County, TX",
                "value": 5.9
            },
            {
                "code": "us-tx-409",
                "name": "San Patricio County, TX",
                "value": 8
            },
            {
                "code": "us-tx-411",
                "name": "San Saba County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-413",
                "name": "Schleicher County, TX",
                "value": 2.9
            },
            {
                "code": "us-tx-415",
                "name": "Scurry County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-417",
                "name": "Shackelford County, TX",
                "value": 2.6
            },
            {
                "code": "us-tx-419",
                "name": "Shelby County, TX",
                "value": 5
            },
            {
                "code": "us-tx-421",
                "name": "Sherman County, TX",
                "value": 3
            },
            {
                "code": "us-tx-423",
                "name": "Smith County, TX",
                "value": 4
            },
            {
                "code": "us-tx-425",
                "name": "Somervell County, TX",
                "value": 4.8
            },
            {
                "code": "us-tx-427",
                "name": "Starr County, TX",
                "value": 12.5
            },
            {
                "code": "us-tx-429",
                "name": "Stephens County, TX",
                "value": 4.3
            },
            {
                "code": "us-tx-431",
                "name": "Sterling County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-433",
                "name": "Stonewall County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-435",
                "name": "Sutton County, TX",
                "value": 4.6
            },
            {
                "code": "us-tx-437",
                "name": "Swisher County, TX",
                "value": 4.1
            },
            {
                "code": "us-tx-439",
                "name": "Tarrant County, TX",
                "value": 3.7
            },
            {
                "code": "us-tx-441",
                "name": "Taylor County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-443",
                "name": "Terrell County, TX",
                "value": 3.5
            },
            {
                "code": "us-tx-445",
                "name": "Terry County, TX",
                "value": 5
            },
            {
                "code": "us-tx-447",
                "name": "Throckmorton County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-449",
                "name": "Titus County, TX",
                "value": 5.1
            },
            {
                "code": "us-tx-451",
                "name": "Tom Green County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-453",
                "name": "Travis County, TX",
                "value": 3
            },
            {
                "code": "us-tx-455",
                "name": "Trinity County, TX",
                "value": 5.7
            },
            {
                "code": "us-tx-457",
                "name": "Tyler County, TX",
                "value": 7.9
            },
            {
                "code": "us-tx-459",
                "name": "Upshur County, TX",
                "value": 4.7
            },
            {
                "code": "us-tx-461",
                "name": "Upton County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-463",
                "name": "Uvalde County, TX",
                "value": 4.6
            },
            {
                "code": "us-tx-465",
                "name": "Val Verde County, TX",
                "value": 4.8
            },
            {
                "code": "us-tx-467",
                "name": "Van Zandt County, TX",
                "value": 3.8
            },
            {
                "code": "us-tx-469",
                "name": "Victoria County, TX",
                "value": 4.4
            },
            {
                "code": "us-tx-471",
                "name": "Walker County, TX",
                "value": 4.6
            },
            {
                "code": "us-tx-473",
                "name": "Waller County, TX",
                "value": 4.6
            },
            {
                "code": "us-tx-475",
                "name": "Ward County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-477",
                "name": "Washington County, TX",
                "value": 4
            },
            {
                "code": "us-tx-479",
                "name": "Webb County, TX",
                "value": 4
            },
            {
                "code": "us-tx-481",
                "name": "Wharton County, TX",
                "value": 4.4
            },
            {
                "code": "us-tx-483",
                "name": "Wheeler County, TX",
                "value": 3.7
            },
            {
                "code": "us-tx-485",
                "name": "Wichita County, TX",
                "value": 3.6
            },
            {
                "code": "us-tx-487",
                "name": "Wilbarger County, TX",
                "value": 4.9
            },
            {
                "code": "us-tx-489",
                "name": "Willacy County, TX",
                "value": 10.8
            },
            {
                "code": "us-tx-491",
                "name": "Williamson County, TX",
                "value": 3.2
            },
            {
                "code": "us-tx-493",
                "name": "Wilson County, TX",
                "value": 3.3
            },
            {
                "code": "us-tx-495",
                "name": "Winkler County, TX",
                "value": 3.4
            },
            {
                "code": "us-tx-497",
                "name": "Wise County, TX",
                "value": 3.7
            },
            {
                "code": "us-tx-499",
                "name": "Wood County, TX",
                "value": 4.5
            },
            {
                "code": "us-tx-501",
                "name": "Yoakum County, TX",
                "value": 3.2
            },
            {
                "code": "us-tx-503",
                "name": "Young County, TX",
                "value": 3.7
            },
            {
                "code": "us-tx-505",
                "name": "Zapata County, TX",
                "value": 7
            },
            {
                "code": "us-tx-507",
                "name": "Zavala County, TX",
                "value": 10
            },
            {
                "code": "us-ut-001",
                "name": "Beaver County, UT",
                "value": 3.8
            },
            {
                "code": "us-ut-003",
                "name": "Box Elder County, UT",
                "value": 3.3
            },
            {
                "code": "us-ut-005",
                "name": "Cache County, UT",
                "value": 2.7
            },
            {
                "code": "us-ut-007",
                "name": "Carbon County, UT",
                "value": 4.8
            },
            {
                "code": "us-ut-009",
                "name": "Daggett County, UT",
                "value": 6.4
            },
            {
                "code": "us-ut-011",
                "name": "Davis County, UT",
                "value": 3
            },
            {
                "code": "us-ut-013",
                "name": "Duchesne County, UT",
                "value": 5.5
            },
            {
                "code": "us-ut-015",
                "name": "Emery County, UT",
                "value": 6.2
            },
            {
                "code": "us-ut-017",
                "name": "Garfield County, UT",
                "value": 18.6
            },
            {
                "code": "us-ut-019",
                "name": "Grand County, UT",
                "value": 13.3
            },
            {
                "code": "us-ut-021",
                "name": "Iron County, UT",
                "value": 3.8
            },
            {
                "code": "us-ut-023",
                "name": "Juab County, UT",
                "value": 3.8
            },
            {
                "code": "us-ut-025",
                "name": "Kane County, UT",
                "value": 5
            },
            {
                "code": "us-ut-027",
                "name": "Millard County, UT",
                "value": 3.5
            },
            {
                "code": "us-ut-029",
                "name": "Morgan County, UT",
                "value": 2.8
            },
            {
                "code": "us-ut-031",
                "name": "Piute County, UT",
                "value": 5.8
            },
            {
                "code": "us-ut-033",
                "name": "Rich County, UT",
                "value": 5.4
            },
            {
                "code": "us-ut-035",
                "name": "Salt Lake County, UT",
                "value": 3.1
            },
            {
                "code": "us-ut-037",
                "name": "San Juan County, UT",
                "value": 9.3
            },
            {
                "code": "us-ut-039",
                "name": "Sanpete County, UT",
                "value": 3.9
            },
            {
                "code": "us-ut-041",
                "name": "Sevier County, UT",
                "value": 4.5
            },
            {
                "code": "us-ut-043",
                "name": "Summit County, UT",
                "value": 2.4
            },
            {
                "code": "us-ut-045",
                "name": "Tooele County, UT",
                "value": 3.6
            },
            {
                "code": "us-ut-047",
                "name": "Uintah County, UT",
                "value": 5.4
            },
            {
                "code": "us-ut-049",
                "name": "Utah County, UT",
                "value": 2.8
            },
            {
                "code": "us-ut-051",
                "name": "Wasatch County, UT",
                "value": 3
            },
            {
                "code": "us-ut-053",
                "name": "Washington County, UT",
                "value": 3.6
            },
            {
                "code": "us-ut-055",
                "name": "Wayne County, UT",
                "value": 12.4
            },
            {
                "code": "us-ut-057",
                "name": "Weber County, UT",
                "value": 4
            },
            {
                "code": "us-vt-001",
                "name": "Addison County, VT",
                "value": 3.4
            },
            {
                "code": "us-vt-003",
                "name": "Bennington County, VT",
                "value": 3.6
            },
            {
                "code": "us-vt-005",
                "name": "Caledonia County, VT",
                "value": 4.6
            },
            {
                "code": "us-vt-007",
                "name": "Chittenden County, VT",
                "value": 2.3
            },
            {
                "code": "us-vt-009",
                "name": "Essex County, VT",
                "value": 5.8
            },
            {
                "code": "us-vt-011",
                "name": "Franklin County, VT",
                "value": 3.2
            },
            {
                "code": "us-vt-013",
                "name": "Grand Isle County, VT",
                "value": 3.9
            },
            {
                "code": "us-vt-015",
                "name": "Lamoille County, VT",
                "value": 4.7
            },
            {
                "code": "us-vt-017",
                "name": "Orange County, VT",
                "value": 4.2
            },
            {
                "code": "us-vt-019",
                "name": "Orleans County, VT",
                "value": 6.3
            },
            {
                "code": "us-vt-021",
                "name": "Rutland County, VT",
                "value": 3.6
            },
            {
                "code": "us-vt-023",
                "name": "Washington County, VT",
                "value": 3.8
            },
            {
                "code": "us-vt-025",
                "name": "Windham County, VT",
                "value": 2.9
            },
            {
                "code": "us-vt-027",
                "name": "Windsor County, VT",
                "value": 2.5
            },
            {
                "code": "us-va-001",
                "name": "Accomack County, VA",
                "value": 5.2
            },
            {
                "code": "us-va-003",
                "name": "Albemarle County, VA",
                "value": 3.2
            },
            {
                "code": "us-va-005",
                "name": "Alleghany County, VA",
                "value": 5
            },
            {
                "code": "us-va-007",
                "name": "Amelia County, VA",
                "value": 3.8
            },
            {
                "code": "us-va-009",
                "name": "Amherst County, VA",
                "value": 4.1
            },
            {
                "code": "us-va-011",
                "name": "Appomattox County, VA",
                "value": 4.6
            },
            {
                "code": "us-va-013",
                "name": "Arlington County, VA",
                "value": 2.3
            },
            {
                "code": "us-va-015",
                "name": "Augusta County, VA",
                "value": 3.4
            },
            {
                "code": "us-va-017",
                "name": "Bath County, VA",
                "value": 3.4
            },
            {
                "code": "us-va-019",
                "name": "Bedford County, VA",
                "value": 3.8
            },
            {
                "code": "us-va-021",
                "name": "Bland County, VA",
                "value": 3.7
            },
            {
                "code": "us-va-023",
                "name": "Botetourt County, VA",
                "value": 3.3
            },
            {
                "code": "us-va-025",
                "name": "Brunswick County, VA",
                "value": 5.8
            },
            {
                "code": "us-va-027",
                "name": "Buchanan County, VA",
                "value": 6.3
            },
            {
                "code": "us-va-029",
                "name": "Buckingham County, VA",
                "value": 5.6
            },
            {
                "code": "us-va-031",
                "name": "Campbell County, VA",
                "value": 4.3
            },
            {
                "code": "us-va-033",
                "name": "Caroline County, VA",
                "value": 4.4
            },
            {
                "code": "us-va-035",
                "name": "Carroll County, VA",
                "value": 4.4
            },
            {
                "code": "us-va-036",
                "name": "Charles City County, VA",
                "value": 5.1
            },
            {
                "code": "us-va-037",
                "name": "Charlotte County, VA",
                "value": 4.5
            },
            {
                "code": "us-va-041",
                "name": "Chesterfield County, VA",
                "value": 3.4
            },
            {
                "code": "us-va-043",
                "name": "Clarke County, VA",
                "value": 3.3
            },
            {
                "code": "us-va-045",
                "name": "Craig County, VA",
                "value": 4.2
            },
            {
                "code": "us-va-047",
                "name": "Culpeper County, VA",
                "value": 3.6
            },
            {
                "code": "us-va-049",
                "name": "Cumberland County, VA",
                "value": 4.4
            },
            {
                "code": "us-va-051",
                "name": "Dickenson County, VA",
                "value": 6.6
            },
            {
                "code": "us-va-053",
                "name": "Dinwiddie County, VA",
                "value": 4.2
            },
            {
                "code": "us-va-057",
                "name": "Essex County, VA",
                "value": 4.9
            },
            {
                "code": "us-va-059",
                "name": "Fairfax County, VA",
                "value": 2.9
            },
            {
                "code": "us-va-061",
                "name": "Fauquier County, VA",
                "value": 3.1
            },
            {
                "code": "us-va-063",
                "name": "Floyd County, VA",
                "value": 3.6
            },
            {
                "code": "us-va-065",
                "name": "Fluvanna County, VA",
                "value": 3
            },
            {
                "code": "us-va-067",
                "name": "Franklin County, VA",
                "value": 3.7
            },
            {
                "code": "us-va-069",
                "name": "Frederick County, VA",
                "value": 3.1
            },
            {
                "code": "us-va-071",
                "name": "Giles County, VA",
                "value": 4.2
            },
            {
                "code": "us-va-073",
                "name": "Gloucester County, VA",
                "value": 3.3
            },
            {
                "code": "us-va-075",
                "name": "Goochland County, VA",
                "value": 3.5
            },
            {
                "code": "us-va-077",
                "name": "Grayson County, VA",
                "value": 4.1
            },
            {
                "code": "us-va-079",
                "name": "Greene County, VA",
                "value": 3
            },
            {
                "code": "us-va-081",
                "name": "Greensville County, VA",
                "value": 4.6
            },
            {
                "code": "us-va-083",
                "name": "Halifax County, VA",
                "value": 4.9
            },
            {
                "code": "us-va-085",
                "name": "Hanover County, VA",
                "value": 3.1
            },
            {
                "code": "us-va-087",
                "name": "Henrico County, VA",
                "value": 3.5
            },
            {
                "code": "us-va-089",
                "name": "Henry County, VA",
                "value": 4.7
            },
            {
                "code": "us-va-091",
                "name": "Highland County, VA",
                "value": 3.7
            },
            {
                "code": "us-va-093",
                "name": "Isle of Wight County, VA",
                "value": 3.6
            },
            {
                "code": "us-va-095",
                "name": "James City County, VA",
                "value": 3.6
            },
            {
                "code": "us-va-097",
                "name": "King and Queen County, VA",
                "value": 3.7
            },
            {
                "code": "us-va-099",
                "name": "King George County, VA",
                "value": 3.7
            },
            {
                "code": "us-va-101",
                "name": "King William County, VA",
                "value": 3.4
            },
            {
                "code": "us-va-103",
                "name": "Lancaster County, VA",
                "value": 7.2
            },
            {
                "code": "us-va-105",
                "name": "Lee County, VA",
                "value": 4.9
            },
            {
                "code": "us-va-107",
                "name": "Loudoun County, VA",
                "value": 2.8
            },
            {
                "code": "us-va-109",
                "name": "Louisa County, VA",
                "value": 3.3
            },
            {
                "code": "us-va-111",
                "name": "Lunenburg County, VA",
                "value": 4.3
            },
            {
                "code": "us-va-113",
                "name": "Madison County, VA",
                "value": 3
            },
            {
                "code": "us-va-115",
                "name": "Mathews County, VA",
                "value": 3.5
            },
            {
                "code": "us-va-117",
                "name": "Mecklenburg County, VA",
                "value": 5.2
            },
            {
                "code": "us-va-119",
                "name": "Middlesex County, VA",
                "value": 3.5
            },
            {
                "code": "us-va-121",
                "name": "Montgomery County, VA",
                "value": 3.5
            },
            {
                "code": "us-va-125",
                "name": "Nelson County, VA",
                "value": 3.7
            },
            {
                "code": "us-va-127",
                "name": "New Kent County, VA",
                "value": 3.1
            },
            {
                "code": "us-va-131",
                "name": "Northampton County, VA",
                "value": 7.7
            },
            {
                "code": "us-va-133",
                "name": "Northumberland County, VA",
                "value": 7.5
            },
            {
                "code": "us-va-135",
                "name": "Nottoway County, VA",
                "value": 3.8
            },
            {
                "code": "us-va-137",
                "name": "Orange County, VA",
                "value": 3.6
            },
            {
                "code": "us-va-139",
                "name": "Page County, VA",
                "value": 6.5
            },
            {
                "code": "us-va-141",
                "name": "Patrick County, VA",
                "value": 5.5
            },
            {
                "code": "us-va-143",
                "name": "Pittsylvania County, VA",
                "value": 4.2
            },
            {
                "code": "us-va-145",
                "name": "Powhatan County, VA",
                "value": 3.2
            },
            {
                "code": "us-va-147",
                "name": "Prince Edward County, VA",
                "value": 4.9
            },
            {
                "code": "us-va-149",
                "name": "Prince George County, VA",
                "value": 4.2
            },
            {
                "code": "us-va-153",
                "name": "Prince William County, VA",
                "value": 3.3
            },
            {
                "code": "us-va-155",
                "name": "Pulaski County, VA",
                "value": 4.5
            },
            {
                "code": "us-va-157",
                "name": "Rappahannock County, VA",
                "value": 3.2
            },
            {
                "code": "us-va-159",
                "name": "Richmond County, VA",
                "value": 4.1
            },
            {
                "code": "us-va-161",
                "name": "Roanoke County, VA",
                "value": 3.2
            },
            {
                "code": "us-va-163",
                "name": "Rockbridge County, VA",
                "value": 4.1
            },
            {
                "code": "us-va-165",
                "name": "Rockingham County, VA",
                "value": 3.1
            },
            {
                "code": "us-va-167",
                "name": "Russell County, VA",
                "value": 5.2
            },
            {
                "code": "us-va-169",
                "name": "Scott County, VA",
                "value": 4
            },
            {
                "code": "us-va-171",
                "name": "Shenandoah County, VA",
                "value": 3.3
            },
            {
                "code": "us-va-173",
                "name": "Smyth County, VA",
                "value": 4.5
            },
            {
                "code": "us-va-175",
                "name": "Southampton County, VA",
                "value": 3.5
            },
            {
                "code": "us-va-177",
                "name": "Spotsylvania County, VA",
                "value": 3.7
            },
            {
                "code": "us-va-179",
                "name": "Stafford County, VA",
                "value": 3.5
            },
            {
                "code": "us-va-181",
                "name": "Surry County, VA",
                "value": 4.5
            },
            {
                "code": "us-va-183",
                "name": "Sussex County, VA",
                "value": 6
            },
            {
                "code": "us-va-185",
                "name": "Tazewell County, VA",
                "value": 5.4
            },
            {
                "code": "us-va-187",
                "name": "Warren County, VA",
                "value": 3.7
            },
            {
                "code": "us-va-191",
                "name": "Washington County, VA",
                "value": 4.1
            },
            {
                "code": "us-va-193",
                "name": "Westmoreland County, VA",
                "value": 5
            },
            {
                "code": "us-va-195",
                "name": "Wise County, VA",
                "value": 6
            },
            {
                "code": "us-va-197",
                "name": "Wythe County, VA",
                "value": 4.6
            },
            {
                "code": "us-va-199",
                "name": "York County, VA",
                "value": 3.4
            },
            {
                "code": "us-va-510",
                "name": "Alexandria city, VA",
                "value": 2.7
            },
            {
                "code": "us-va-520",
                "name": "Bristol city, VA",
                "value": 4.1
            },
            {
                "code": "us-va-530",
                "name": "Buena Vista city, VA",
                "value": 3.8
            },
            {
                "code": "us-va-540",
                "name": "Charlottesville city, VA",
                "value": 3.2
            },
            {
                "code": "us-va-550",
                "name": "Chesapeake city, VA",
                "value": 3.5
            },
            {
                "code": "us-va-570",
                "name": "Colonial Heights city, VA",
                "value": 3.8
            },
            {
                "code": "us-va-580",
                "name": "Covington city, VA",
                "value": 6.8
            },
            {
                "code": "us-va-590",
                "name": "Danville city, VA",
                "value": 5.4
            },
            {
                "code": "us-va-595",
                "name": "Emporia city, VA",
                "value": 5.5
            },
            {
                "code": "us-va-600",
                "name": "Fairfax city, VA",
                "value": 2.7
            },
            {
                "code": "us-va-610",
                "name": "Falls Church city, VA",
                "value": 2.5
            },
            {
                "code": "us-va-620",
                "name": "Franklin city, VA",
                "value": 5
            },
            {
                "code": "us-va-630",
                "name": "Fredericksburg city, VA",
                "value": 4.2
            },
            {
                "code": "us-va-640",
                "name": "Galax city, VA",
                "value": 3.7
            },
            {
                "code": "us-va-650",
                "name": "Hampton city, VA",
                "value": 4.8
            },
            {
                "code": "us-va-660",
                "name": "Harrisonburg city, VA",
                "value": 3.9
            },
            {
                "code": "us-va-670",
                "name": "Hopewell city, VA",
                "value": 5.7
            },
            {
                "code": "us-va-678",
                "name": "Lexington city, VA",
                "value": 5.8
            },
            {
                "code": "us-va-680",
                "name": "Lynchburg city, VA",
                "value": 4.9
            },
            {
                "code": "us-va-683",
                "name": "Manassas city, VA",
                "value": 3.5
            },
            {
                "code": "us-va-685",
                "name": "Manassas Park city, VA",
                "value": 3.5
            },
            {
                "code": "us-va-690",
                "name": "Martinsville city, VA",
                "value": 5.9
            },
            {
                "code": "us-va-700",
                "name": "Newport News city, VA",
                "value": 4.4
            },
            {
                "code": "us-va-710",
                "name": "Norfolk city, VA",
                "value": 4.3
            },
            {
                "code": "us-va-720",
                "name": "Norton city, VA",
                "value": 4.4
            },
            {
                "code": "us-va-730",
                "name": "Petersburg city, VA",
                "value": 7.1
            },
            {
                "code": "us-va-735",
                "name": "Poquoson city, VA",
                "value": 3.3
            },
            {
                "code": "us-va-740",
                "name": "Portsmouth city, VA",
                "value": 4.9
            },
            {
                "code": "us-va-750",
                "name": "Radford city, VA",
                "value": 4.4
            },
            {
                "code": "us-va-760",
                "name": "Richmond city, VA",
                "value": 4.2
            },
            {
                "code": "us-va-770",
                "name": "Roanoke city, VA",
                "value": 3.9
            },
            {
                "code": "us-va-775",
                "name": "Salem city, VA",
                "value": 3.5
            },
            {
                "code": "us-va-790",
                "name": "Staunton city, VA",
                "value": 3.5
            },
            {
                "code": "us-va-800",
                "name": "Suffolk city, VA",
                "value": 3.8
            },
            {
                "code": "us-va-810",
                "name": "Virginia Beach city, VA",
                "value": 3.3
            },
            {
                "code": "us-va-820",
                "name": "Waynesboro city, VA",
                "value": 4.1
            },
            {
                "code": "us-va-830",
                "name": "Williamsburg city, VA",
                "value": 5
            },
            {
                "code": "us-va-840",
                "name": "Winchester city, VA",
                "value": 3.3
            },
            {
                "code": "us-wa-001",
                "name": "Adams County, WA",
                "value": 10
            },
            {
                "code": "us-wa-003",
                "name": "Asotin County, WA",
                "value": 5.4
            },
            {
                "code": "us-wa-005",
                "name": "Benton County, WA",
                "value": 6.9
            },
            {
                "code": "us-wa-007",
                "name": "Chelan County, WA",
                "value": 6.6
            },
            {
                "code": "us-wa-009",
                "name": "Clallam County, WA",
                "value": 8
            },
            {
                "code": "us-wa-011",
                "name": "Clark County, WA",
                "value": 5.5
            },
            {
                "code": "us-wa-013",
                "name": "Columbia County, WA",
                "value": 7
            },
            {
                "code": "us-wa-015",
                "name": "Cowlitz County, WA",
                "value": 7
            },
            {
                "code": "us-wa-017",
                "name": "Douglas County, WA",
                "value": 7.7
            },
            {
                "code": "us-wa-019",
                "name": "Ferry County, WA",
                "value": 16.1
            },
            {
                "code": "us-wa-021",
                "name": "Franklin County, WA",
                "value": 8.8
            },
            {
                "code": "us-wa-023",
                "name": "Garfield County, WA",
                "value": 7.9
            },
            {
                "code": "us-wa-025",
                "name": "Grant County, WA",
                "value": 9.4
            },
            {
                "code": "us-wa-027",
                "name": "Grays Harbor County, WA",
                "value": 8.2
            },
            {
                "code": "us-wa-029",
                "name": "Island County, WA",
                "value": 6.1
            },
            {
                "code": "us-wa-031",
                "name": "Jefferson County, WA",
                "value": 7.2
            },
            {
                "code": "us-wa-033",
                "name": "King County, WA",
                "value": 3.9
            },
            {
                "code": "us-wa-035",
                "name": "Kitsap County, WA",
                "value": 5.5
            },
            {
                "code": "us-wa-037",
                "name": "Kittitas County, WA",
                "value": 6.7
            },
            {
                "code": "us-wa-039",
                "name": "Klickitat County, WA",
                "value": 7.4
            },
            {
                "code": "us-wa-041",
                "name": "Lewis County, WA",
                "value": 7.5
            },
            {
                "code": "us-wa-043",
                "name": "Lincoln County, WA",
                "value": 6.3
            },
            {
                "code": "us-wa-045",
                "name": "Mason County, WA",
                "value": 7.4
            },
            {
                "code": "us-wa-047",
                "name": "Okanogan County, WA",
                "value": 9.5
            },
            {
                "code": "us-wa-049",
                "name": "Pacific County, WA",
                "value": 8.7
            },
            {
                "code": "us-wa-051",
                "name": "Pend Oreille County, WA",
                "value": 9.3
            },
            {
                "code": "us-wa-053",
                "name": "Pierce County, WA",
                "value": 6
            },
            {
                "code": "us-wa-055",
                "name": "San Juan County, WA",
                "value": 5.5
            },
            {
                "code": "us-wa-057",
                "name": "Skagit County, WA",
                "value": 6.3
            },
            {
                "code": "us-wa-059",
                "name": "Skamania County, WA",
                "value": 7.1
            },
            {
                "code": "us-wa-061",
                "name": "Snohomish County, WA",
                "value": 4.3
            },
            {
                "code": "us-wa-063",
                "name": "Spokane County, WA",
                "value": 6.5
            },
            {
                "code": "us-wa-065",
                "name": "Stevens County, WA",
                "value": 9.2
            },
            {
                "code": "us-wa-067",
                "name": "Thurston County, WA",
                "value": 5.6
            },
            {
                "code": "us-wa-069",
                "name": "Wahkiakum County, WA",
                "value": 7.7
            },
            {
                "code": "us-wa-071",
                "name": "Walla Walla County, WA",
                "value": 6.5
            },
            {
                "code": "us-wa-073",
                "name": "Whatcom County, WA",
                "value": 5.7
            },
            {
                "code": "us-wa-075",
                "name": "Whitman County, WA",
                "value": 4.8
            },
            {
                "code": "us-wa-077",
                "name": "Yakima County, WA",
                "value": 9.3
            },
            {
                "code": "us-wv-001",
                "name": "Barbour County, WV",
                "value": 7
            },
            {
                "code": "us-wv-003",
                "name": "Berkeley County, WV",
                "value": 4.2
            },
            {
                "code": "us-wv-005",
                "name": "Boone County, WV",
                "value": 6.7
            },
            {
                "code": "us-wv-007",
                "name": "Braxton County, WV",
                "value": 9.8
            },
            {
                "code": "us-wv-009",
                "name": "Brooke County, WV",
                "value": 7.3
            },
            {
                "code": "us-wv-011",
                "name": "Cabell County, WV",
                "value": 5.2
            },
            {
                "code": "us-wv-013",
                "name": "Calhoun County, WV",
                "value": 16.8
            },
            {
                "code": "us-wv-015",
                "name": "Clay County, WV",
                "value": 11.9
            },
            {
                "code": "us-wv-017",
                "name": "Doddridge County, WV",
                "value": 4.8
            },
            {
                "code": "us-wv-019",
                "name": "Fayette County, WV",
                "value": 7.6
            },
            {
                "code": "us-wv-021",
                "name": "Gilmer County, WV",
                "value": 8.7
            },
            {
                "code": "us-wv-023",
                "name": "Grant County, WV",
                "value": 7
            },
            {
                "code": "us-wv-025",
                "name": "Greenbrier County, WV",
                "value": 6.3
            },
            {
                "code": "us-wv-027",
                "name": "Hampshire County, WV",
                "value": 4.7
            },
            {
                "code": "us-wv-029",
                "name": "Hancock County, WV",
                "value": 7.4
            },
            {
                "code": "us-wv-031",
                "name": "Hardy County, WV",
                "value": 6.4
            },
            {
                "code": "us-wv-033",
                "name": "Harrison County, WV",
                "value": 5.4
            },
            {
                "code": "us-wv-035",
                "name": "Jackson County, WV",
                "value": 6.3
            },
            {
                "code": "us-wv-037",
                "name": "Jefferson County, WV",
                "value": 3.3
            },
            {
                "code": "us-wv-039",
                "name": "Kanawha County, WV",
                "value": 5.7
            },
            {
                "code": "us-wv-041",
                "name": "Lewis County, WV",
                "value": 7.5
            },
            {
                "code": "us-wv-043",
                "name": "Lincoln County, WV",
                "value": 8.5
            },
            {
                "code": "us-wv-045",
                "name": "Logan County, WV",
                "value": 7.8
            },
            {
                "code": "us-wv-047",
                "name": "McDowell County, WV",
                "value": 8.5
            },
            {
                "code": "us-wv-049",
                "name": "Marion County, WV",
                "value": 6.4
            },
            {
                "code": "us-wv-051",
                "name": "Marshall County, WV",
                "value": 7.8
            },
            {
                "code": "us-wv-053",
                "name": "Mason County, WV",
                "value": 9.2
            },
            {
                "code": "us-wv-055",
                "name": "Mercer County, WV",
                "value": 6.5
            },
            {
                "code": "us-wv-057",
                "name": "Mineral County, WV",
                "value": 6.5
            },
            {
                "code": "us-wv-059",
                "name": "Mingo County, WV",
                "value": 8.4
            },
            {
                "code": "us-wv-061",
                "name": "Monongalia County, WV",
                "value": 4.2
            },
            {
                "code": "us-wv-063",
                "name": "Monroe County, WV",
                "value": 5.7
            },
            {
                "code": "us-wv-065",
                "name": "Morgan County, WV",
                "value": 4.3
            },
            {
                "code": "us-wv-067",
                "name": "Nicholas County, WV",
                "value": 7.9
            },
            {
                "code": "us-wv-069",
                "name": "Ohio County, WV",
                "value": 5.5
            },
            {
                "code": "us-wv-071",
                "name": "Pendleton County, WV",
                "value": 4.6
            },
            {
                "code": "us-wv-073",
                "name": "Pleasants County, WV",
                "value": 8.8
            },
            {
                "code": "us-wv-075",
                "name": "Pocahontas County, WV",
                "value": 5.9
            },
            {
                "code": "us-wv-077",
                "name": "Preston County, WV",
                "value": 5.9
            },
            {
                "code": "us-wv-079",
                "name": "Putnam County, WV",
                "value": 5.5
            },
            {
                "code": "us-wv-081",
                "name": "Raleigh County, WV",
                "value": 5.9
            },
            {
                "code": "us-wv-083",
                "name": "Randolph County, WV",
                "value": 6.4
            },
            {
                "code": "us-wv-085",
                "name": "Ritchie County, WV",
                "value": 6.6
            },
            {
                "code": "us-wv-087",
                "name": "Roane County, WV",
                "value": 11.1
            },
            {
                "code": "us-wv-089",
                "name": "Summers County, WV",
                "value": 7.8
            },
            {
                "code": "us-wv-091",
                "name": "Taylor County, WV",
                "value": 6
            },
            {
                "code": "us-wv-093",
                "name": "Tucker County, WV",
                "value": 5.7
            },
            {
                "code": "us-wv-095",
                "name": "Tyler County, WV",
                "value": 9.8
            },
            {
                "code": "us-wv-097",
                "name": "Upshur County, WV",
                "value": 6.6
            },
            {
                "code": "us-wv-099",
                "name": "Wayne County, WV",
                "value": 6.9
            },
            {
                "code": "us-wv-101",
                "name": "Webster County, WV",
                "value": 7.5
            },
            {
                "code": "us-wv-103",
                "name": "Wetzel County, WV",
                "value": 10.5
            },
            {
                "code": "us-wv-105",
                "name": "Wirt County, WV",
                "value": 9.9
            },
            {
                "code": "us-wv-107",
                "name": "Wood County, WV",
                "value": 6.5
            },
            {
                "code": "us-wv-109",
                "name": "Wyoming County, WV",
                "value": 7.2
            },
            {
                "code": "us-wi-001",
                "name": "Adams County, WI",
                "value": 6.1
            },
            {
                "code": "us-wi-003",
                "name": "Ashland County, WI",
                "value": 4.5
            },
            {
                "code": "us-wi-005",
                "name": "Barron County, WI",
                "value": 4.2
            },
            {
                "code": "us-wi-007",
                "name": "Bayfield County, WI",
                "value": 5.9
            },
            {
                "code": "us-wi-009",
                "name": "Brown County, WI",
                "value": 3.1
            },
            {
                "code": "us-wi-011",
                "name": "Buffalo County, WI",
                "value": 4.4
            },
            {
                "code": "us-wi-013",
                "name": "Burnett County, WI",
                "value": 5.7
            },
            {
                "code": "us-wi-015",
                "name": "Calumet County, WI",
                "value": 2.9
            },
            {
                "code": "us-wi-017",
                "name": "Chippewa County, WI",
                "value": 4.3
            },
            {
                "code": "us-wi-019",
                "name": "Clark County, WI",
                "value": 3.5
            },
            {
                "code": "us-wi-021",
                "name": "Columbia County, WI",
                "value": 3.2
            },
            {
                "code": "us-wi-023",
                "name": "Crawford County, WI",
                "value": 4.8
            },
            {
                "code": "us-wi-025",
                "name": "Dane County, WI",
                "value": 2.4
            },
            {
                "code": "us-wi-027",
                "name": "Dodge County, WI",
                "value": 3.1
            },
            {
                "code": "us-wi-029",
                "name": "Door County, WI",
                "value": 5.1
            },
            {
                "code": "us-wi-031",
                "name": "Douglas County, WI",
                "value": 4.6
            },
            {
                "code": "us-wi-033",
                "name": "Dunn County, WI",
                "value": 3.6
            },
            {
                "code": "us-wi-035",
                "name": "Eau Claire County, WI",
                "value": 3
            },
            {
                "code": "us-wi-037",
                "name": "Florence County, WI",
                "value": 4.7
            },
            {
                "code": "us-wi-039",
                "name": "Fond du Lac County, WI",
                "value": 3
            },
            {
                "code": "us-wi-041",
                "name": "Forest County, WI",
                "value": 5.4
            },
            {
                "code": "us-wi-043",
                "name": "Grant County, WI",
                "value": 3.5
            },
            {
                "code": "us-wi-045",
                "name": "Green County, WI",
                "value": 3
            },
            {
                "code": "us-wi-047",
                "name": "Green Lake County, WI",
                "value": 3.9
            },
            {
                "code": "us-wi-049",
                "name": "Iowa County, WI",
                "value": 3.4
            },
            {
                "code": "us-wi-051",
                "name": "Iron County, WI",
                "value": 6.5
            },
            {
                "code": "us-wi-053",
                "name": "Jackson County, WI",
                "value": 3.7
            },
            {
                "code": "us-wi-055",
                "name": "Jefferson County, WI",
                "value": 3.4
            },
            {
                "code": "us-wi-057",
                "name": "Juneau County, WI",
                "value": 3.6
            },
            {
                "code": "us-wi-059",
                "name": "Kenosha County, WI",
                "value": 3.8
            },
            {
                "code": "us-wi-061",
                "name": "Kewaunee County, WI",
                "value": 3.5
            },
            {
                "code": "us-wi-063",
                "name": "La Crosse County, WI",
                "value": 3
            },
            {
                "code": "us-wi-065",
                "name": "Lafayette County, WI",
                "value": 2.7
            },
            {
                "code": "us-wi-067",
                "name": "Langlade County, WI",
                "value": 4.3
            },
            {
                "code": "us-wi-069",
                "name": "Lincoln County, WI",
                "value": 3.6
            },
            {
                "code": "us-wi-071",
                "name": "Manitowoc County, WI",
                "value": 3.8
            },
            {
                "code": "us-wi-073",
                "name": "Marathon County, WI",
                "value": 2.9
            },
            {
                "code": "us-wi-075",
                "name": "Marinette County, WI",
                "value": 4.6
            },
            {
                "code": "us-wi-077",
                "name": "Marquette County, WI",
                "value": 4.4
            },
            {
                "code": "us-wi-078",
                "name": "Menominee County, WI",
                "value": 4.9
            },
            {
                "code": "us-wi-079",
                "name": "Milwaukee County, WI",
                "value": 3.7
            },
            {
                "code": "us-wi-081",
                "name": "Monroe County, WI",
                "value": 3.3
            },
            {
                "code": "us-wi-083",
                "name": "Oconto County, WI",
                "value": 4
            },
            {
                "code": "us-wi-085",
                "name": "Oneida County, WI",
                "value": 4.5
            },
            {
                "code": "us-wi-087",
                "name": "Outagamie County, WI",
                "value": 3.1
            },
            {
                "code": "us-wi-089",
                "name": "Ozaukee County, WI",
                "value": 2.6
            },
            {
                "code": "us-wi-091",
                "name": "Pepin County, WI",
                "value": 4.7
            },
            {
                "code": "us-wi-093",
                "name": "Pierce County, WI",
                "value": 3.8
            },
            {
                "code": "us-wi-095",
                "name": "Polk County, WI",
                "value": 4.8
            },
            {
                "code": "us-wi-097",
                "name": "Portage County, WI",
                "value": 3.3
            },
            {
                "code": "us-wi-099",
                "name": "Price County, WI",
                "value": 3.9
            },
            {
                "code": "us-wi-101",
                "name": "Racine County, WI",
                "value": 4
            },
            {
                "code": "us-wi-103",
                "name": "Richland County, WI",
                "value": 3.4
            },
            {
                "code": "us-wi-105",
                "name": "Rock County, WI",
                "value": 3.6
            },
            {
                "code": "us-wi-107",
                "name": "Rusk County, WI",
                "value": 4.9
            },
            {
                "code": "us-wi-109",
                "name": "St. Croix County, WI",
                "value": 3.6
            },
            {
                "code": "us-wi-111",
                "name": "Sauk County, WI",
                "value": 3.1
            },
            {
                "code": "us-wi-113",
                "name": "Sawyer County, WI",
                "value": 5
            },
            {
                "code": "us-wi-115",
                "name": "Shawano County, WI",
                "value": 3.6
            },
            {
                "code": "us-wi-117",
                "name": "Sheboygan County, WI",
                "value": 2.7
            },
            {
                "code": "us-wi-119",
                "name": "Taylor County, WI",
                "value": 4.3
            },
            {
                "code": "us-wi-121",
                "name": "Trempealeau County, WI",
                "value": 3.4
            },
            {
                "code": "us-wi-123",
                "name": "Vernon County, WI",
                "value": 3.7
            },
            {
                "code": "us-wi-125",
                "name": "Vilas County, WI",
                "value": 4.7
            },
            {
                "code": "us-wi-127",
                "name": "Walworth County, WI",
                "value": 3.6
            },
            {
                "code": "us-wi-129",
                "name": "Washburn County, WI",
                "value": 4.7
            },
            {
                "code": "us-wi-131",
                "name": "Washington County, WI",
                "value": 2.8
            },
            {
                "code": "us-wi-133",
                "name": "Waukesha County, WI",
                "value": 2.8
            },
            {
                "code": "us-wi-135",
                "name": "Waupaca County, WI",
                "value": 3.4
            },
            {
                "code": "us-wi-137",
                "name": "Waushara County, WI",
                "value": 4.4
            },
            {
                "code": "us-wi-139",
                "name": "Winnebago County, WI",
                "value": 2.9
            },
            {
                "code": "us-wi-141",
                "name": "Wood County, WI",
                "value": 4
            },
            {
                "code": "us-wy-001",
                "name": "Albany County, WY",
                "value": 3.4
            },
            {
                "code": "us-wy-003",
                "name": "Big Horn County, WY",
                "value": 5.5
            },
            {
                "code": "us-wy-005",
                "name": "Campbell County, WY",
                "value": 4.9
            },
            {
                "code": "us-wy-007",
                "name": "Carbon County, WY",
                "value": 4.9
            },
            {
                "code": "us-wy-009",
                "name": "Converse County, WY",
                "value": 4.8
            },
            {
                "code": "us-wy-011",
                "name": "Crook County, WY",
                "value": 3.6
            },
            {
                "code": "us-wy-013",
                "name": "Fremont County, WY",
                "value": 6.6
            },
            {
                "code": "us-wy-015",
                "name": "Goshen County, WY",
                "value": 3.6
            },
            {
                "code": "us-wy-017",
                "name": "Hot Springs County, WY",
                "value": 4.3
            },
            {
                "code": "us-wy-019",
                "name": "Johnson County, WY",
                "value": 5.5
            },
            {
                "code": "us-wy-021",
                "name": "Laramie County, WY",
                "value": 4.5
            },
            {
                "code": "us-wy-023",
                "name": "Lincoln County, WY",
                "value": 4.7
            },
            {
                "code": "us-wy-025",
                "name": "Natrona County, WY",
                "value": 5.6
            },
            {
                "code": "us-wy-027",
                "name": "Niobrara County, WY",
                "value": 2.6
            },
            {
                "code": "us-wy-029",
                "name": "Park County, WY",
                "value": 5.9
            },
            {
                "code": "us-wy-031",
                "name": "Platte County, WY",
                "value": 4.7
            },
            {
                "code": "us-wy-033",
                "name": "Sheridan County, WY",
                "value": 5.3
            },
            {
                "code": "us-wy-035",
                "name": "Sublette County, WY",
                "value": 4.9
            },
            {
                "code": "us-wy-037",
                "name": "Sweetwater County, WY",
                "value": 4.9
            },
            {
                "code": "us-wy-039",
                "name": "Teton County, WY",
                "value": 2.7
            },
            {
                "code": "us-wy-041",
                "name": "Uinta County, WY",
                "value": 5
            },
            {
                "code": "us-wy-043",
                "name": "Washakie County, WY",
                "value": 4.7
            },
            {
                "code": "us-wy-045",
                "name": "Weston County, WY",
                "value": 4.2
            },
            {
                "code": "us-pr-001",
                "name": "Adjuntas Municipio, PR",
                "value": 17
            },
            {
                "code": "us-pr-003",
                "name": "Aguada Municipio, PR",
                "value": 13.2
            },
            {
                "code": "us-pr-005",
                "name": "Aguadilla Municipio, PR",
                "value": 14.5
            },
            {
                "code": "us-pr-007",
                "name": "Aguas Buenas Municipio, PR",
                "value": 11.4
            },
            {
                "code": "us-pr-009",
                "name": "Aibonito Municipio, PR",
                "value": 17.2
            },
            {
                "code": "us-pr-011",
                "name": "Anasco Municipio, PR",
                "value": 11.4
            },
            {
                "code": "us-pr-013",
                "name": "Arecibo Municipio, PR",
                "value": 12
            },
            {
                "code": "us-pr-015",
                "name": "Arroyo Municipio, PR",
                "value": 17.3
            },
            {
                "code": "us-pr-017",
                "name": "Barceloneta Municipio, PR",
                "value": 13
            },
            {
                "code": "us-pr-019",
                "name": "Barranquitas Municipio, PR",
                "value": 12.8
            },
            {
                "code": "us-pr-021",
                "name": "Bayamon Municipio, PR",
                "value": 7.5
            },
            {
                "code": "us-pr-023",
                "name": "Cabo Rojo Municipio, PR",
                "value": 12.8
            },
            {
                "code": "us-pr-025",
                "name": "Caguas Municipio, PR",
                "value": 9.1
            },
            {
                "code": "us-pr-027",
                "name": "Camuy Municipio, PR",
                "value": 11.8
            },
            {
                "code": "us-pr-029",
                "name": "Canovanas Municipio, PR",
                "value": 9.3
            },
            {
                "code": "us-pr-031",
                "name": "Carolina Municipio, PR",
                "value": 8
            },
            {
                "code": "us-pr-033",
                "name": "Catano Municipio, PR",
                "value": 9.1
            },
            {
                "code": "us-pr-035",
                "name": "Cayey Municipio, PR",
                "value": 9.2
            },
            {
                "code": "us-pr-037",
                "name": "Ceiba Municipio, PR",
                "value": 15.2
            },
            {
                "code": "us-pr-039",
                "name": "Ciales Municipio, PR",
                "value": 14.6
            },
            {
                "code": "us-pr-041",
                "name": "Cidra Municipio, PR",
                "value": 8.3
            },
            {
                "code": "us-pr-043",
                "name": "Coamo Municipio, PR",
                "value": 16.1
            },
            {
                "code": "us-pr-045",
                "name": "Comerio Municipio, PR",
                "value": 11.4
            },
            {
                "code": "us-pr-047",
                "name": "Corozal Municipio, PR",
                "value": 11.2
            },
            {
                "code": "us-pr-049",
                "name": "Culebra Municipio, PR",
                "value": 6.7
            },
            {
                "code": "us-pr-051",
                "name": "Dorado Municipio, PR",
                "value": 6.4
            },
            {
                "code": "us-pr-053",
                "name": "Fajardo Municipio, PR",
                "value": 16
            },
            {
                "code": "us-pr-054",
                "name": "Florida Municipio, PR",
                "value": 14
            },
            {
                "code": "us-pr-055",
                "name": "Guanica Municipio, PR",
                "value": 18.1
            },
            {
                "code": "us-pr-057",
                "name": "Guayama Municipio, PR",
                "value": 15.8
            },
            {
                "code": "us-pr-059",
                "name": "Guayanilla Municipio, PR",
                "value": 16.1
            },
            {
                "code": "us-pr-061",
                "name": "Guaynabo Municipio, PR",
                "value": 5
            },
            {
                "code": "us-pr-063",
                "name": "Gurabo Municipio, PR",
                "value": 7.5
            },
            {
                "code": "us-pr-065",
                "name": "Hatillo Municipio, PR",
                "value": 15.6
            },
            {
                "code": "us-pr-067",
                "name": "Hormigueros Municipio, PR",
                "value": 11.4
            },
            {
                "code": "us-pr-069",
                "name": "Humacao Municipio, PR",
                "value": 13.9
            },
            {
                "code": "us-pr-071",
                "name": "Isabela Municipio, PR",
                "value": 12.8
            },
            {
                "code": "us-pr-073",
                "name": "Jayuya Municipio, PR",
                "value": 13.3
            },
            {
                "code": "us-pr-075",
                "name": "Juana Diaz Municipio, PR",
                "value": 11.9
            },
            {
                "code": "us-pr-077",
                "name": "Juncos Municipio, PR",
                "value": 11.2
            },
            {
                "code": "us-pr-079",
                "name": "Lajas Municipio, PR",
                "value": 18.3
            },
            {
                "code": "us-pr-081",
                "name": "Lares Municipio, PR",
                "value": 19
            },
            {
                "code": "us-pr-083",
                "name": "Las Marias Municipio, PR",
                "value": 17.9
            },
            {
                "code": "us-pr-085",
                "name": "Las Piedras Municipio, PR",
                "value": 11.3
            },
            {
                "code": "us-pr-087",
                "name": "Loiza Municipio, PR",
                "value": 9.6
            },
            {
                "code": "us-pr-089",
                "name": "Luquillo Municipio, PR",
                "value": 15.2
            },
            {
                "code": "us-pr-091",
                "name": "Manati Municipio, PR",
                "value": 10
            },
            {
                "code": "us-pr-093",
                "name": "Maricao Municipio, PR",
                "value": 19.3
            },
            {
                "code": "us-pr-095",
                "name": "Maunabo Municipio, PR",
                "value": 18.3
            },
            {
                "code": "us-pr-097",
                "name": "Mayaguez Municipio, PR",
                "value": 12.6
            },
            {
                "code": "us-pr-099",
                "name": "Moca Municipio, PR",
                "value": 13.9
            },
            {
                "code": "us-pr-101",
                "name": "Morovis Municipio, PR",
                "value": 11.6
            },
            {
                "code": "us-pr-103",
                "name": "Naguabo Municipio, PR",
                "value": 12.3
            },
            {
                "code": "us-pr-105",
                "name": "Naranjito Municipio, PR",
                "value": 11.6
            },
            {
                "code": "us-pr-107",
                "name": "Orocovis Municipio, PR",
                "value": 15.4
            },
            {
                "code": "us-pr-109",
                "name": "Patillas Municipio, PR",
                "value": 22.6
            },
            {
                "code": "us-pr-111",
                "name": "Penuelas Municipio, PR",
                "value": 14.8
            },
            {
                "code": "us-pr-113",
                "name": "Ponce Municipio, PR",
                "value": 10.6
            },
            {
                "code": "us-pr-115",
                "name": "Quebradillas Municipio, PR",
                "value": 16.5
            },
            {
                "code": "us-pr-117",
                "name": "Rincon Municipio, PR",
                "value": 18.1
            },
            {
                "code": "us-pr-119",
                "name": "Rio Grande Municipio, PR",
                "value": 10.7
            },
            {
                "code": "us-pr-121",
                "name": "Sabana Grande Municipio, PR",
                "value": 16.1
            },
            {
                "code": "us-pr-123",
                "name": "Salinas Municipio, PR",
                "value": 16.1
            },
            {
                "code": "us-pr-125",
                "name": "San German Municipio, PR",
                "value": 14.4
            },
            {
                "code": "us-pr-127",
                "name": "San Juan Municipio, PR",
                "value": 7
            },
            {
                "code": "us-pr-129",
                "name": "San Lorenzo Municipio, PR",
                "value": 11.9
            },
            {
                "code": "us-pr-131",
                "name": "San Sebastian Municipio, PR",
                "value": 17.5
            },
            {
                "code": "us-pr-133",
                "name": "Santa Isabel Municipio, PR",
                "value": 12.7
            },
            {
                "code": "us-pr-135",
                "name": "Toa Alta Municipio, PR",
                "value": 7.4
            },
            {
                "code": "us-pr-137",
                "name": "Toa Baja Municipio, PR",
                "value": 7.9
            },
            {
                "code": "us-pr-139",
                "name": "Trujillo Alto Municipio, PR",
                "value": 5.6
            },
            {
                "code": "us-pr-141",
                "name": "Utuado Municipio, PR",
                "value": 13.8
            },
            {
                "code": "us-pr-143",
                "name": "Vega Alta Municipio, PR",
                "value": 10.1
            },
            {
                "code": "us-pr-145",
                "name": "Vega Baja Municipio, PR",
                "value": 12.2
            },
            {
                "code": "us-pr-147",
                "name": "Vieques Municipio, PR",
                "value": 24.5
            },
            {
                "code": "us-pr-149",
                "name": "Villalba Municipio, PR",
                "value": 20
            },
            {
                "code": "us-pr-151",
                "name": "Yabucoa Municipio, PR",
                "value": 17.6
            },
            {
                "code": "us-pr-153",
                "name": "Yauco Municipio, PR",
                "value": 17.3
            }
        ]




}